export namespace IUserMilestone {
  export type RetailerMilestoneType =
    | 'CHECKOUT_CART_FORCE_PAYMENT_ON_SHIPMENT'
    | 'CHECKOUT_MAKER_MARKET_FORCE_PAYMENT_ON_SHIPMENT'
    | 'CHECKOUT_OVERLIMIT'
    | 'CREDIT_LIMIT_CHART'
    | 'INSIDER_SEEN_IN_MENU_7_UNIQUE_DAYS'
    | 'INSIDER_SEEN_ON_DISTINCT_DAY'
    | 'INSIDER_PROMOTION_MODAL_DISMISSED'
    | 'INSIDER_PROMOTION_MODAL_NEVER_SHOW_AGAIN'
    | 'INSIDER_HOMEPAGE_BANNER_SEEN_ON_DISTINCT_DAY'
    | 'INSIDER_ALERT_BANNER_SEEN_ON_DISTINCT_DAY'
    | 'RETAILER_SCORE_WARNING_VISITED'
    | 'INSTALLMENT_BANNER_SEEN_TIMES'
    | 'PROACTIVE_CHAT_SEEN'
    | 'REORDER_INCREASED_TERMS_BANNER_SEEN_ON_DISTINCT_DAY'
    | 'REORDERED'
    | 'R2M_MARKETING_PAGE_SEEN'
    | 'ELEVATE_CREDIT_MODAL_SEEN'
    | 'SALES_REP_BANNER_DISMISSED'
    | 'PROACTIVE_CHAT_FOR_RETURNING_RETAILERS_SEEN'
    | 'INSIDER_V2_CHANGES_MODAL_SEEN'
    | 'NET90_PROMO_MODAL_SEEN'
    | 'STYLE_QUIZ_MODAL_SEEN'
    | 'NET90_HOLIDAY_BANNER_SEEN_ON_DISTINCT_DAY'
    | 'BRAND_REVIEW_TOOLTIP_SEEN'
    | 'UNLIMITED_REORDER_TERMS_BANNER_DISMISSED'
    | 'NET90_TERMINATING_PROMO_MODAL_SEEN'
    | 'SQUARE_POS_ORDER_SUCCESS_BANNER_DISMISSED'
    | 'PREORDER_INTRO_MODAL_SEEN'
    | 'GREAT_APP_MIGRATION_MODAL_DISMISS'
    | 'GREAT_APP_MIGRATION_BANNER_DISMISS'
    | 'SQUARE_2020_PROMO_PAGE_SEEN'
    | 'AMEX_PROMO_PAGE_SEEN'
    | 'RETAILER_COVID_LOANS_HELPER_MODAL_SEEN'
    | 'COVID_19_PROMO_MODAL_SEEN'
    | 'RETAILER_PORTAL_NAV_GUIDED_TOUR_SEEN'
    | 'RETAILER_PORTAL_PRODUCTS_PAGE_GUIDED_TOUR_SEEN'
    | 'RETAILER_PORTAL_ONBOARDING_COMPLETE'
    | 'RETAILER_PORTAL_ONBOARDING_STARTED'
    | 'COVID_CHECKOUT_SURVEY_DISMISSED'
    | 'RETAILER_HAS_SEEN_NEIGHBORHOOD_MODAL'
    | 'RETAILER_PORTAL_SEEN_PHONE_NUMBER_MODAL'
    | 'RETAILER_PORTAL_INVENTORY_TOOLTIP_SEEN'
    | 'RETAILER_PORTAL_HAS_SEEN_SHOPIFY_SYNC_BANNER'
    | 'RETAILER_PORTAL_BULK_UPLOAD_COMPLETE'
    | 'RETAILER_HAS_SEEN_SHOP_BOARDS_MODAL'
    | 'RETAILER_POST_SIGN_UP_MODAL_DISMISS'
    | 'RETAILER_INTEGRATION_EARLY_ACCESS_BANNER_DISMISS'
    | 'RETAILER_NO_COMISSION_BANNER_DISMISS'
    | 'RETAILER_PORTAL_SQUARE_SETUP_COMPLETE'
    | 'RETAILER_HAS_SEEN_REOPENING_TOOLTIP'
    | 'RETAILER_PORTAL_HAS_SEEN_SQUARE_SYNC_BANNER'
    | 'RETAILER_HAS_SET_NEW_R2C_LINK'
    | 'RETAILER_HAS_DISMISSED_UPLOAD_NOTIFICATION'
    | 'RETAILER_HAS_DISMISSED_CONTACT_US_BANNER'
    | 'RETAILER_HAS_STARTED_BULK_UPLOAD'
    | 'RETAILER_HAS_DISMISSED_WELCOME_STORE_LIVE_BANNER'
    | 'RETAILER_HAS_SEEN_HIGH_RETURNER_MODAL'
    | 'RETAILER_HAS_SEEN_R2M_CHECKOUT_BANNER'
    | 'RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP'
    | 'RETAILER_HAS_DISMISSED_POS_PROMO_BANNER'
    | 'POS_ORDER_SUCCESS_BANNER_V2_DISMISSED'
    | 'RETAILER_HAS_SEEN_PRE_QUALIFIED_PROMO_MODAL'
    | 'RETAILER_HAS_SEEN_TERMS_APPLICATION_PROMO_MODAL'
    | 'CREDIT_UTILIZATION_ORDER_SUCCESS_BANNER_DISMISSED'
    | 'CHECKOUT_CREDIT_BACK_BANNER_DISMISS'
    | 'YOUR_PICKS_PAGE_SEEN'
    | 'YOUR_PICKS_TOAST_SEEN_ON_DISTINCT_DAY'
    | 'APPAREL_ANSWERS_COMPLETED'
    | 'RETAILER_SEEN_LIMIT_INCREASE_V2'
    | 'YOUR_PICKS_QUIZ_MODAL_DISMISSED'
    | 'YOUR_PICKS_QUIZ_MODAL_SNOOZE_COUNT'
    | 'RESELLER_CERTIFICATE_ON_SIGNUP'
    | 'RETAILER_HAS_SEEN_LIMIT_INCREASE_AT_FIRST_ORDER'
    | 'PLAID_ACH_ACCOUNT_MENU_NOTIFICATION_DISMISSED'
    | 'LAUNCH_WITH_FAIRE_BANNER_DISMISSED'
    | 'RETAILER_HAS_SEEN_LAUNCH_WITH_FAIRE_ACCEPTED'
    | 'R2B_FOLLOWUPS_PAGE_SEEN'
    | 'RETAILER_HAS_SEEN_WINTER_DISCOUNT_PROMO'
    | 'RETAILER_HAS_SEEN_SAMPLES_TOOLTIP'
    | 'FIRST_ORDER_FREE_SHIPPING_BANNER_PROMO_DISMISSED'
    | 'PURCHASE_ORDER_LANDING_PAGE_MODAL_SEEN'
    | 'RETAILER_HAS_SEEN_WINTER_DISCOUNT_LAST_WEEK_REMINDER'
    | 'RETAILER_HAS_SEEN_WINTER_DISCOUNT_LAST_DAY_COUNTDOWN'
    | 'RETAILER_HAS_BEEN_ASKED_FOR_VAT_NUMBER'
    | 'RETAILER_HAS_BEEN_ASKED_FOR_EORI_NUMBER'
    | 'FAIRE_WINTER_MARKET_CLAIM_YOUR_GIFT_SEEN_COUNT'
    | 'FWM_2021_SUCCESS_MODAL_SEEN'
    | 'FAIRE_WINTER_MARKET_SELF_VERIFICATION_MODAL_SEEN'
    | 'NON_BM_TERMS_APPLICATION_MODAL_SEEN'
    | 'RETAILER_BUCKETED_INTO_UK_EU_BRANDS_FREE_SHIPPING_EXPERIMENT'
    | 'APPAREL_POPUP_MODAL_SEEN'
    | 'APPAREL_INLINE_CATEGORY_SEEN'
    | 'APPAREL_INLINE_QUIZ_SEEN'
    | 'APPAREL_CATEGORIZATION_COMPLETED'
    | 'APPAREL_STYLE_QUIZ_COMPLETED'
    | 'CHECKOUT_WITHOUT_INSIDER_ENROLMENT'
    | 'PRICE_MATCH_GUARANTEE_MODAL_SEEN'
    | 'INSIDER_SHIPMENT_SELECTED'
    | 'RETAILER_LOYALTY_PROGRAM_BANNER_DISMISSED'
    | 'RETAILER_LOYALTY_PROGRAM_BANNER_SEEN'
    | 'NON_BM_TERMS_APPLICATION_IN_CHECKOUT_DISMISSED'
    | 'PREMATURE_APPLICATION_ON_HOLD_DISMISSED'
    | 'USER_HAS_CLOSED_UK_EU_BRANDS_FREE_SHIPPING_BANNER'
    | 'RETAILER_BUCKETED_INTO_PRICE_MATCH_GUARANTEE_EXPERIMENT'
    | 'HAS_SEEN_NET_TERMS_HUB_LAUNCH_WITH_FAIRE_POST_APPLICATION_MODAL'
    | 'APPAREL_STYLE_QUIZ_FREE_SHIPPING_SEEN'
    | 'USER_HAS_SEEN_UK_EU_BRANDS_FREE_SHIPPING_TOP_BANNER'
    | 'USER_HAS_SEEN_UK_EU_BRANDS_FREE_SHIPPING_HOMEPAGE_BANNER'
    | 'APPAREL_POPUP_MODAL_SEEN_IOS'
    | 'APPAREL_POPUP_MODAL_SEEN_ANDROID'
    | 'FAIRE_SUMMER_MARKET_2021_RETAILER_RSVP'
    | 'INSIDER_REMINDER_ON_CHECKOUT_SELECTED'
    | 'INSIDER_REMINDER_ON_CHECKOUT_VIEWED'
    | 'RETAILER_FASHION_WEEK_RSVP_COMPLETED'
    | 'FAIRE_FASHION_WEEK_RETAILER_MODAL_DONE'
    | 'FAIRE_FASHION_WEEK_RETAILER_MODAL_DISMISSED'
    | 'POST_ORDER_INSIDER_ENROLLMENT_VIEWED'
    | 'MOBILE_HOME_FEED_ALTERNATE_NET_TERMS_AND_FREE_RETURNS'
    | 'APP_CAT_NAV_FREE_RETURNS_BANNER_DISMISSED'
    | 'R2B_VALUE_BASED_INCENTIVES_LANDING_MODAL_SEEN'
    | 'R2B_REFERRAL_PAGE_LANDING_MODAL_SEEN'
    | 'CATEGORY_APP_DOWNLOAD_CTA_SEEN'
    | 'SEARCH_APP_DOWNLOAD_CTA_SEEN'
    | 'SEARCH_MODAL_APP_DOWNLOAD_CTA_SEEN'
    | 'FASHION_WEEK_CATEGORY_BANNER_SEEN'
    | 'OPENING_ORDER_DISCOUNT_MODAL_SEEN'
    | 'OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL_SEEN'
    | 'FASHION_WEEK_SELF_IDV_SUBMITTED'
    | 'FASHION_WEEK_IDENTITY_VERIFICATION_MODAL_DISMISSED'
    | 'F14_DISCOUNT_TOOLTIP_SEEN'
    | 'RETAILER_PORTAL_TOP_SHOP_TOOLTIP_SEEN'
    | 'RETAILER_PORTAL_TOP_SHOP_BANNER_SEEN'
    | 'SHOULD_DISPLAY_INTERNATIONAL_BUYING_MODAL'
    | 'INTERNATIONAL_BUYING_MODAL_SEEN'
    | 'INSIDER_BRAND_REFRESH_ANNOUNCEMENT_MODAL_SEEN'
    | 'INSIDER_BRAND_REFRESH_ANNOUNCEMENT_TOOLTIP_SEEN'
    | 'HAS_VISITED_CATEGORY_SEARCH_PAGES'
    | 'MOBILE_HOME_FEED_TOP_SHOP_ANNOUNCEMENT'
    | 'FIRST_ORDER_INCENTIVE_MODAL_DISMISS'
    | 'OPENING_ORDER_DISCOUNT_ELIGIBILITY_PROCESSED'
    | 'FIRST_ORDER_INCENTIVE_COUNTDOWN_MODAL_DISMISS'
    | 'HOLIDAY_EXTENDED_WINDOW_START_SEEN'
    | 'HOLIDAY_EXTENDED_WINDOW_END_SEEN'
    | 'RETAILER_PORTAL_TOP_SHOP_BANNER_DISMISSED'
    | 'RETAILER_PORTAL_ALL_BRANDS_PAGE_TOP_SHOP_BANNER_SEEN'
    | 'RETAILER_PORTAL_ALL_BRANDS_PAGE_TOP_SHOP_BANNER_DISMISSED'
    | 'R2B_ATTRIBUTION_REVAMP_MODAL_SEEN'
    | 'LAST_CHARGE_ALTERNATIVE_CARD_NOTIFICATION_SENT'
    | 'OPENING_ORDER_DISCOUNT_WELCOME_EMAIL_SENT'
    | 'OPENING_ORDER_DISCOUNT_COUNT_DOWN_EMAIL_SENT'
    | 'APP_CAT_NAV_WAREHOUSE_SALE_BANNER_DISMISSED'
    | 'USER_HAS_SEEN_FREE_SHIPPING_DUTIES_HOMEPAGE_BANNER'
    | 'USER_HAS_SEEN_FREE_SHIPPING_DUTIES_INFO_IN_LOCATION_FILTER'
    | 'USER_HAS_SEEN_FREE_SHIPPING_DUTIES_HOME_FEED_BANNER'
    | 'RE_ENGAGEMENT_INCENTIVE_MODAL_DISMISS'
    | 'SURFACE_INSIDER_SHIPPING_SAVING'
    | 'RETAILER_BUCKETED_INTO_FFD_EXPERIMENT'
    | 'MID_PRICE_POINT_PLUS_TOP_BANNER_DISMISSED'
    | 'HW2021_RETAILER_PRODUCT_RECOMMENDATIONS_INSPIRE_PAGE_ONBOARDING_COMPLETED'
    | 'RETAILER_LANGUAGE_UPDATE_ANNOUNCEMENT_DISMISSED'
    | 'MOBILE_MARKET_LIST_VISITED_FFW_2022'
    | 'PRE_EVENT_MODAL_CLICKED_FFW_2022'
    | 'PRE_EVENT_MODAL_DISMISSED_FFW_2022'
    | 'INSIDER_SIGNUP_EDUCATION_MODAL_SEEN'
    | 'INSIDER_CATEGORY_PAGE_BANNER_DISMISSED'
    | 'FIRST_INSIDER_ORDER'
    | 'MY_BRANDS_FWM_HOMEPAGE_BANNER'
    | 'MY_BRANDS_ORDERS_BANNER'
    | 'MY_BRANDS_FOLLOWING_BANNER'
    | 'MY_BRANDS_ONBOARDING'
    | 'RETAILER_LANGUAGE_DAN_UPDATE_ANNOUNCEMENT_DISMISSED'
    | 'RETAILER_LANGUAGE_SWE_UPDATE_ANNOUNCEMENT_DISMISSED'
    | 'RETAILER_UPDATE_BUSINESS_DETAILS_BANNER_DISMISSED'
    | 'RETAILER_UPDATE_BUSINESS_DETAILS_MODAL_DISMISSED'
    | 'MY_BRANDS_TOP_NAV_DISPLAYED'
    | 'SHOWROOM_APPAREL_INLINE_BANNER_SEEN_COUNT'
    | 'SHOWROOM_APPAREL_C2_TITLE_BANNER_SEEN_COUNT'
    | 'SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED'
    | 'SHOWROOM_PAGE_EDU_BANNER_SEEN_COUNT'
    | 'SHOWROOM_APPAREL_PRODUCT_CAROUSEL_SEEN_COUNT'
    | 'BRAND_PAGE_BANNER_STARTER_COLLECTION'
    | 'SEARCH_FILTER_PILL_INSIDER_BANNER_EUROPE'
    | 'MY_BRANDS_ONBOARDING_ANDROID'
    | 'MY_BRANDS_ONBOARDING_IOS'
    | 'RETAILER_HAS_BEEN_ASKED_FOR_ABN_NUMBER'
    | 'SHOWROOM_PAGE_NEW_RETAILER_EXPERIENCE'
    | 'ORDER_PLACED_WITH_LOCAL_DISCOUNT'
    | 'LOCAL_DISCOUNT_CATEGORY_UPSELL_BANNER_SHOWN'
    | 'LOCAL_DISCOUNT_RETAILER_MODAL_SEEN'
    | 'ORDERS_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN'
    | 'ORDER_DETAILS_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN'
    | 'CHECKOUT_CONFIRMATION_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN'
    | 'SHOWROOM_APPAREL_C1_TITLE_BANNER'
    | 'SHOWROOM_APPAREL_INLINE_BANNER'
    | 'SHOWROOM_APPAREL_C2_TITLE_BANNER'
    | 'SHOWROOM_HOMEPAGE_EDU_BANNER'
    | 'IMPROVE_CART_NAV_220314_ONBOARDING_SEEN'
    | 'POS_SETTINGS_TOOLTIP_DISMISSED'
    | 'ORDERS_PAGE_SORT_BY_SHIPMENT_TOOLTIP_SEEN'
    | 'INSIDER_FILTER_PILL_TOOLTIP_SEEN'
    | 'INSIDER_FILTER_PILL_TOOLTIP_DISMISSED'
    | 'MY_MARKET_LIST_USED_FSM_22'
    | 'APP_APPAREL_C1_DISMISSIBLE_TOP_BANNER'
    | 'APP_APPAREL_C2_DISMISSIBLE_TOP_BANNER'
    | 'APP_APPAREL_C3_DISMISSIBLE_TOP_BANNER'
    | 'APP_APPAREL_SEARCH_DISMISSIBLE_TOP_BANNER'
    | 'APP_CORE_CATEGORIES_APPAREL_DISMISSIBLE_TOP_BANNER'
    | 'APP_CORE_CATEGORIES_APPAREL_DISMISSIBLE_TOP_BANNER_SEEN'
    | 'R2B_CREDIT_REDUCTION_INFO_MODAL_SEEN'
    | 'NO_RETAILER_MILESTONE'
    | 'LATEST_FASHION_DROPDOWN_SEEN_COUNT'
    | 'LATEST_FASHION_DROPDOWN_CLICKED'
    | 'FD_CREDIT_MARKETPLACE_PIVOT_MODAL_DISMISS'
    | 'MULTI_USER_RETAILER_SET_UP_TEAM_MODAL_SEEN_COUNT'
    | 'INSIDER_GROWTH_MEMBERSHIP_MIGRATION_SETTINGS_PAGE_ANNOUNCEMENT_SEEN'
    | 'BUY_IT_AGAIN_TOOLTIP_IS_VIEWED'
    | 'INSIDER_CATEGORY_PAGE_SLIM_BANNER_DISMISSED'
    | 'IDV_MODAL_SEEN'
    | 'RETAILER_NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED'
    | 'RETAILER_NAM_SUBSIDY_PULLBACK_BANNER_SEEN'
    | 'RETAILER_MULTI_USER_EDUCATIONAL_BANNER_SEEN_COUNT'
    | 'INSIDER_TOP_NAV_LINK_FIRST_TIME_VIEWED'
    | 'ADDED_ITEM_TO_CART'
    | 'RECEIVED_POST_SIGNUP_AUTO_IDV'
    | 'HAS_SEEN_INVENTORY_LEVEL_TOOLTIP'
    | 'HAS_SEEN_PENDING_INVENTORY_TOOLTIP_IN_BUY_IT_AGAIN_PAGE'
    | 'HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22'
    | 'HAS_DISMISSED_BUY_IT_AGAIN_ITEMS_IN_CART_BANNER'
    | 'HAS_SEEN_ACH_UPSELL_TEXT'
    | 'FORCE_ELIGIBLE_FOR_TERMS_LIMIT_INCREASE'
    | 'INSIDER_GROWTH_MIGRATION_ACCOUNT_DROPDOWN_NOTICE_SEEN'
    | 'INSIDER_GROWTH_MIGRATION_PROMO_MODAL_SEEN'
    | 'INSIDER_GROWTH_MIGRATION_TOOLTIP_SEEN'
    | 'INSIDER_GROWTH_MIGRATION_TOOLTIP_DISMISSED'
    | 'INSIDER_GROWTH_MIGRATION_MOBILE_BANNER_SEEN'
    | 'SUNSET_LOCAL_DISCOUNT_RETAILER_MODAL_SEEN'
    | 'POS_INVENTORY_MANAGEMENT_AVAILABLE_TO_LINK_TOOLTIP_IS_VIEWED'
    | 'RETAILER_INSIDER_MEMBERSHIP_RESUMED'
    | 'RETAILER_INSIDER_MEMBERSHIP_RESUMED_SEEN'
    | 'RETAILER_HAS_DISMISSED_OR_WON_FAIRDLE_TODAY'
    | 'PREPAID_CARDS_RESTRICTED_MODAL_SEEN'
    | 'RETAILER_MY_TEAM_PAGE_SEEN'
    | 'APP_LOW_MINIMUM_CALLOUT_BANNER_DISMISSED'
    | 'RETAILER_MULTI_USERS_GTM_EMAIL_SENT'
    | 'RETAILER_NEEDS_MANUAL_IDV'
    | 'ORDER_CONFIRMATION_EMAIL_SENT_WITH_TEAM_SECTION'
    | 'FILTER_REDESIGN_EDUCATIONAL_BANNER_WEB_DISMISSED'
    | 'FILTER_REDESIGN_EDUCATIONAL_BANNER_MOBILE_DISMISSED'
    | 'RETAILER_MULTI_USERS_GTM_SETTING_ASSIGNED'
    | 'POS_INTEGRATED_RETAILER_HAS_SEEN_ONBOARDING_TOOLTIPS'
    | 'POS_INTEGRATION_SPLASH_PAGE_VISITED_ON_MOBILE_WEB'
    | 'R2B_REFERRAL_POLICY_TOS_MODAL_SEEN'
    | 'MARKUP_FILTER_TOOLTIP_SEEN'
    | 'BRAND_LOCATION_FILTER_SEEN'
    | 'BRAND_LOCATION_FILTER_TOOLTIP_SEEN'
    | 'BRAND_LOCATION_FILTER_TOOLTIP_DISMISSED'
    | 'MARKUP_FILTER_TOOLTIP_DISMISSED'
    | 'RETAILER_POS_INTEGRATION_LINKED_BEFORE_ONBOARDING_FLOW_INTRODUCED'
    | 'INSIDER_FRAMANY_NORDICS_PRE_LAUNCH_ANNOUNCEMENT_MODAL_SEEN'
    | 'SHIPPED_FILTER_TOOLTIP_DISMISSED'
    | 'MARKUP_FILTER_BADGE_DISMISSED'
    | 'INSIDER_FRAMANY_NORDICS_POST_LAUNCH_ANNOUNCEMENT_MODAL_SEEN'
    | 'OPEN_WITH_FAIRE_UPSELL_NUDGE_1_SEEN'
    | 'OPEN_WITH_FAIRE_UPSELL_NUDGE_2_SEEN'
    | 'RETAILER_HAS_SEEN_PAYMENT_PLAN_PAYMENT_FAILED_MODAL'
    | 'RETAILER_HAS_SEEN_PAYMENT_PLAN_FULLY_PAID_MODAL'
    | 'MULTI_USER_SUBMIT_FOR_CHECKOUT_INFO_TOOLTIP_DISMISSED'
    | 'MULTI_USER_BRAND_PAGE_COLLABORATOR_INFO_TOOLTIP_DISMISSED'
    | 'RECORDED_SAMPLE_V2_TREATMENT'
    | 'RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER_SEEN'
    | 'MARKETING_EMAIL_OPT_IN_DISMISSED'
    | 'MARKETING_EMAIL_OPT_IN_SUBMITTED'
    | 'MARKETING_EMAIL_OPT_IN_MOBILE_RENDERED'
    | 'MARKETING_EMAIL_OPT_IN_COLLAPSED'
    | 'MARKETING_EMAIL_OPT_IN_REMINDERS_BEGUN'
    | 'MARKETING_EMAIL_PREFERENCES_SET'
    | 'FIRST_ORDER_INCENTIVE_AUTO_EXTEND_MODAL_DISMISS'
    | 'SAMPLE_BRANDS_HOMEPAGE_CAROUSEL_SEEN'
    | 'COMMISSION_UPDATE_REQUEST_BANNER_DISMISSED'
    | 'RETAILER_NEEDS_AUTO_IDV'
    | 'OPEN_WITH_FAIRE_PRE_OPENING_NUDGE_SEEN'
    | 'OPEN_WITH_FAIRE_POST_OPENING_NUDGE_SEEN'
    | 'RETAILER_OWF_IDV_TIER_3_SET'
    | 'HAS_SEEN_ECO_FRIENDLY_CATEGORY_PAGE'
    | 'HAS_SENT_REFERRAL_BONUS_FOLLOW_UP'
    | 'HAS_SEEN_REFERRAL_REENGAGEMENT_BANNER'
    | 'ECO_FRIENDLY_GTM_BANNER_DISMISSED'
    | 'OWF_APPLY_AGAIN_REMINDER_SCHEDULED'
    | 'OWF_APPLY_AGAIN_REMINDER_SENT'
    | 'HAS_CLOSED_ORDERS_PAGE_ACH_BANNER'
    | 'ECO_FRIENDLY_CATEGORY_PAGE_GTM_BANNER_DISMISSED'
    | 'SEEN_OWF_R2R_HOMEPAGE_BANNER'
    | 'FIRST_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN'
    | 'SECOND_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN'
    | 'THIRD_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN'
    | 'FIRST_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT'
    | 'SECOND_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT'
    | 'THIRD_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT'
    | 'KNOWN_REFERRAL_ADOPTION_TRACKING_ENGAGEMENT_SESSION'
    | 'KNOWN_REFERRER_ADOPTION_HAS_SENT_INVITE'
    | 'FB_CAT_TREE_NUX_DISMISSED'
    | 'HAS_SEEN_KNOWN_REFERRER_ADOPTION_BANNER'
    | 'HOLIDAY_PROMO_BANNER_VIEWED'
    | 'HOLIDAY_PROMO_BANNER_CLICKED'
    | 'OPEN_WITH_FAIRE_CTA_MOBILE_TAPPED'
    | 'REFER_RETAILERS_CTA_MOBILE_TAPPED'
    | 'MARKETING_SMS_OPT_IN_DISMISSED'
    | 'MARKETING_SMS_OPT_IN_COLLAPSED'
    | 'MARKETING_SMS_OPT_IN_SUBMITTED'
    | 'MARKETING_SMS_OPT_IN_FIRST_TRIGGERED'
    | 'NEW_GUARANTEED_SHIPPING_BADGE_SEEN'
    | 'HAS_SEEN_ACH_PROACTIVE_LIMIT_INCREASE_MODAL'
    | 'HAS_CLOSED_ACH_PROACTIVE_LIMIT_INCREASE_ORDERS_PAGE_BANNER'
    | 'ACH_PROACTIVE_LIMIT_INCREASE_ACCOUNT_DROPDOWN_OFFER_VIEW'
    | 'FD_MARKETPLACE_DISCOUNT_MODAL_DISMISSED'
    | 'INSIDER_REVIEW_TERMS_AND_CONDITIONS_MODAL_SEEN'
    | 'FIRST_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN'
    | 'SECOND_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN'
    | 'THIRD_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN'
    | 'MULTI_USER_GTM_PDP_AND_BRAND_PAGE_SILENCING'
    | 'MULTI_USER_GTM_INVOICE_AND_ORDER_PAGE_SILENCING'
    | 'MULTI_USER_GTM_ACCOUNT_SETTINGS_DROPDOWN_SILENCING'
    | 'MULTI_USER_GTM_MESSENGER_BANNER_DISMISSED'
    | 'FD_MARKETPLACE_DISCOUNT_NUDGE_MODAL_DISMISSED'
    | 'SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES'
    | 'SHOPIFY_LEAD_UPGRADED_PLAN'
    | 'RETAILER_MULTI_USERS_GTM_V2_SETTING_ASSIGNED'
    | 'RETAILER_MULTI_USERS_GTM_V2_EMAIL_SENT'
    | 'SHOPIFY_FEEDBACK_BANNER_DISMISSED'
    | 'RENAME_GUIDEPOST_BANNER_SEEN'
    | 'RENAME_GUIDEPOST_BANNER_DISMISSED'
    | 'HAS_SEEN_ACH_TERMS_PRE_APPROVAL_MODAL'
    | 'HAS_SEEN_TERMS_PRE_APPROVAL_MODAL'
    | 'HAS_CLOSED_ACH_TERMS_PRE_APPROVAL_ORDERS_PAGE_BANNER'
    | 'ACH_TERMS_PRE_APPROVAL_ACCOUNT_DROPDOWN_OFFER_VIEW'
    | 'ACH_TERMS_PRE_APPROVAL_CHECKOUT_OFFER_VIEW'
    | 'TERMS_PRE_APPROVAL_CHECKOUT_OFFER_VIEW'
    | 'SHOPIFY_ONBOARDING_BENEFITS_MODAL_SEEN'
    | 'MULTI_USER_GTM_PDP_AND_BRAND_PAGE_V2_SILENCING'
    | 'MULTI_USER_GTM_INVOICE_AND_ORDER_PAGE_V2_SILENCING'
    | 'MULTI_USER_GTM_ACCOUNT_SETTINGS_DROPDOWN_V2_SILENCING'
    | 'HAS_SEEN_POS_NEW_FEATURE_MODAL'
    | 'ELEVATE_TOP_SHOP_BANNER_DISMISSED'
    | 'AUTO_FILTER_BANNER_DISMISSED'
    | 'DO_NOT_AUTO_FILTER_SEARCH_RESULTS_FOR_RETAILER'
    | 'HAS_SEEN_POS_NEW_FEATURE_NOTIFICATION'
    | 'BESTSELLER_SORT_FILTER_NOTIFICATION_SEEN'
    | 'BESTSELLER_SORT_FILTER_NOTIFICATION_DISMISSED'
    | 'BESTSELLER_FILTER_BADGE_SEEN'
    | 'ECO_FRIENDLY_HOMEPAGE_BANNER_SEEN'
    | 'ECO_FRIENDLY_HOMEPAGE_BANNER_CLICKED'
    | 'ECO_FRIENDLY_CATEGORY_PAGE_TOP_BANNER_SEEN'
    | 'ECO_FRIENDLY_CATEGORY_PAGE_TOP_BANNER_CLICKED'
    | 'ECO_FRIENDLY_CATEGORY_PRODUCT_RESULTS_BANNER_SEEN'
    | 'ECO_FRIENDLY_CATEGORY_PRODUCT_RESULTS_CLICKED'
    | 'APP_BESTSELLERS_EDUCATIONAL_BANNER_DISMISSED'
    | 'HAS_ASSIGNED_TERMS_PRE_APPROVAL_BENEFITS'
    | 'HAS_SEEN_SKU_MATCHING_SETTING_NUDGE'
    | 'LOGGED_OUT_PRODUCT_TILE_CLICKED'
    | 'FAIRE_ACADEMY_REENGAGEMENT_EMAIL_SENT'
    | 'MOBILE_BRAND_PAGE_FILTERS_REDESIGN_BANNER_DISMISSED'
    | 'MOBILE_BRAND_PAGE_FILTERS_REDESIGN_BANNER_SEEN'
    | 'FAIRE_DIRECT_INCENTIVE_MODAL_DISMISS'
    | 'INSIDER_THRESHOLD_BADGE_TOOLTIP_SEEN'
    | 'STORES_PAGE_GENERAL_EXPANDING_OFFER_BANNER_DISMISSED'
    | 'STORES_PAGE_CONTEXTUAL_EXPANDING_OFFER_BANNER_DISMISSED'
    | 'EVERGREEN_FIRST_ORDER_INCENTIVE_MODAL_DISMISS'
    | 'INSIDER_BADGE_TOOLTIP_SEEN'
    | 'RETAILER_EXPANDING_OFFER_REMINDER_EMAIL_SENT'
    | 'RETAILER_EXPANDING_OFFER_EMAIL_EVENT_SENT'
    | 'TOP_PLACEMENT_CATEGORIES_FOR_YOU_NAV_NODES_SEEN'
    | 'BRAND_SUB_USER_ONBOARDING_MODAL_SEEN'
    | 'POS_FEEDBACK_BANNER_DISMISSED'
    | 'CARM_NUDGE_VIEWED'
    | 'CARM_NUDGE_DISMISSED'
    | 'POS_GUIDED_TOUR_DISMISSED'
    | 'POS_MATCHES_NUDGE_DISMISSED'
    | 'POS_POST_ORDER_MARKETING_EMAIL_SENT'
    | 'HAS_SEEN_NON_BM_INITIAL_LIMIT_LANDING_MODAL'
    | 'HAS_SEEN_NON_BM_INITIAL_LIMIT_CONFIRMATION_MODAL'
    | 'HAS_SEEN_NON_BM_INITIAL_LIMIT_CHECKOUT_UPSELL_BANNER'
    | 'INSIDER_REVIEW_TERMS_AND_CONDITIONS_ACCEPTANCE_MODAL_SEEN'
    | 'HAS_SEEN_GRANTS_LANDING_PAGE'
    | 'ONE_OFF_LIMIT_INCREASE_MODAL_VIEW'
    | 'ONE_OFF_LIMIT_INCREASE_DROPDOWN_VIEW'
    | 'FAIRE_PAY_ACCOUNT_DROPDOWN_NEW_BADGE_VIEW'
    | 'POS_MARKETING_BANNERS_DISMISSED'
    | 'ORDER_DETAIL_POS_ONBOARDING_BANNER_SEEN'
    | 'POS_BULK_EDITOR_EDUCATION_MODAL_SEEN'
    | 'POS_BULK_EDITOR_EDUCATION_BANNER_SEEN'
    | 'POS_BULK_EDITOR_WELCOME_TOOLTIP_SEEN'
    | 'POS_BULK_EDITOR_EDITING_TOOLTIP_SEEN'
    | 'POS_BULK_EDITOR_PASTING_TOOLTIP_SEEN'
    | 'LAST_CHANCE_FIRST_ORDER_INCENTIVE_MODAL_DISMISS'
    | 'INSIDER_EXPANDED_FREE_SHIPPING_BANNER_DISMISS'
    | 'INSIDER_EXPANDED_FREE_SHIPPING_BANNER_SEEN'
    | 'INSIDER_PARTNERSHIP_LAUNCH_ANNOUNCEMENT_MODAL_SEEN'
    | 'SENT_REVIEW_BRAND_BRAZE_EMAIL'
    | 'SENT_REVIEW_BRAND_REMINDER_BRAZE_EMAIL'
    | 'INSIDER_REFRESH_REMINDER_MODAL_SEEN'
    | 'INSIDER_REFRESH_REMINDER_CART_BANNER_DISMISSED'
    | 'INSIDER_REFRESH_REMINDER_MY_BRANDS_BANNER_DISMISSED'
    | 'USER_FEEDBACK_TOOLTIP_SEEN'
    | 'USER_FEEDBACK_TOOLTIP_DISMISSED'
    | 'INSIDER_REFRESH_CART_BRANDS_EXPIRING'
    | 'INSIDER_REFRESH_MY_BRANDS_EXPIRING'
    | 'SALE_ANNOUNCEMENT_DISMISSED'
    | 'INSIDER_CAN_AUS_LAUNCH_MODAL_SEEN'
    | 'RETAILER_SUBMITTED_PURCHASE_ORDER_FOR_PILOT'
    | 'DIGEST_PAGE_MODAL_SEEN'
    | 'DEALS_HUB_BANNER_CTA_CLICKED'
    | 'DEALS_HUB_BANNER_SEEN'
    | 'RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN'
    | 'DIGEST_PAGE_SEEN'
    | 'RETAILER_STORE_GTM_CHECKOUT_ADD_A_STORE_SEEN'
    | 'APP_DOWNLOAD_NUDGE_DISMISSED'
    | 'LOW_POS_STOCK_CAROUSEL_CLICKED'
    | 'BRAND_REVIEW_SUGGESTION_MOBILE_BANNER_SEEN';

  export enum RetailerMilestone {
    CHECKOUT_CART_FORCE_PAYMENT_ON_SHIPMENT = 'CHECKOUT_CART_FORCE_PAYMENT_ON_SHIPMENT',
    CHECKOUT_MAKER_MARKET_FORCE_PAYMENT_ON_SHIPMENT = 'CHECKOUT_MAKER_MARKET_FORCE_PAYMENT_ON_SHIPMENT',
    CHECKOUT_OVERLIMIT = 'CHECKOUT_OVERLIMIT',
    CREDIT_LIMIT_CHART = 'CREDIT_LIMIT_CHART',
    /**
     * @deprecated
     */
    INSIDER_SEEN_IN_MENU_7_UNIQUE_DAYS = 'INSIDER_SEEN_IN_MENU_7_UNIQUE_DAYS',
    INSIDER_SEEN_ON_DISTINCT_DAY = 'INSIDER_SEEN_ON_DISTINCT_DAY',
    /**
     * @deprecated
     */
    INSIDER_PROMOTION_MODAL_DISMISSED = 'INSIDER_PROMOTION_MODAL_DISMISSED',
    /**
     * @deprecated
     */
    INSIDER_PROMOTION_MODAL_NEVER_SHOW_AGAIN = 'INSIDER_PROMOTION_MODAL_NEVER_SHOW_AGAIN',
    INSIDER_HOMEPAGE_BANNER_SEEN_ON_DISTINCT_DAY = 'INSIDER_HOMEPAGE_BANNER_SEEN_ON_DISTINCT_DAY',
    INSIDER_ALERT_BANNER_SEEN_ON_DISTINCT_DAY = 'INSIDER_ALERT_BANNER_SEEN_ON_DISTINCT_DAY',
    RETAILER_SCORE_WARNING_VISITED = 'RETAILER_SCORE_WARNING_VISITED',
    INSTALLMENT_BANNER_SEEN_TIMES = 'INSTALLMENT_BANNER_SEEN_TIMES',
    PROACTIVE_CHAT_SEEN = 'PROACTIVE_CHAT_SEEN',
    REORDER_INCREASED_TERMS_BANNER_SEEN_ON_DISTINCT_DAY = 'REORDER_INCREASED_TERMS_BANNER_SEEN_ON_DISTINCT_DAY',
    REORDERED = 'REORDERED',
    R2M_MARKETING_PAGE_SEEN = 'R2M_MARKETING_PAGE_SEEN',
    /**
     * @deprecated
     */
    ELEVATE_CREDIT_MODAL_SEEN = 'ELEVATE_CREDIT_MODAL_SEEN',
    SALES_REP_BANNER_DISMISSED = 'SALES_REP_BANNER_DISMISSED',
    PROACTIVE_CHAT_FOR_RETURNING_RETAILERS_SEEN = 'PROACTIVE_CHAT_FOR_RETURNING_RETAILERS_SEEN',
    INSIDER_V2_CHANGES_MODAL_SEEN = 'INSIDER_V2_CHANGES_MODAL_SEEN',
    NET90_PROMO_MODAL_SEEN = 'NET90_PROMO_MODAL_SEEN',
    /**
     * @deprecated
     */
    STYLE_QUIZ_MODAL_SEEN = 'STYLE_QUIZ_MODAL_SEEN',
    NET90_HOLIDAY_BANNER_SEEN_ON_DISTINCT_DAY = 'NET90_HOLIDAY_BANNER_SEEN_ON_DISTINCT_DAY',
    BRAND_REVIEW_TOOLTIP_SEEN = 'BRAND_REVIEW_TOOLTIP_SEEN',
    /**
     * @deprecated
     */
    UNLIMITED_REORDER_TERMS_BANNER_DISMISSED = 'UNLIMITED_REORDER_TERMS_BANNER_DISMISSED',
    /**
     * @deprecated
     */
    NET90_TERMINATING_PROMO_MODAL_SEEN = 'NET90_TERMINATING_PROMO_MODAL_SEEN',
    SQUARE_POS_ORDER_SUCCESS_BANNER_DISMISSED = 'SQUARE_POS_ORDER_SUCCESS_BANNER_DISMISSED',
    /**
     * @deprecated
     */
    PREORDER_INTRO_MODAL_SEEN = 'PREORDER_INTRO_MODAL_SEEN',
    GREAT_APP_MIGRATION_MODAL_DISMISS = 'GREAT_APP_MIGRATION_MODAL_DISMISS',
    GREAT_APP_MIGRATION_BANNER_DISMISS = 'GREAT_APP_MIGRATION_BANNER_DISMISS',
    SQUARE_2020_PROMO_PAGE_SEEN = 'SQUARE_2020_PROMO_PAGE_SEEN',
    AMEX_PROMO_PAGE_SEEN = 'AMEX_PROMO_PAGE_SEEN',
    RETAILER_COVID_LOANS_HELPER_MODAL_SEEN = 'RETAILER_COVID_LOANS_HELPER_MODAL_SEEN',
    /**
     * @deprecated
     */
    COVID_19_PROMO_MODAL_SEEN = 'COVID_19_PROMO_MODAL_SEEN',
    RETAILER_PORTAL_NAV_GUIDED_TOUR_SEEN = 'RETAILER_PORTAL_NAV_GUIDED_TOUR_SEEN',
    RETAILER_PORTAL_PRODUCTS_PAGE_GUIDED_TOUR_SEEN = 'RETAILER_PORTAL_PRODUCTS_PAGE_GUIDED_TOUR_SEEN',
    RETAILER_PORTAL_ONBOARDING_COMPLETE = 'RETAILER_PORTAL_ONBOARDING_COMPLETE',
    RETAILER_PORTAL_ONBOARDING_STARTED = 'RETAILER_PORTAL_ONBOARDING_STARTED',
    COVID_CHECKOUT_SURVEY_DISMISSED = 'COVID_CHECKOUT_SURVEY_DISMISSED',
    RETAILER_HAS_SEEN_NEIGHBORHOOD_MODAL = 'RETAILER_HAS_SEEN_NEIGHBORHOOD_MODAL',
    RETAILER_PORTAL_SEEN_PHONE_NUMBER_MODAL = 'RETAILER_PORTAL_SEEN_PHONE_NUMBER_MODAL',
    RETAILER_PORTAL_INVENTORY_TOOLTIP_SEEN = 'RETAILER_PORTAL_INVENTORY_TOOLTIP_SEEN',
    RETAILER_PORTAL_HAS_SEEN_SHOPIFY_SYNC_BANNER = 'RETAILER_PORTAL_HAS_SEEN_SHOPIFY_SYNC_BANNER',
    RETAILER_PORTAL_BULK_UPLOAD_COMPLETE = 'RETAILER_PORTAL_BULK_UPLOAD_COMPLETE',
    RETAILER_HAS_SEEN_SHOP_BOARDS_MODAL = 'RETAILER_HAS_SEEN_SHOP_BOARDS_MODAL',
    RETAILER_POST_SIGN_UP_MODAL_DISMISS = 'RETAILER_POST_SIGN_UP_MODAL_DISMISS',
    RETAILER_INTEGRATION_EARLY_ACCESS_BANNER_DISMISS = 'RETAILER_INTEGRATION_EARLY_ACCESS_BANNER_DISMISS',
    RETAILER_NO_COMISSION_BANNER_DISMISS = 'RETAILER_NO_COMISSION_BANNER_DISMISS',
    RETAILER_PORTAL_SQUARE_SETUP_COMPLETE = 'RETAILER_PORTAL_SQUARE_SETUP_COMPLETE',
    RETAILER_HAS_SEEN_REOPENING_TOOLTIP = 'RETAILER_HAS_SEEN_REOPENING_TOOLTIP',
    RETAILER_PORTAL_HAS_SEEN_SQUARE_SYNC_BANNER = 'RETAILER_PORTAL_HAS_SEEN_SQUARE_SYNC_BANNER',
    RETAILER_HAS_SET_NEW_R2C_LINK = 'RETAILER_HAS_SET_NEW_R2C_LINK',
    RETAILER_HAS_DISMISSED_UPLOAD_NOTIFICATION = 'RETAILER_HAS_DISMISSED_UPLOAD_NOTIFICATION',
    RETAILER_HAS_DISMISSED_CONTACT_US_BANNER = 'RETAILER_HAS_DISMISSED_CONTACT_US_BANNER',
    RETAILER_HAS_STARTED_BULK_UPLOAD = 'RETAILER_HAS_STARTED_BULK_UPLOAD',
    RETAILER_HAS_DISMISSED_WELCOME_STORE_LIVE_BANNER = 'RETAILER_HAS_DISMISSED_WELCOME_STORE_LIVE_BANNER',
    RETAILER_HAS_SEEN_HIGH_RETURNER_MODAL = 'RETAILER_HAS_SEEN_HIGH_RETURNER_MODAL',
    RETAILER_HAS_SEEN_R2M_CHECKOUT_BANNER = 'RETAILER_HAS_SEEN_R2M_CHECKOUT_BANNER',
    RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP = 'RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP',
    RETAILER_HAS_DISMISSED_POS_PROMO_BANNER = 'RETAILER_HAS_DISMISSED_POS_PROMO_BANNER',
    POS_ORDER_SUCCESS_BANNER_V2_DISMISSED = 'POS_ORDER_SUCCESS_BANNER_V2_DISMISSED',
    RETAILER_HAS_SEEN_PRE_QUALIFIED_PROMO_MODAL = 'RETAILER_HAS_SEEN_PRE_QUALIFIED_PROMO_MODAL',
    RETAILER_HAS_SEEN_TERMS_APPLICATION_PROMO_MODAL = 'RETAILER_HAS_SEEN_TERMS_APPLICATION_PROMO_MODAL',
    CREDIT_UTILIZATION_ORDER_SUCCESS_BANNER_DISMISSED = 'CREDIT_UTILIZATION_ORDER_SUCCESS_BANNER_DISMISSED',
    CHECKOUT_CREDIT_BACK_BANNER_DISMISS = 'CHECKOUT_CREDIT_BACK_BANNER_DISMISS',
    /**
     * @deprecated
     */
    YOUR_PICKS_PAGE_SEEN = 'YOUR_PICKS_PAGE_SEEN',
    /**
     * @deprecated
     */
    YOUR_PICKS_TOAST_SEEN_ON_DISTINCT_DAY = 'YOUR_PICKS_TOAST_SEEN_ON_DISTINCT_DAY',
    /**
     * Set at the end of onboarding (for new apparel retailers) or when all apparel quiz answers have been provided
     * (for existing apparel retailers)
     * Used to determine if we have sufficient information to surface the Your Picks page
     * @deprecated
     */
    APPAREL_ANSWERS_COMPLETED = 'APPAREL_ANSWERS_COMPLETED',
    RETAILER_SEEN_LIMIT_INCREASE_V2 = 'RETAILER_SEEN_LIMIT_INCREASE_V2',
    /**
     * @deprecated
     */
    YOUR_PICKS_QUIZ_MODAL_DISMISSED = 'YOUR_PICKS_QUIZ_MODAL_DISMISSED',
    /**
     * @deprecated
     */
    YOUR_PICKS_QUIZ_MODAL_SNOOZE_COUNT = 'YOUR_PICKS_QUIZ_MODAL_SNOOZE_COUNT',
    RESELLER_CERTIFICATE_ON_SIGNUP = 'RESELLER_CERTIFICATE_ON_SIGNUP',
    /**
     * @deprecated
     */
    RETAILER_HAS_SEEN_LIMIT_INCREASE_AT_FIRST_ORDER = 'RETAILER_HAS_SEEN_LIMIT_INCREASE_AT_FIRST_ORDER',
    PLAID_ACH_ACCOUNT_MENU_NOTIFICATION_DISMISSED = 'PLAID_ACH_ACCOUNT_MENU_NOTIFICATION_DISMISSED',
    LAUNCH_WITH_FAIRE_BANNER_DISMISSED = 'LAUNCH_WITH_FAIRE_BANNER_DISMISSED',
    RETAILER_HAS_SEEN_LAUNCH_WITH_FAIRE_ACCEPTED = 'RETAILER_HAS_SEEN_LAUNCH_WITH_FAIRE_ACCEPTED',
    R2B_FOLLOWUPS_PAGE_SEEN = 'R2B_FOLLOWUPS_PAGE_SEEN',
    RETAILER_HAS_SEEN_WINTER_DISCOUNT_PROMO = 'RETAILER_HAS_SEEN_WINTER_DISCOUNT_PROMO',
    RETAILER_HAS_SEEN_SAMPLES_TOOLTIP = 'RETAILER_HAS_SEEN_SAMPLES_TOOLTIP',
    FIRST_ORDER_FREE_SHIPPING_BANNER_PROMO_DISMISSED = 'FIRST_ORDER_FREE_SHIPPING_BANNER_PROMO_DISMISSED',
    PURCHASE_ORDER_LANDING_PAGE_MODAL_SEEN = 'PURCHASE_ORDER_LANDING_PAGE_MODAL_SEEN',
    RETAILER_HAS_SEEN_WINTER_DISCOUNT_LAST_WEEK_REMINDER = 'RETAILER_HAS_SEEN_WINTER_DISCOUNT_LAST_WEEK_REMINDER',
    RETAILER_HAS_SEEN_WINTER_DISCOUNT_LAST_DAY_COUNTDOWN = 'RETAILER_HAS_SEEN_WINTER_DISCOUNT_LAST_DAY_COUNTDOWN',
    /**
     * we only want to ask for VAT or EORI once each
     */
    RETAILER_HAS_BEEN_ASKED_FOR_VAT_NUMBER = 'RETAILER_HAS_BEEN_ASKED_FOR_VAT_NUMBER',
    RETAILER_HAS_BEEN_ASKED_FOR_EORI_NUMBER = 'RETAILER_HAS_BEEN_ASKED_FOR_EORI_NUMBER',
    /**
     * @deprecated
     */
    FAIRE_WINTER_MARKET_CLAIM_YOUR_GIFT_SEEN_COUNT = 'FAIRE_WINTER_MARKET_CLAIM_YOUR_GIFT_SEEN_COUNT',
    /**
     * @deprecated
     */
    FWM_2021_SUCCESS_MODAL_SEEN = 'FWM_2021_SUCCESS_MODAL_SEEN',
    /**
     * @deprecated
     */
    FAIRE_WINTER_MARKET_SELF_VERIFICATION_MODAL_SEEN = 'FAIRE_WINTER_MARKET_SELF_VERIFICATION_MODAL_SEEN',
    NON_BM_TERMS_APPLICATION_MODAL_SEEN = 'NON_BM_TERMS_APPLICATION_MODAL_SEEN',
    RETAILER_BUCKETED_INTO_UK_EU_BRANDS_FREE_SHIPPING_EXPERIMENT = 'RETAILER_BUCKETED_INTO_UK_EU_BRANDS_FREE_SHIPPING_EXPERIMENT',
    APPAREL_POPUP_MODAL_SEEN = 'APPAREL_POPUP_MODAL_SEEN',
    APPAREL_INLINE_CATEGORY_SEEN = 'APPAREL_INLINE_CATEGORY_SEEN',
    APPAREL_INLINE_QUIZ_SEEN = 'APPAREL_INLINE_QUIZ_SEEN',
    APPAREL_CATEGORIZATION_COMPLETED = 'APPAREL_CATEGORIZATION_COMPLETED',
    APPAREL_STYLE_QUIZ_COMPLETED = 'APPAREL_STYLE_QUIZ_COMPLETED',
    CHECKOUT_WITHOUT_INSIDER_ENROLMENT = 'CHECKOUT_WITHOUT_INSIDER_ENROLMENT',
    PRICE_MATCH_GUARANTEE_MODAL_SEEN = 'PRICE_MATCH_GUARANTEE_MODAL_SEEN',
    INSIDER_SHIPMENT_SELECTED = 'INSIDER_SHIPMENT_SELECTED',
    RETAILER_LOYALTY_PROGRAM_BANNER_DISMISSED = 'RETAILER_LOYALTY_PROGRAM_BANNER_DISMISSED',
    RETAILER_LOYALTY_PROGRAM_BANNER_SEEN = 'RETAILER_LOYALTY_PROGRAM_BANNER_SEEN',
    NON_BM_TERMS_APPLICATION_IN_CHECKOUT_DISMISSED = 'NON_BM_TERMS_APPLICATION_IN_CHECKOUT_DISMISSED',
    PREMATURE_APPLICATION_ON_HOLD_DISMISSED = 'PREMATURE_APPLICATION_ON_HOLD_DISMISSED',
    USER_HAS_CLOSED_UK_EU_BRANDS_FREE_SHIPPING_BANNER = 'USER_HAS_CLOSED_UK_EU_BRANDS_FREE_SHIPPING_BANNER',
    RETAILER_BUCKETED_INTO_PRICE_MATCH_GUARANTEE_EXPERIMENT = 'RETAILER_BUCKETED_INTO_PRICE_MATCH_GUARANTEE_EXPERIMENT',
    HAS_SEEN_NET_TERMS_HUB_LAUNCH_WITH_FAIRE_POST_APPLICATION_MODAL = 'HAS_SEEN_NET_TERMS_HUB_LAUNCH_WITH_FAIRE_POST_APPLICATION_MODAL',
    /**
     * @deprecated
     */
    APPAREL_STYLE_QUIZ_FREE_SHIPPING_SEEN = 'APPAREL_STYLE_QUIZ_FREE_SHIPPING_SEEN',
    USER_HAS_SEEN_UK_EU_BRANDS_FREE_SHIPPING_TOP_BANNER = 'USER_HAS_SEEN_UK_EU_BRANDS_FREE_SHIPPING_TOP_BANNER',
    USER_HAS_SEEN_UK_EU_BRANDS_FREE_SHIPPING_HOMEPAGE_BANNER = 'USER_HAS_SEEN_UK_EU_BRANDS_FREE_SHIPPING_HOMEPAGE_BANNER',
    APPAREL_POPUP_MODAL_SEEN_IOS = 'APPAREL_POPUP_MODAL_SEEN_IOS',
    APPAREL_POPUP_MODAL_SEEN_ANDROID = 'APPAREL_POPUP_MODAL_SEEN_ANDROID',
    FAIRE_SUMMER_MARKET_2021_RETAILER_RSVP = 'FAIRE_SUMMER_MARKET_2021_RETAILER_RSVP',
    INSIDER_REMINDER_ON_CHECKOUT_SELECTED = 'INSIDER_REMINDER_ON_CHECKOUT_SELECTED',
    INSIDER_REMINDER_ON_CHECKOUT_VIEWED = 'INSIDER_REMINDER_ON_CHECKOUT_VIEWED',
    /**
     * Set when the retailer completes the Faire Fashion Week RSVP flow
     * @deprecated
     */
    RETAILER_FASHION_WEEK_RSVP_COMPLETED = 'RETAILER_FASHION_WEEK_RSVP_COMPLETED',
    /**
     * Set when retailer announcement modal is acknowledged
     * @deprecated
     */
    FAIRE_FASHION_WEEK_RETAILER_MODAL_DONE = 'FAIRE_FASHION_WEEK_RETAILER_MODAL_DONE',
    /**
     * Set/increment count when retailer announcement modal is dismissed
     * @deprecated
     */
    FAIRE_FASHION_WEEK_RETAILER_MODAL_DISMISSED = 'FAIRE_FASHION_WEEK_RETAILER_MODAL_DISMISSED',
    POST_ORDER_INSIDER_ENROLLMENT_VIEWED = 'POST_ORDER_INSIDER_ENROLLMENT_VIEWED',
    MOBILE_HOME_FEED_ALTERNATE_NET_TERMS_AND_FREE_RETURNS = 'MOBILE_HOME_FEED_ALTERNATE_NET_TERMS_AND_FREE_RETURNS',
    APP_CAT_NAV_FREE_RETURNS_BANNER_DISMISSED = 'APP_CAT_NAV_FREE_RETURNS_BANNER_DISMISSED',
    R2B_VALUE_BASED_INCENTIVES_LANDING_MODAL_SEEN = 'R2B_VALUE_BASED_INCENTIVES_LANDING_MODAL_SEEN',
    /**
     * This milestone is used for landing modal added to old experience of r2b referral page
     */
    R2B_REFERRAL_PAGE_LANDING_MODAL_SEEN = 'R2B_REFERRAL_PAGE_LANDING_MODAL_SEEN',
    /**
     * milestones for app download cta experiment
     */
    CATEGORY_APP_DOWNLOAD_CTA_SEEN = 'CATEGORY_APP_DOWNLOAD_CTA_SEEN',
    SEARCH_APP_DOWNLOAD_CTA_SEEN = 'SEARCH_APP_DOWNLOAD_CTA_SEEN',
    SEARCH_MODAL_APP_DOWNLOAD_CTA_SEEN = 'SEARCH_MODAL_APP_DOWNLOAD_CTA_SEEN',
    /**
     * increment count when retailer sees the banner on a category page
     * @deprecated
     */
    FASHION_WEEK_CATEGORY_BANNER_SEEN = 'FASHION_WEEK_CATEGORY_BANNER_SEEN',
    OPENING_ORDER_DISCOUNT_MODAL_SEEN = 'OPENING_ORDER_DISCOUNT_MODAL_SEEN',
    OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL_SEEN = 'OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL_SEEN',
    /**
     * @deprecated
     */
    FASHION_WEEK_SELF_IDV_SUBMITTED = 'FASHION_WEEK_SELF_IDV_SUBMITTED',
    /**
     * @deprecated
     */
    FASHION_WEEK_IDENTITY_VERIFICATION_MODAL_DISMISSED = 'FASHION_WEEK_IDENTITY_VERIFICATION_MODAL_DISMISSED',
    /**
     * Set when the retailer dismisses the F14D brand discount tooltip on the new brands page
     */
    F14_DISCOUNT_TOOLTIP_SEEN = 'F14_DISCOUNT_TOOLTIP_SEEN',
    /**
     * Set when the retailer sees the tooltip on the Top Shop filter
     */
    RETAILER_PORTAL_TOP_SHOP_TOOLTIP_SEEN = 'RETAILER_PORTAL_TOP_SHOP_TOOLTIP_SEEN',
    /**
     * Set when the retailer sees the Top Shop banner in retailer portal on Top Shop page
     */
    RETAILER_PORTAL_TOP_SHOP_BANNER_SEEN = 'RETAILER_PORTAL_TOP_SHOP_BANNER_SEEN',
    /**
     * Set when the retailer has performed certain actions on the site (eg. has searched products)
     * @deprecated
     */
    SHOULD_DISPLAY_INTERNATIONAL_BUYING_MODAL = 'SHOULD_DISPLAY_INTERNATIONAL_BUYING_MODAL',
    /**
     * Set when the retailer has seen the international buying promotional modal
     */
    INTERNATIONAL_BUYING_MODAL_SEEN = 'INTERNATIONAL_BUYING_MODAL_SEEN',
    /**
     * @deprecated
     */
    INSIDER_BRAND_REFRESH_ANNOUNCEMENT_MODAL_SEEN = 'INSIDER_BRAND_REFRESH_ANNOUNCEMENT_MODAL_SEEN',
    /**
     * @deprecated
     */
    INSIDER_BRAND_REFRESH_ANNOUNCEMENT_TOOLTIP_SEEN = 'INSIDER_BRAND_REFRESH_ANNOUNCEMENT_TOOLTIP_SEEN',
    HAS_VISITED_CATEGORY_SEARCH_PAGES = 'HAS_VISITED_CATEGORY_SEARCH_PAGES',
    /**
     * Top shop announcement was rolled back
     * @deprecated
     */
    MOBILE_HOME_FEED_TOP_SHOP_ANNOUNCEMENT = 'MOBILE_HOME_FEED_TOP_SHOP_ANNOUNCEMENT',
    FIRST_ORDER_INCENTIVE_MODAL_DISMISS = 'FIRST_ORDER_INCENTIVE_MODAL_DISMISS',
    OPENING_ORDER_DISCOUNT_ELIGIBILITY_PROCESSED = 'OPENING_ORDER_DISCOUNT_ELIGIBILITY_PROCESSED',
    FIRST_ORDER_INCENTIVE_COUNTDOWN_MODAL_DISMISS = 'FIRST_ORDER_INCENTIVE_COUNTDOWN_MODAL_DISMISS',
    HOLIDAY_EXTENDED_WINDOW_START_SEEN = 'HOLIDAY_EXTENDED_WINDOW_START_SEEN',
    HOLIDAY_EXTENDED_WINDOW_END_SEEN = 'HOLIDAY_EXTENDED_WINDOW_END_SEEN',
    /**
     * Set when the retailer dismisses the Top Shop banner in retailer portal on Top Shop page
     */
    RETAILER_PORTAL_TOP_SHOP_BANNER_DISMISSED = 'RETAILER_PORTAL_TOP_SHOP_BANNER_DISMISSED',
    /**
     * Set when the retailer sees the Top Shop banner in retailer portal on all brands page page
     */
    RETAILER_PORTAL_ALL_BRANDS_PAGE_TOP_SHOP_BANNER_SEEN = 'RETAILER_PORTAL_ALL_BRANDS_PAGE_TOP_SHOP_BANNER_SEEN',
    /**
     * Set when the retailer dismisses the Top Shop banner on all brands page in retailer portal
     */
    RETAILER_PORTAL_ALL_BRANDS_PAGE_TOP_SHOP_BANNER_DISMISSED = 'RETAILER_PORTAL_ALL_BRANDS_PAGE_TOP_SHOP_BANNER_DISMISSED',
    /**
     * Set when the retailer has seen the R2B attribution revamp modal
     */
    R2B_ATTRIBUTION_REVAMP_MODAL_SEEN = 'R2B_ATTRIBUTION_REVAMP_MODAL_SEEN',
    LAST_CHARGE_ALTERNATIVE_CARD_NOTIFICATION_SENT = 'LAST_CHARGE_ALTERNATIVE_CARD_NOTIFICATION_SENT',
    OPENING_ORDER_DISCOUNT_WELCOME_EMAIL_SENT = 'OPENING_ORDER_DISCOUNT_WELCOME_EMAIL_SENT',
    OPENING_ORDER_DISCOUNT_COUNT_DOWN_EMAIL_SENT = 'OPENING_ORDER_DISCOUNT_COUNT_DOWN_EMAIL_SENT',
    APP_CAT_NAV_WAREHOUSE_SALE_BANNER_DISMISSED = 'APP_CAT_NAV_WAREHOUSE_SALE_BANNER_DISMISSED',
    /**
     * Set when retailer sees the free shipping and duties homepage banner
     */
    USER_HAS_SEEN_FREE_SHIPPING_DUTIES_HOMEPAGE_BANNER = 'USER_HAS_SEEN_FREE_SHIPPING_DUTIES_HOMEPAGE_BANNER',
    /**
     * Set when retailer sees the free shipping and duties notification in the location filter
     */
    USER_HAS_SEEN_FREE_SHIPPING_DUTIES_INFO_IN_LOCATION_FILTER = 'USER_HAS_SEEN_FREE_SHIPPING_DUTIES_INFO_IN_LOCATION_FILTER',
    /**
     * Set when retailer sees the free shipping and duties homefeed banner
     */
    USER_HAS_SEEN_FREE_SHIPPING_DUTIES_HOME_FEED_BANNER = 'USER_HAS_SEEN_FREE_SHIPPING_DUTIES_HOME_FEED_BANNER',
    RE_ENGAGEMENT_INCENTIVE_MODAL_DISMISS = 'RE_ENGAGEMENT_INCENTIVE_MODAL_DISMISS',
    SURFACE_INSIDER_SHIPPING_SAVING = 'SURFACE_INSIDER_SHIPPING_SAVING',
    /**
     * @deprecated
     */
    RETAILER_BUCKETED_INTO_FFD_EXPERIMENT = 'RETAILER_BUCKETED_INTO_FFD_EXPERIMENT',
    /**
     * Set when retailer dismiss the mid price point plus top banner on mobile app
     */
    MID_PRICE_POINT_PLUS_TOP_BANNER_DISMISSED = 'MID_PRICE_POINT_PLUS_TOP_BANNER_DISMISSED',
    HW2021_RETAILER_PRODUCT_RECOMMENDATIONS_INSPIRE_PAGE_ONBOARDING_COMPLETED = 'HW2021_RETAILER_PRODUCT_RECOMMENDATIONS_INSPIRE_PAGE_ONBOARDING_COMPLETED',
    RETAILER_LANGUAGE_UPDATE_ANNOUNCEMENT_DISMISSED = 'RETAILER_LANGUAGE_UPDATE_ANNOUNCEMENT_DISMISSED',
    MOBILE_MARKET_LIST_VISITED_FFW_2022 = 'MOBILE_MARKET_LIST_VISITED_FFW_2022',
    /**
     * @deprecated
     */
    PRE_EVENT_MODAL_CLICKED_FFW_2022 = 'PRE_EVENT_MODAL_CLICKED_FFW_2022',
    /**
     * @deprecated
     */
    PRE_EVENT_MODAL_DISMISSED_FFW_2022 = 'PRE_EVENT_MODAL_DISMISSED_FFW_2022',
    INSIDER_SIGNUP_EDUCATION_MODAL_SEEN = 'INSIDER_SIGNUP_EDUCATION_MODAL_SEEN',
    INSIDER_CATEGORY_PAGE_BANNER_DISMISSED = 'INSIDER_CATEGORY_PAGE_BANNER_DISMISSED',
    FIRST_INSIDER_ORDER = 'FIRST_INSIDER_ORDER',
    MY_BRANDS_FWM_HOMEPAGE_BANNER = 'MY_BRANDS_FWM_HOMEPAGE_BANNER',
    MY_BRANDS_ORDERS_BANNER = 'MY_BRANDS_ORDERS_BANNER',
    /**
     * @deprecated
     */
    MY_BRANDS_FOLLOWING_BANNER = 'MY_BRANDS_FOLLOWING_BANNER',
    MY_BRANDS_ONBOARDING = 'MY_BRANDS_ONBOARDING',
    RETAILER_LANGUAGE_DAN_UPDATE_ANNOUNCEMENT_DISMISSED = 'RETAILER_LANGUAGE_DAN_UPDATE_ANNOUNCEMENT_DISMISSED',
    RETAILER_LANGUAGE_SWE_UPDATE_ANNOUNCEMENT_DISMISSED = 'RETAILER_LANGUAGE_SWE_UPDATE_ANNOUNCEMENT_DISMISSED',
    RETAILER_UPDATE_BUSINESS_DETAILS_BANNER_DISMISSED = 'RETAILER_UPDATE_BUSINESS_DETAILS_BANNER_DISMISSED',
    RETAILER_UPDATE_BUSINESS_DETAILS_MODAL_DISMISSED = 'RETAILER_UPDATE_BUSINESS_DETAILS_MODAL_DISMISSED',
    MY_BRANDS_TOP_NAV_DISPLAYED = 'MY_BRANDS_TOP_NAV_DISPLAYED',
    /**
     * Increment when retailer sees Showroom inline banner in apparel categories c2 or c3
     * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=390%3A40725
     * @deprecated
     */
    SHOWROOM_APPAREL_INLINE_BANNER_SEEN_COUNT = 'SHOWROOM_APPAREL_INLINE_BANNER_SEEN_COUNT',
    /**
     * Increment when retailer sees Showroom apparel categories C2 title banner
     * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=390%3A40725
     * @deprecated
     */
    SHOWROOM_APPAREL_C2_TITLE_BANNER_SEEN_COUNT = 'SHOWROOM_APPAREL_C2_TITLE_BANNER_SEEN_COUNT',
    SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED = 'SHOWROOM_APPAREL_C2_TITLE_BANNER_DISMISSED',
    /**
     * Increment when retailer sees Showroom homepage educational banner
     * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=751%3A63615
     * @deprecated
     */
    SHOWROOM_PAGE_EDU_BANNER_SEEN_COUNT = 'SHOWROOM_PAGE_EDU_BANNER_SEEN_COUNT',
    /**
     * Increment when retailer sees Showroom product carousel in apparel categories
     * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=390%3A40968
     * @deprecated
     */
    SHOWROOM_APPAREL_PRODUCT_CAROUSEL_SEEN_COUNT = 'SHOWROOM_APPAREL_PRODUCT_CAROUSEL_SEEN_COUNT',
    /**
     * Set when a retailer have seen a brand page banner for FD Starter Collection
     * @deprecated
     */
    BRAND_PAGE_BANNER_STARTER_COLLECTION = 'BRAND_PAGE_BANNER_STARTER_COLLECTION',
    SEARCH_FILTER_PILL_INSIDER_BANNER_EUROPE = 'SEARCH_FILTER_PILL_INSIDER_BANNER_EUROPE',
    MY_BRANDS_ONBOARDING_ANDROID = 'MY_BRANDS_ONBOARDING_ANDROID',
    MY_BRANDS_ONBOARDING_IOS = 'MY_BRANDS_ONBOARDING_IOS',
    /**
     * Only ask retailer for ABN for once
     */
    RETAILER_HAS_BEEN_ASKED_FOR_ABN_NUMBER = 'RETAILER_HAS_BEEN_ASKED_FOR_ABN_NUMBER',
    /**
     * Increment when retailer sees Showroom apparel categories C2 title banner *
     */
    SHOWROOM_PAGE_NEW_RETAILER_EXPERIENCE = 'SHOWROOM_PAGE_NEW_RETAILER_EXPERIENCE',
    /**
     * count number of orders being placed with EU local discount
     */
    ORDER_PLACED_WITH_LOCAL_DISCOUNT = 'ORDER_PLACED_WITH_LOCAL_DISCOUNT',
    /**
     * count number of orders being placed with EU local discount
     */
    LOCAL_DISCOUNT_CATEGORY_UPSELL_BANNER_SHOWN = 'LOCAL_DISCOUNT_CATEGORY_UPSELL_BANNER_SHOWN',
    /**
     * Should be set when a retailer sees the local discount retailer modal for the first time
     */
    LOCAL_DISCOUNT_RETAILER_MODAL_SEEN = 'LOCAL_DISCOUNT_RETAILER_MODAL_SEEN',
    /**
     * Handles auto-showing of the tooltip for purchase order input.
     * @deprecated
     */
    ORDERS_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN = 'ORDERS_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN',
    /**
     * @deprecated
     */
    ORDER_DETAILS_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN = 'ORDER_DETAILS_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN',
    /**
     * @deprecated
     */
    CHECKOUT_CONFIRMATION_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN = 'CHECKOUT_CONFIRMATION_PAGE_PURCHASE_ORDER_TOOLTIP_SEEN',
    /**
     * Increment when retailer sees Showroom Apparel C1 title banner
     * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=390%3A40968
     */
    SHOWROOM_APPAREL_C1_TITLE_BANNER = 'SHOWROOM_APPAREL_C1_TITLE_BANNER',
    /**
     * Increment when retailer sees Showroom inline banner in apparel categories c2 or c3
     * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=390%3A40725
     */
    SHOWROOM_APPAREL_INLINE_BANNER = 'SHOWROOM_APPAREL_INLINE_BANNER',
    /**
     * Increment when retailer sees Showroom apparel categories C2 title banner
     * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=390%3A40725
     */
    SHOWROOM_APPAREL_C2_TITLE_BANNER = 'SHOWROOM_APPAREL_C2_TITLE_BANNER',
    /**
     * Increment when retailer sees Showroom homepage educational banner
     * https:www.figma.com/file/nMAgBhL6oxN8dZr6zJxSAS/Showroom-v2?node-id=751%3A63615
     */
    SHOWROOM_HOMEPAGE_EDU_BANNER = 'SHOWROOM_HOMEPAGE_EDU_BANNER',
    /**
     * Retailer has seen onboarding for new features enabled by setting IMPROVE_CART_NAV_220314
     */
    IMPROVE_CART_NAV_220314_ONBOARDING_SEEN = 'IMPROVE_CART_NAV_220314_ONBOARDING_SEEN',
    POS_SETTINGS_TOOLTIP_DISMISSED = 'POS_SETTINGS_TOOLTIP_DISMISSED',
    /**
     * Handles auto-showing of the tooltip for the new order & reviews page.
     */
    ORDERS_PAGE_SORT_BY_SHIPMENT_TOOLTIP_SEEN = 'ORDERS_PAGE_SORT_BY_SHIPMENT_TOOLTIP_SEEN',
    /**
     * Number of times retailer has seen Insider filter pill tooltip, hide the tooltip after a threshold
     */
    INSIDER_FILTER_PILL_TOOLTIP_SEEN = 'INSIDER_FILTER_PILL_TOOLTIP_SEEN',
    /**
     * Retailer dismissed Insider filter pill tooltip, no longer show it again
     */
    INSIDER_FILTER_PILL_TOOLTIP_DISMISSED = 'INSIDER_FILTER_PILL_TOOLTIP_DISMISSED',
    /**
     * Retailer has added brands to My Market List during FSM'22
     */
    MY_MARKET_LIST_USED_FSM_22 = 'MY_MARKET_LIST_USED_FSM_22',
    /**
     * Track if retailer has dismissed top message banner for apparel related content on mobile app
     * https:www.figma.com/file/BGhv0oPBg53qzT8GarFkgN/Apparel-New-User-Experience?node-id=1578%3A34257
     * @deprecated
     */
    APP_APPAREL_C1_DISMISSIBLE_TOP_BANNER = 'APP_APPAREL_C1_DISMISSIBLE_TOP_BANNER',
    /**
     * @deprecated
     */
    APP_APPAREL_C2_DISMISSIBLE_TOP_BANNER = 'APP_APPAREL_C2_DISMISSIBLE_TOP_BANNER',
    /**
     * @deprecated
     */
    APP_APPAREL_C3_DISMISSIBLE_TOP_BANNER = 'APP_APPAREL_C3_DISMISSIBLE_TOP_BANNER',
    /**
     * @deprecated
     */
    APP_APPAREL_SEARCH_DISMISSIBLE_TOP_BANNER = 'APP_APPAREL_SEARCH_DISMISSIBLE_TOP_BANNER',
    /**
     * @deprecated
     */
    APP_CORE_CATEGORIES_APPAREL_DISMISSIBLE_TOP_BANNER = 'APP_CORE_CATEGORIES_APPAREL_DISMISSIBLE_TOP_BANNER',
    /**
     * @deprecated
     */
    APP_CORE_CATEGORIES_APPAREL_DISMISSIBLE_TOP_BANNER_SEEN = 'APP_CORE_CATEGORIES_APPAREL_DISMISSIBLE_TOP_BANNER_SEEN',
    R2B_CREDIT_REDUCTION_INFO_MODAL_SEEN = 'R2B_CREDIT_REDUCTION_INFO_MODAL_SEEN',
    /**
     * In order to handle unique indexes correctly, we need MySQL to store an actual value for nulls
     * @deprecated
     */
    NO_RETAILER_MILESTONE = 'NO_RETAILER_MILESTONE',
    /**
     * Tracks how many times a user has viewed "Shop Latest Fashion" in search dropdown
     */
    LATEST_FASHION_DROPDOWN_SEEN_COUNT = 'LATEST_FASHION_DROPDOWN_SEEN_COUNT',
    /**
     * Tracks if a user has clicked on a category in "Shop Latest Fashion" search dropdown
     */
    LATEST_FASHION_DROPDOWN_CLICKED = 'LATEST_FASHION_DROPDOWN_CLICKED',
    /**
     * @deprecated
     */
    FD_CREDIT_MARKETPLACE_PIVOT_MODAL_DISMISS = 'FD_CREDIT_MARKETPLACE_PIVOT_MODAL_DISMISS',
    /**
     * Tracks if an Retailer Admin has seen the "Set Up Your Team" modal. Show up to 3 times(even if dismissed). Don't
     * show again if a team member is added (even if pending)
     * https:www.figma.com/file/dQJtJ8WL56u6xUGN9ehvTY/Multi-user-Alpha-1.0-handoff-(part-1)?node-id=2%3A4081
     */
    MULTI_USER_RETAILER_SET_UP_TEAM_MODAL_SEEN_COUNT = 'MULTI_USER_RETAILER_SET_UP_TEAM_MODAL_SEEN_COUNT',
    INSIDER_GROWTH_MEMBERSHIP_MIGRATION_SETTINGS_PAGE_ANNOUNCEMENT_SEEN = 'INSIDER_GROWTH_MEMBERSHIP_MIGRATION_SETTINGS_PAGE_ANNOUNCEMENT_SEEN',
    /**
     * Tracks if the tooltip from the new buy it again page has been viewed by a retailer
     */
    BUY_IT_AGAIN_TOOLTIP_IS_VIEWED = 'BUY_IT_AGAIN_TOOLTIP_IS_VIEWED',
    /**
     * Use this milestone for the universal insider slim banner shown in the category page*
     * @deprecated
     */
    INSIDER_CATEGORY_PAGE_SLIM_BANNER_DISMISSED = 'INSIDER_CATEGORY_PAGE_SLIM_BANNER_DISMISSED',
    /**
     * Use this milestone for tracking if the retailer has seen the IDV modal *
     */
    IDV_MODAL_SEEN = 'IDV_MODAL_SEEN',
    /**
     * Retailer has dismissed the NAM subsidy pullback banner
     * @deprecated
     */
    RETAILER_NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED = 'RETAILER_NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED',
    /**
     * Retailer has seen the NAM subsidy pullback banner
     * @deprecated
     */
    RETAILER_NAM_SUBSIDY_PULLBACK_BANNER_SEEN = 'RETAILER_NAM_SUBSIDY_PULLBACK_BANNER_SEEN',
    /**
     * Retailer has seen the multi user education banner
     */
    RETAILER_MULTI_USER_EDUCATIONAL_BANNER_SEEN_COUNT = 'RETAILER_MULTI_USER_EDUCATIONAL_BANNER_SEEN_COUNT',
    /**
     * Retailer has seen the Insider top nav link for the first time
     */
    INSIDER_TOP_NAV_LINK_FIRST_TIME_VIEWED = 'INSIDER_TOP_NAV_LINK_FIRST_TIME_VIEWED',
    /**
     * Use this milestone for tracking if the retailer has added anything to cart *
     */
    ADDED_ITEM_TO_CART = 'ADDED_ITEM_TO_CART',
    /**
     * Use this milestone for tracking if the retailer received an auto-IDV request synchronously after sign up *
     */
    RECEIVED_POST_SIGNUP_AUTO_IDV = 'RECEIVED_POST_SIGNUP_AUTO_IDV',
    /**
     * Retailer has seen the tooltip for inventory levels on the buy it again page *
     */
    HAS_SEEN_INVENTORY_LEVEL_TOOLTIP = 'HAS_SEEN_INVENTORY_LEVEL_TOOLTIP',
    /**
     * Retailer has seen the tooltip for pending inventory level on the buy it again page *
     * @deprecated
     */
    HAS_SEEN_PENDING_INVENTORY_TOOLTIP_IN_BUY_IT_AGAIN_PAGE = 'HAS_SEEN_PENDING_INVENTORY_TOOLTIP_IN_BUY_IT_AGAIN_PAGE',
    /**
     * Retailer has seen warehouse sale promo modal *
     */
    HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22 = 'HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22',
    /**
     * Retailer has dismissed the buy it again page items in cart banner *
     */
    HAS_DISMISSED_BUY_IT_AGAIN_ITEMS_IN_CART_BANNER = 'HAS_DISMISSED_BUY_IT_AGAIN_ITEMS_IN_CART_BANNER',
    /**
     * Retailer has seen the ach upsell text in checkout page *
     */
    HAS_SEEN_ACH_UPSELL_TEXT = 'HAS_SEEN_ACH_UPSELL_TEXT',
    /**
     * Force retailer to be eligible for credit application / terms limit increase *
     */
    FORCE_ELIGIBLE_FOR_TERMS_LIMIT_INCREASE = 'FORCE_ELIGIBLE_FOR_TERMS_LIMIT_INCREASE',
    /**
     * Track if retailer has seen/dismissed Insider growth - profitability membership migration related contents
     */
    INSIDER_GROWTH_MIGRATION_ACCOUNT_DROPDOWN_NOTICE_SEEN = 'INSIDER_GROWTH_MIGRATION_ACCOUNT_DROPDOWN_NOTICE_SEEN',
    /**
     * @deprecated
     */
    INSIDER_GROWTH_MIGRATION_PROMO_MODAL_SEEN = 'INSIDER_GROWTH_MIGRATION_PROMO_MODAL_SEEN',
    INSIDER_GROWTH_MIGRATION_TOOLTIP_SEEN = 'INSIDER_GROWTH_MIGRATION_TOOLTIP_SEEN',
    INSIDER_GROWTH_MIGRATION_TOOLTIP_DISMISSED = 'INSIDER_GROWTH_MIGRATION_TOOLTIP_DISMISSED',
    /**
     * @deprecated
     */
    INSIDER_GROWTH_MIGRATION_MOBILE_BANNER_SEEN = 'INSIDER_GROWTH_MIGRATION_MOBILE_BANNER_SEEN',
    /**
     * Retailer has seen the sunset local discount modal
     */
    SUNSET_LOCAL_DISCOUNT_RETAILER_MODAL_SEEN = 'SUNSET_LOCAL_DISCOUNT_RETAILER_MODAL_SEEN',
    /**
     * Retailer has seen the tool tip on POS manager page regarding number of items can be linked*
     */
    POS_INVENTORY_MANAGEMENT_AVAILABLE_TO_LINK_TOOLTIP_IS_VIEWED = 'POS_INVENTORY_MANAGEMENT_AVAILABLE_TO_LINK_TOOLTIP_IS_VIEWED',
    /**
     * Retailer has resumed Insider membership *
     */
    RETAILER_INSIDER_MEMBERSHIP_RESUMED = 'RETAILER_INSIDER_MEMBERSHIP_RESUMED',
    /**
     * Retailer has resumed Insider membership and seen the Settings page restored state *
     */
    RETAILER_INSIDER_MEMBERSHIP_RESUMED_SEEN = 'RETAILER_INSIDER_MEMBERSHIP_RESUMED_SEEN',
    /**
     * Retailer has closed out of or won their Fairdle game today
     * so they should not see it again until tomorrow
     * @deprecated
     */
    RETAILER_HAS_DISMISSED_OR_WON_FAIRDLE_TODAY = 'RETAILER_HAS_DISMISSED_OR_WON_FAIRDLE_TODAY',
    /**
     * Retailer has seen the PREPAID_CARDS_RESTRICTED_MODAL promo modal *
     * @deprecated
     */
    PREPAID_CARDS_RESTRICTED_MODAL_SEEN = 'PREPAID_CARDS_RESTRICTED_MODAL_SEEN',
    /**
     * Retailer user has seen the my team page
     */
    RETAILER_MY_TEAM_PAGE_SEEN = 'RETAILER_MY_TEAM_PAGE_SEEN',
    /**
     * Retailer has dismissed mobile low minimum callout banner *
     */
    APP_LOW_MINIMUM_CALLOUT_BANNER_DISMISSED = 'APP_LOW_MINIMUM_CALLOUT_BANNER_DISMISSED',
    /**
     * Retailer multi user GTM email has been sent
     */
    RETAILER_MULTI_USERS_GTM_EMAIL_SENT = 'RETAILER_MULTI_USERS_GTM_EMAIL_SENT',
    /**
     * Retailer has went through auto-confirmation and auto-IDV job after the first order
     * but found IDV for the retailer need to be done manually
     */
    RETAILER_NEEDS_MANUAL_IDV = 'RETAILER_NEEDS_MANUAL_IDV',
    /**
     * Order confirmation email with team section sent to user
     */
    ORDER_CONFIRMATION_EMAIL_SENT_WITH_TEAM_SECTION = 'ORDER_CONFIRMATION_EMAIL_SENT_WITH_TEAM_SECTION',
    /**
     * Retailer has dismissed the filter redesign educational banner for web. This milestone will be set by FE *
     */
    FILTER_REDESIGN_EDUCATIONAL_BANNER_WEB_DISMISSED = 'FILTER_REDESIGN_EDUCATIONAL_BANNER_WEB_DISMISSED',
    /**
     * Retailer has dismissed the filter redesign educational banner for mobile. This milestone will be set by FE *
     */
    FILTER_REDESIGN_EDUCATIONAL_BANNER_MOBILE_DISMISSED = 'FILTER_REDESIGN_EDUCATIONAL_BANNER_MOBILE_DISMISSED',
    /**
     * Retailer multi users gtm setting assigned to treatment bucket
     */
    RETAILER_MULTI_USERS_GTM_SETTING_ASSIGNED = 'RETAILER_MULTI_USERS_GTM_SETTING_ASSIGNED',
    /**
     * Onboarding tooltip tour for POS integration
     */
    POS_INTEGRATED_RETAILER_HAS_SEEN_ONBOARDING_TOOLTIPS = 'POS_INTEGRATED_RETAILER_HAS_SEEN_ONBOARDING_TOOLTIPS',
    /**
     * When a retailer visits the POS integration info page on mobile web
     */
    POS_INTEGRATION_SPLASH_PAGE_VISITED_ON_MOBILE_WEB = 'POS_INTEGRATION_SPLASH_PAGE_VISITED_ON_MOBILE_WEB',
    /**
     * Set when the retailer sees the referral policy TOS modal
     */
    R2B_REFERRAL_POLICY_TOS_MODAL_SEEN = 'R2B_REFERRAL_POLICY_TOS_MODAL_SEEN',
    /**
     * Set when the retailer sees the markup filter tooltip
     * @deprecated
     */
    MARKUP_FILTER_TOOLTIP_SEEN = 'MARKUP_FILTER_TOOLTIP_SEEN',
    /**
     * Set when the retailer sees brand location filter
     */
    BRAND_LOCATION_FILTER_SEEN = 'BRAND_LOCATION_FILTER_SEEN',
    /**
     * Set when the retailer sees brand location tooltip
     */
    BRAND_LOCATION_FILTER_TOOLTIP_SEEN = 'BRAND_LOCATION_FILTER_TOOLTIP_SEEN',
    /**
     * Set when the retailer dismisses the brand location tooltip
     */
    BRAND_LOCATION_FILTER_TOOLTIP_DISMISSED = 'BRAND_LOCATION_FILTER_TOOLTIP_DISMISSED',
    /**
     * Set when the retailer dismisses the markup filter tooltip
     * @deprecated
     */
    MARKUP_FILTER_TOOLTIP_DISMISSED = 'MARKUP_FILTER_TOOLTIP_DISMISSED',
    /**
     * Set when retailer has a LINKED POS integration prior to retailer POS onboarding flow was introduced
     */
    RETAILER_POS_INTEGRATION_LINKED_BEFORE_ONBOARDING_FLOW_INTRODUCED = 'RETAILER_POS_INTEGRATION_LINKED_BEFORE_ONBOARDING_FLOW_INTRODUCED',
    INSIDER_FRAMANY_NORDICS_PRE_LAUNCH_ANNOUNCEMENT_MODAL_SEEN = 'INSIDER_FRAMANY_NORDICS_PRE_LAUNCH_ANNOUNCEMENT_MODAL_SEEN',
    /**
     * Set when retailer dismisses the shipped filter tooltip on the orders page
     */
    SHIPPED_FILTER_TOOLTIP_DISMISSED = 'SHIPPED_FILTER_TOOLTIP_DISMISSED',
    /**
     * Set when the retailer dismisses the markup filter badge
     * @deprecated
     */
    MARKUP_FILTER_BADGE_DISMISSED = 'MARKUP_FILTER_BADGE_DISMISSED',
    /**
     * Set when retailer views the Insider Framany+Nordics full launch announcement modal *
     */
    INSIDER_FRAMANY_NORDICS_POST_LAUNCH_ANNOUNCEMENT_MODAL_SEEN = 'INSIDER_FRAMANY_NORDICS_POST_LAUNCH_ANNOUNCEMENT_MODAL_SEEN',
    /**
     * Set when retailer has seen the first open with Faire upsell moment *
     */
    OPEN_WITH_FAIRE_UPSELL_NUDGE_1_SEEN = 'OPEN_WITH_FAIRE_UPSELL_NUDGE_1_SEEN',
    /**
     * Set when retailer has seen the second open with Faire upsell moment *
     */
    OPEN_WITH_FAIRE_UPSELL_NUDGE_2_SEEN = 'OPEN_WITH_FAIRE_UPSELL_NUDGE_2_SEEN',
    RETAILER_HAS_SEEN_PAYMENT_PLAN_PAYMENT_FAILED_MODAL = 'RETAILER_HAS_SEEN_PAYMENT_PLAN_PAYMENT_FAILED_MODAL',
    RETAILER_HAS_SEEN_PAYMENT_PLAN_FULLY_PAID_MODAL = 'RETAILER_HAS_SEEN_PAYMENT_PLAN_FULLY_PAID_MODAL',
    MULTI_USER_SUBMIT_FOR_CHECKOUT_INFO_TOOLTIP_DISMISSED = 'MULTI_USER_SUBMIT_FOR_CHECKOUT_INFO_TOOLTIP_DISMISSED',
    MULTI_USER_BRAND_PAGE_COLLABORATOR_INFO_TOOLTIP_DISMISSED = 'MULTI_USER_BRAND_PAGE_COLLABORATOR_INFO_TOOLTIP_DISMISSED',
    /**
     * @deprecated
     */
    RECORDED_SAMPLE_V2_TREATMENT = 'RECORDED_SAMPLE_V2_TREATMENT',
    /**
     * The number of times the user has seen the homepage multi user first time landing education banner (either on web or mobile apps) *
     */
    RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER_SEEN = 'RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER_SEEN',
    MARKETING_EMAIL_OPT_IN_DISMISSED = 'MARKETING_EMAIL_OPT_IN_DISMISSED',
    MARKETING_EMAIL_OPT_IN_SUBMITTED = 'MARKETING_EMAIL_OPT_IN_SUBMITTED',
    MARKETING_EMAIL_OPT_IN_MOBILE_RENDERED = 'MARKETING_EMAIL_OPT_IN_MOBILE_RENDERED',
    MARKETING_EMAIL_OPT_IN_COLLAPSED = 'MARKETING_EMAIL_OPT_IN_COLLAPSED',
    MARKETING_EMAIL_OPT_IN_REMINDERS_BEGUN = 'MARKETING_EMAIL_OPT_IN_REMINDERS_BEGUN',
    MARKETING_EMAIL_PREFERENCES_SET = 'MARKETING_EMAIL_PREFERENCES_SET',
    FIRST_ORDER_INCENTIVE_AUTO_EXTEND_MODAL_DISMISS = 'FIRST_ORDER_INCENTIVE_AUTO_EXTEND_MODAL_DISMISS',
    SAMPLE_BRANDS_HOMEPAGE_CAROUSEL_SEEN = 'SAMPLE_BRANDS_HOMEPAGE_CAROUSEL_SEEN',
    COMMISSION_UPDATE_REQUEST_BANNER_DISMISSED = 'COMMISSION_UPDATE_REQUEST_BANNER_DISMISSED',
    /**
     * Retailer will be sent an auto-IDV request
     */
    RETAILER_NEEDS_AUTO_IDV = 'RETAILER_NEEDS_AUTO_IDV',
    /**
     * Set when retailer has seen the nudge to apply for OwF 2 weeks before opening *
     */
    OPEN_WITH_FAIRE_PRE_OPENING_NUDGE_SEEN = 'OPEN_WITH_FAIRE_PRE_OPENING_NUDGE_SEEN',
    /**
     * Set when retailer has seen the nudge to apply for OwF a month after opening *
     */
    OPEN_WITH_FAIRE_POST_OPENING_NUDGE_SEEN = 'OPEN_WITH_FAIRE_POST_OPENING_NUDGE_SEEN',
    /**
     * @deprecated
     */
    RETAILER_OWF_IDV_TIER_3_SET = 'RETAILER_OWF_IDV_TIER_3_SET',
    /**
     * Set when retailer has seen an Eco-friendly category page *
     */
    HAS_SEEN_ECO_FRIENDLY_CATEGORY_PAGE = 'HAS_SEEN_ECO_FRIENDLY_CATEGORY_PAGE',
    /**
     * Set when retailer sends referral bonus follow-up message *
     */
    HAS_SENT_REFERRAL_BONUS_FOLLOW_UP = 'HAS_SENT_REFERRAL_BONUS_FOLLOW_UP',
    /**
     * Set when retailer has seen referral reengagement banner *
     */
    HAS_SEEN_REFERRAL_REENGAGEMENT_BANNER = 'HAS_SEEN_REFERRAL_REENGAGEMENT_BANNER',
    /**
     * Set when retailer has dismissed eco friendly GTM banner *
     */
    ECO_FRIENDLY_GTM_BANNER_DISMISSED = 'ECO_FRIENDLY_GTM_BANNER_DISMISSED',
    /**
     * Set when retailer has scheduled to receive OwF apply again reminder email *
     */
    OWF_APPLY_AGAIN_REMINDER_SCHEDULED = 'OWF_APPLY_AGAIN_REMINDER_SCHEDULED',
    /**
     * Set when OwF apply again reminder email is sent to retailer *
     */
    OWF_APPLY_AGAIN_REMINDER_SENT = 'OWF_APPLY_AGAIN_REMINDER_SENT',
    /**
     * Set when retailer has seen or dismissed ach messaging banner on orders page *
     */
    HAS_CLOSED_ORDERS_PAGE_ACH_BANNER = 'HAS_CLOSED_ORDERS_PAGE_ACH_BANNER',
    /**
     * Set when retailer has dismissed eco friendly GTM banner *
     */
    ECO_FRIENDLY_CATEGORY_PAGE_GTM_BANNER_DISMISSED = 'ECO_FRIENDLY_CATEGORY_PAGE_GTM_BANNER_DISMISSED',
    /**
     * Set when retailer user viewed OwF R2R homepage banner *
     */
    SEEN_OWF_R2R_HOMEPAGE_BANNER = 'SEEN_OWF_R2R_HOMEPAGE_BANNER',
    /**
     * Set when retailer has seen the first referral adoption nudge *
     */
    FIRST_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN = 'FIRST_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN',
    /**
     * Set when retailer has seen the second referral adoption nudge *
     */
    SECOND_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN = 'SECOND_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN',
    /**
     * Set when retailer has seen the third referral adoption nudge *
     */
    THIRD_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN = 'THIRD_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_SEEN',
    /**
     * Set when we sent the first retailer nudge email *
     */
    FIRST_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT = 'FIRST_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT',
    /**
     * Set when we sent the second retailer nudge email *
     */
    SECOND_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT = 'SECOND_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT',
    /**
     * Set when we sent the third retailer nudge email *
     */
    THIRD_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT = 'THIRD_KNOWN_REFERRAL_ADOPTION_RETAILER_NUDGE_EMAIL_SENT',
    /**
     * milestone for FE increment on new engagement sessions *
     */
    KNOWN_REFERRAL_ADOPTION_TRACKING_ENGAGEMENT_SESSION = 'KNOWN_REFERRAL_ADOPTION_TRACKING_ENGAGEMENT_SESSION',
    /**
     * Set when retailer has sent the invite email *
     */
    KNOWN_REFERRER_ADOPTION_HAS_SENT_INVITE = 'KNOWN_REFERRER_ADOPTION_HAS_SENT_INVITE',
    /**
     * Set when a retailer has acknowleged the F&B Category Tree changes *
     */
    FB_CAT_TREE_NUX_DISMISSED = 'FB_CAT_TREE_NUX_DISMISSED',
    /**
     * Set when retailer has seen known referral adoption banner *
     */
    HAS_SEEN_KNOWN_REFERRER_ADOPTION_BANNER = 'HAS_SEEN_KNOWN_REFERRER_ADOPTION_BANNER',
    /**
     * Set when retailer has seen the homepage banner on web or mobile app in the special occasion feature *
     */
    HOLIDAY_PROMO_BANNER_VIEWED = 'HOLIDAY_PROMO_BANNER_VIEWED',
    /**
     * Set when retailer has clicked the homepage banner on web or mobile app in the special occasion feature *
     */
    HOLIDAY_PROMO_BANNER_CLICKED = 'HOLIDAY_PROMO_BANNER_CLICKED',
    /**
     * Set when a user has tapped the 'refer brands' CTA on mobile app *
     */
    OPEN_WITH_FAIRE_CTA_MOBILE_TAPPED = 'OPEN_WITH_FAIRE_CTA_MOBILE_TAPPED',
    /**
     * Set when a user has tapped the 'refer retailers' CTA on mobile app *
     */
    REFER_RETAILERS_CTA_MOBILE_TAPPED = 'REFER_RETAILERS_CTA_MOBILE_TAPPED',
    /**
     * Handles the state for the SMS Opt In Nudge Modal *
     */
    MARKETING_SMS_OPT_IN_DISMISSED = 'MARKETING_SMS_OPT_IN_DISMISSED',
    MARKETING_SMS_OPT_IN_COLLAPSED = 'MARKETING_SMS_OPT_IN_COLLAPSED',
    MARKETING_SMS_OPT_IN_SUBMITTED = 'MARKETING_SMS_OPT_IN_SUBMITTED',
    MARKETING_SMS_OPT_IN_FIRST_TRIGGERED = 'MARKETING_SMS_OPT_IN_FIRST_TRIGGERED',
    /**
     * This is incremented when the retailer sees the new badge that hightlights
     * guaranteed shipping on the checkout page. See the mocks here:
     * https:www.figma.com/file/24vrtwmeKfAK9Uc7OTSJXu/Retailer-shipping-explorations?type=design&node-id=853-68478&mode=design&t=bOSoRu44VgxDJHLZ-0
     */
    NEW_GUARANTEED_SHIPPING_BADGE_SEEN = 'NEW_GUARANTEED_SHIPPING_BADGE_SEEN',
    /**
     * Set when retailer interacts the ACH PLI offer promo modals and banners *
     */
    HAS_SEEN_ACH_PROACTIVE_LIMIT_INCREASE_MODAL = 'HAS_SEEN_ACH_PROACTIVE_LIMIT_INCREASE_MODAL',
    HAS_CLOSED_ACH_PROACTIVE_LIMIT_INCREASE_ORDERS_PAGE_BANNER = 'HAS_CLOSED_ACH_PROACTIVE_LIMIT_INCREASE_ORDERS_PAGE_BANNER',
    ACH_PROACTIVE_LIMIT_INCREASE_ACCOUNT_DROPDOWN_OFFER_VIEW = 'ACH_PROACTIVE_LIMIT_INCREASE_ACCOUNT_DROPDOWN_OFFER_VIEW',
    /**
     * Set when the retailer dismisses the FD Marketplace Discount next session modal *
     */
    FD_MARKETPLACE_DISCOUNT_MODAL_DISMISSED = 'FD_MARKETPLACE_DISCOUNT_MODAL_DISMISSED',
    /**
     * Set when the retailer sees the Insider Terms and Conditions modal *
     */
    INSIDER_REVIEW_TERMS_AND_CONDITIONS_MODAL_SEEN = 'INSIDER_REVIEW_TERMS_AND_CONDITIONS_MODAL_SEEN',
    /**
     * Milestones for showing different nudges as part of referral reengagement *
     */
    FIRST_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN = 'FIRST_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN',
    SECOND_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN = 'SECOND_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN',
    THIRD_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN = 'THIRD_REFERRAL_REENGAGEMENT_RETAILER_NUDGE_SEEN',
    /**
     * Handles silencing multi user GTM entry points *
     */
    MULTI_USER_GTM_PDP_AND_BRAND_PAGE_SILENCING = 'MULTI_USER_GTM_PDP_AND_BRAND_PAGE_SILENCING',
    MULTI_USER_GTM_INVOICE_AND_ORDER_PAGE_SILENCING = 'MULTI_USER_GTM_INVOICE_AND_ORDER_PAGE_SILENCING',
    MULTI_USER_GTM_ACCOUNT_SETTINGS_DROPDOWN_SILENCING = 'MULTI_USER_GTM_ACCOUNT_SETTINGS_DROPDOWN_SILENCING',
    MULTI_USER_GTM_MESSENGER_BANNER_DISMISSED = 'MULTI_USER_GTM_MESSENGER_BANNER_DISMISSED',
    /**
     * Set when the retailer dismisses the FD Marketplace Discount nudge modal *
     */
    FD_MARKETPLACE_DISCOUNT_NUDGE_MODAL_DISMISSED = 'FD_MARKETPLACE_DISCOUNT_NUDGE_MODAL_DISMISSED',
    /**
     * Milestones for retailers who have installed the retailer Faire app on Shopify
     */
    SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES = 'SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES',
    SHOPIFY_LEAD_UPGRADED_PLAN = 'SHOPIFY_LEAD_UPGRADED_PLAN',
    /**
     * Milestone for retailer multi-user GTMv2 for when a retailer has been assigned to the treatment bucket
     */
    RETAILER_MULTI_USERS_GTM_V2_SETTING_ASSIGNED = 'RETAILER_MULTI_USERS_GTM_V2_SETTING_ASSIGNED',
    /**
     * Milestone for retailer multi-user GTMv2 for when the announcement e-mail has been sent.
     */
    RETAILER_MULTI_USERS_GTM_V2_EMAIL_SENT = 'RETAILER_MULTI_USERS_GTM_V2_EMAIL_SENT',
    /**
     * Milestone for when retailer dismisses banner to prompt review for retailer Faire app on Shopify
     */
    SHOPIFY_FEEDBACK_BANNER_DISMISSED = 'SHOPIFY_FEEDBACK_BANNER_DISMISSED',
    /**
     * Milestone for when a retailer has seen the guidepost renaming banner.
     */
    RENAME_GUIDEPOST_BANNER_SEEN = 'RENAME_GUIDEPOST_BANNER_SEEN',
    /**
     * Milestone for when retailer dismisses the guidepost renaming banner.
     */
    RENAME_GUIDEPOST_BANNER_DISMISSED = 'RENAME_GUIDEPOST_BANNER_DISMISSED',
    /**
     * Set when retailer interacts the ACH TPA (terms pre approval) offer promo modals and banners
     * ACH_TERMS_PRE_APPROVAL is retailers are required linking ACH to get terms
     * TERMS_PRE_APPROVAL is retailers are granted terms without requiring ACH *
     */
    HAS_SEEN_ACH_TERMS_PRE_APPROVAL_MODAL = 'HAS_SEEN_ACH_TERMS_PRE_APPROVAL_MODAL',
    HAS_SEEN_TERMS_PRE_APPROVAL_MODAL = 'HAS_SEEN_TERMS_PRE_APPROVAL_MODAL',
    HAS_CLOSED_ACH_TERMS_PRE_APPROVAL_ORDERS_PAGE_BANNER = 'HAS_CLOSED_ACH_TERMS_PRE_APPROVAL_ORDERS_PAGE_BANNER',
    ACH_TERMS_PRE_APPROVAL_ACCOUNT_DROPDOWN_OFFER_VIEW = 'ACH_TERMS_PRE_APPROVAL_ACCOUNT_DROPDOWN_OFFER_VIEW',
    ACH_TERMS_PRE_APPROVAL_CHECKOUT_OFFER_VIEW = 'ACH_TERMS_PRE_APPROVAL_CHECKOUT_OFFER_VIEW',
    TERMS_PRE_APPROVAL_CHECKOUT_OFFER_VIEW = 'TERMS_PRE_APPROVAL_CHECKOUT_OFFER_VIEW',
    /**
     * Set when retailer sees modal showing unlocked Faire benefits after converting to paid shopify plan.
     */
    SHOPIFY_ONBOARDING_BENEFITS_MODAL_SEEN = 'SHOPIFY_ONBOARDING_BENEFITS_MODAL_SEEN',
    /**
     * Handles silencing multi user GTM V2 entry points *
     */
    MULTI_USER_GTM_PDP_AND_BRAND_PAGE_V2_SILENCING = 'MULTI_USER_GTM_PDP_AND_BRAND_PAGE_V2_SILENCING',
    MULTI_USER_GTM_INVOICE_AND_ORDER_PAGE_V2_SILENCING = 'MULTI_USER_GTM_INVOICE_AND_ORDER_PAGE_V2_SILENCING',
    MULTI_USER_GTM_ACCOUNT_SETTINGS_DROPDOWN_V2_SILENCING = 'MULTI_USER_GTM_ACCOUNT_SETTINGS_DROPDOWN_V2_SILENCING',
    /**
     * Milestone for when retailer dismisses the pos new feature notification modal.
     */
    HAS_SEEN_POS_NEW_FEATURE_MODAL = 'HAS_SEEN_POS_NEW_FEATURE_MODAL',
    /**
     * Records dismissal of the top shop banner that explains the "top shop" toggle filter *
     */
    ELEVATE_TOP_SHOP_BANNER_DISMISSED = 'ELEVATE_TOP_SHOP_BANNER_DISMISSED',
    /**
     * Records the dismissal of the auto filter banner or people who don't want us to auto filter their searches *
     * @deprecated
     */
    AUTO_FILTER_BANNER_DISMISSED = 'AUTO_FILTER_BANNER_DISMISSED',
    /**
     * @deprecated
     */
    DO_NOT_AUTO_FILTER_SEARCH_RESULTS_FOR_RETAILER = 'DO_NOT_AUTO_FILTER_SEARCH_RESULTS_FOR_RETAILER',
    /**
     * Milestone for when retailer has seen the new feature notification in pos setting page.
     */
    HAS_SEEN_POS_NEW_FEATURE_NOTIFICATION = 'HAS_SEEN_POS_NEW_FEATURE_NOTIFICATION',
    /**
     * Milestone for when a retailer has seen the bestseller filter/sort notification.
     */
    BESTSELLER_SORT_FILTER_NOTIFICATION_SEEN = 'BESTSELLER_SORT_FILTER_NOTIFICATION_SEEN',
    /**
     * Milestone for when a retailer has dismissed the bestseller filter/sort notification.
     */
    BESTSELLER_SORT_FILTER_NOTIFICATION_DISMISSED = 'BESTSELLER_SORT_FILTER_NOTIFICATION_DISMISSED',
    /**
     * Milestone for when retailer has seen the New bestseller filter badge.
     */
    BESTSELLER_FILTER_BADGE_SEEN = 'BESTSELLER_FILTER_BADGE_SEEN',
    /**
     * Milestone for when a retailer has seen the eco-friendly homepage banner.
     */
    ECO_FRIENDLY_HOMEPAGE_BANNER_SEEN = 'ECO_FRIENDLY_HOMEPAGE_BANNER_SEEN',
    /**
     * Milestone for when a retailer has clicked on the eco-friendly homepage banner.
     */
    ECO_FRIENDLY_HOMEPAGE_BANNER_CLICKED = 'ECO_FRIENDLY_HOMEPAGE_BANNER_CLICKED',
    /**
     * Milestone for when a retailer has seen the eco-friendly category page top banner.
     */
    ECO_FRIENDLY_CATEGORY_PAGE_TOP_BANNER_SEEN = 'ECO_FRIENDLY_CATEGORY_PAGE_TOP_BANNER_SEEN',
    /**
     * Milestone for when a retailer has clicked on the eco-friendly category page top banner.
     */
    ECO_FRIENDLY_CATEGORY_PAGE_TOP_BANNER_CLICKED = 'ECO_FRIENDLY_CATEGORY_PAGE_TOP_BANNER_CLICKED',
    /**
     * Milestone for when a retailer has seen the eco-friendly category product results banner.
     */
    ECO_FRIENDLY_CATEGORY_PRODUCT_RESULTS_BANNER_SEEN = 'ECO_FRIENDLY_CATEGORY_PRODUCT_RESULTS_BANNER_SEEN',
    /**
     * Milestone for when a retailer has clicked on the eco-friendly category product results banner.
     */
    ECO_FRIENDLY_CATEGORY_PRODUCT_RESULTS_CLICKED = 'ECO_FRIENDLY_CATEGORY_PRODUCT_RESULTS_CLICKED',
    /**
     * Milestone for when a retailer has clicked on the bestsellers (c1) category educational banner.
     */
    APP_BESTSELLERS_EDUCATIONAL_BANNER_DISMISSED = 'APP_BESTSELLERS_EDUCATIONAL_BANNER_DISMISSED',
    /**
     * Milestone to check if retailer is in Terms Pre Approval (TPA) Treatment 2
     */
    HAS_ASSIGNED_TERMS_PRE_APPROVAL_BENEFITS = 'HAS_ASSIGNED_TERMS_PRE_APPROVAL_BENEFITS',
    /**
     * Milestone for when retailer has seen the SKU matching setting nudge
     */
    HAS_SEEN_SKU_MATCHING_SETTING_NUDGE = 'HAS_SEEN_SKU_MATCHING_SETTING_NUDGE',
    /**
     * Set when logged-out retailer clicks product tile
     */
    LOGGED_OUT_PRODUCT_TILE_CLICKED = 'LOGGED_OUT_PRODUCT_TILE_CLICKED',
    /**
     * Milestone to mark Faire Academy reengagement email has been sent to a retailer user
     */
    FAIRE_ACADEMY_REENGAGEMENT_EMAIL_SENT = 'FAIRE_ACADEMY_REENGAGEMENT_EMAIL_SENT',
    /**
     * Milestone for when retailer has dismissed the mobile brand page filters redesign banner
     */
    MOBILE_BRAND_PAGE_FILTERS_REDESIGN_BANNER_DISMISSED = 'MOBILE_BRAND_PAGE_FILTERS_REDESIGN_BANNER_DISMISSED',
    /**
     * Milestone for when retailer has seen the mobile brand page filters redesign banner
     */
    MOBILE_BRAND_PAGE_FILTERS_REDESIGN_BANNER_SEEN = 'MOBILE_BRAND_PAGE_FILTERS_REDESIGN_BANNER_SEEN',
    /**
     * Milestone for when retailer has seen the Faire Direct incentive modal
     */
    FAIRE_DIRECT_INCENTIVE_MODAL_DISMISS = 'FAIRE_DIRECT_INCENTIVE_MODAL_DISMISS',
    /**
     * Set when the retailer views the tooltip for the Insider Free Shipping Threshold coverage badge
     */
    INSIDER_THRESHOLD_BADGE_TOOLTIP_SEEN = 'INSIDER_THRESHOLD_BADGE_TOOLTIP_SEEN',
    /**
     * Set when the retailer dismisses the general expanding offer banner in stores page
     */
    STORES_PAGE_GENERAL_EXPANDING_OFFER_BANNER_DISMISSED = 'STORES_PAGE_GENERAL_EXPANDING_OFFER_BANNER_DISMISSED',
    /**
     * Set when the retailer dismisses the contextual expanding offer banner in stores page
     */
    STORES_PAGE_CONTEXTUAL_EXPANDING_OFFER_BANNER_DISMISSED = 'STORES_PAGE_CONTEXTUAL_EXPANDING_OFFER_BANNER_DISMISSED',
    /**
     * Set when the retailer dismisses the Evergreen First Order Incentive modal
     * @deprecated
     */
    EVERGREEN_FIRST_ORDER_INCENTIVE_MODAL_DISMISS = 'EVERGREEN_FIRST_ORDER_INCENTIVE_MODAL_DISMISS',
    /**
     * Set when the retailer views the tooltip for the Insider Free Shipping coverage badge
     */
    INSIDER_BADGE_TOOLTIP_SEEN = 'INSIDER_BADGE_TOOLTIP_SEEN',
    /**
     * Milestone to mark retailer expanding offer reminder email has been sent to a retailer user
     */
    RETAILER_EXPANDING_OFFER_REMINDER_EMAIL_SENT = 'RETAILER_EXPANDING_OFFER_REMINDER_EMAIL_SENT',
    /**
     * Milestone to mark retailer expanding offer series event has been published to Braze for a retailer user
     */
    RETAILER_EXPANDING_OFFER_EMAIL_EVENT_SENT = 'RETAILER_EXPANDING_OFFER_EMAIL_EVENT_SENT',
    /**
     * Milestone to mark retailers that have seen any category configured in TOP_PLACEMENT_CATEGORIES_FOR_YOU_NAV_NODES
     * @deprecated
     */
    TOP_PLACEMENT_CATEGORIES_FOR_YOU_NAV_NODES_SEEN = 'TOP_PLACEMENT_CATEGORIES_FOR_YOU_NAV_NODES_SEEN',
    /**
     * Milestone to mark brand sub user has seen or skipped the onboarding modal
     */
    BRAND_SUB_USER_ONBOARDING_MODAL_SEEN = 'BRAND_SUB_USER_ONBOARDING_MODAL_SEEN',
    /**
     * Milestone for when retailer dismisses banner to prompt review for retailer Faire app
     */
    POS_FEEDBACK_BANNER_DISMISSED = 'POS_FEEDBACK_BANNER_DISMISSED',
    /**
     * Set when retailer is shown the CARM nudge on checkout success page
     */
    CARM_NUDGE_VIEWED = 'CARM_NUDGE_VIEWED',
    /**
     * Set when retailer dismisses the CARM nudge on checkout success page
     */
    CARM_NUDGE_DISMISSED = 'CARM_NUDGE_DISMISSED',
    /**
     * Retailer interacted with POS guided tour
     */
    POS_GUIDED_TOUR_DISMISSED = 'POS_GUIDED_TOUR_DISMISSED',
    /**
     * Retailer interacted with POS matches page
     */
    POS_MATCHES_NUDGE_DISMISSED = 'POS_MATCHES_NUDGE_DISMISSED',
    /**
     * Retailer has been sent the one time post order POS marketing email
     */
    POS_POST_ORDER_MARKETING_EMAIL_SENT = 'POS_POST_ORDER_MARKETING_EMAIL_SENT',
    /**
     * Retailer has seen the landing modal for the non bm initial limit
     */
    HAS_SEEN_NON_BM_INITIAL_LIMIT_LANDING_MODAL = 'HAS_SEEN_NON_BM_INITIAL_LIMIT_LANDING_MODAL',
    /**
     * Retailer has seen the confirmation modal for the non bm initial limit
     */
    HAS_SEEN_NON_BM_INITIAL_LIMIT_CONFIRMATION_MODAL = 'HAS_SEEN_NON_BM_INITIAL_LIMIT_CONFIRMATION_MODAL',
    /**
     * Retailer has seen the checkout upsell banner related to the non bm initial limit
     */
    HAS_SEEN_NON_BM_INITIAL_LIMIT_CHECKOUT_UPSELL_BANNER = 'HAS_SEEN_NON_BM_INITIAL_LIMIT_CHECKOUT_UPSELL_BANNER',
    /**
     * FD-214720 Set when the retailer has seen the Insider terms and conditions acceptance modal
     */
    INSIDER_REVIEW_TERMS_AND_CONDITIONS_ACCEPTANCE_MODAL_SEEN = 'INSIDER_REVIEW_TERMS_AND_CONDITIONS_ACCEPTANCE_MODAL_SEEN',
    /**
     * Retailer has seen the sem grant landing page
     */
    HAS_SEEN_GRANTS_LANDING_PAGE = 'HAS_SEEN_GRANTS_LANDING_PAGE',
    /**
     * Retailer should be shown one-off limit increase modal
     */
    ONE_OFF_LIMIT_INCREASE_MODAL_VIEW = 'ONE_OFF_LIMIT_INCREASE_MODAL_VIEW',
    /**
     * Retailer should be shown one-off limit increase info in dropdown
     */
    ONE_OFF_LIMIT_INCREASE_DROPDOWN_VIEW = 'ONE_OFF_LIMIT_INCREASE_DROPDOWN_VIEW',
    /**
     * "new" badge on Faire Pay item in the account menu
     */
    FAIRE_PAY_ACCOUNT_DROPDOWN_NEW_BADGE_VIEW = 'FAIRE_PAY_ACCOUNT_DROPDOWN_NEW_BADGE_VIEW',
    /**
     * Retailer has opted out of the POS marketing banners
     */
    POS_MARKETING_BANNERS_DISMISSED = 'POS_MARKETING_BANNERS_DISMISSED',
    /**
     * Set when the retailer sees the POS onboarding banner on order detail
     */
    ORDER_DETAIL_POS_ONBOARDING_BANNER_SEEN = 'ORDER_DETAIL_POS_ONBOARDING_BANNER_SEEN',
    /**
     * Set when retailer dismisses the POS bulk editor education modal
     */
    POS_BULK_EDITOR_EDUCATION_MODAL_SEEN = 'POS_BULK_EDITOR_EDUCATION_MODAL_SEEN',
    /**
     * Set when retailer dismisses the POS bulk editor education banner
     */
    POS_BULK_EDITOR_EDUCATION_BANNER_SEEN = 'POS_BULK_EDITOR_EDUCATION_BANNER_SEEN',
    /**
     * Set when retailer dismisses the POS bulk editor welcome tooltip
     */
    POS_BULK_EDITOR_WELCOME_TOOLTIP_SEEN = 'POS_BULK_EDITOR_WELCOME_TOOLTIP_SEEN',
    /**
     * Set when retailer dismisses the POS bulk editor product editing tooltip
     */
    POS_BULK_EDITOR_EDITING_TOOLTIP_SEEN = 'POS_BULK_EDITOR_EDITING_TOOLTIP_SEEN',
    /**
     * Set when retailer dismisses the POS bulk editor copy/paste tooltip
     */
    POS_BULK_EDITOR_PASTING_TOOLTIP_SEEN = 'POS_BULK_EDITOR_PASTING_TOOLTIP_SEEN',
    /**
     * Set when the retailer dismisses the Last Chance First Order Incentive modal
     */
    LAST_CHANCE_FIRST_ORDER_INCENTIVE_MODAL_DISMISS = 'LAST_CHANCE_FIRST_ORDER_INCENTIVE_MODAL_DISMISS',
    /**
     * Set when the retailer dismisses the Insider Free Shipping expanded coverage banner
     */
    INSIDER_EXPANDED_FREE_SHIPPING_BANNER_DISMISS = 'INSIDER_EXPANDED_FREE_SHIPPING_BANNER_DISMISS',
    /**
     * Set when the retailer sees the Insider Free Shipping expanded coverage banner
     */
    INSIDER_EXPANDED_FREE_SHIPPING_BANNER_SEEN = 'INSIDER_EXPANDED_FREE_SHIPPING_BANNER_SEEN',
    /**
     * Set when the retailer sees the Insider Partnership launch announcement modal
     */
    INSIDER_PARTNERSHIP_LAUNCH_ANNOUNCEMENT_MODAL_SEEN = 'INSIDER_PARTNERSHIP_LAUNCH_ANNOUNCEMENT_MODAL_SEEN',
    /**
     * Set when sent the review brand Braze email to retailer
     */
    SENT_REVIEW_BRAND_BRAZE_EMAIL = 'SENT_REVIEW_BRAND_BRAZE_EMAIL',
    /**
     * Set when sent the review brand reminder Braze email to retailer
     */
    SENT_REVIEW_BRAND_REMINDER_BRAZE_EMAIL = 'SENT_REVIEW_BRAND_REMINDER_BRAZE_EMAIL',
    /**
     * Set when the Insider refresh reminder modal is seen
     */
    INSIDER_REFRESH_REMINDER_MODAL_SEEN = 'INSIDER_REFRESH_REMINDER_MODAL_SEEN',
    /**
     * Set when Insider refresh reminder banner in cart is dismissed
     */
    INSIDER_REFRESH_REMINDER_CART_BANNER_DISMISSED = 'INSIDER_REFRESH_REMINDER_CART_BANNER_DISMISSED',
    /**
     * Set when Insider refresh reminder banner on the my my brands page is dismissed
     */
    INSIDER_REFRESH_REMINDER_MY_BRANDS_BANNER_DISMISSED = 'INSIDER_REFRESH_REMINDER_MY_BRANDS_BANNER_DISMISSED',
    /**
     * User feedback tooltip seen
     */
    USER_FEEDBACK_TOOLTIP_SEEN = 'USER_FEEDBACK_TOOLTIP_SEEN',
    /**
     * User feedback tooltip dismissed
     */
    USER_FEEDBACK_TOOLTIP_DISMISSED = 'USER_FEEDBACK_TOOLTIP_DISMISSED',
    /**
     * Set when any brands in cart will lose coverage on refresh
     */
    INSIDER_REFRESH_CART_BRANDS_EXPIRING = 'INSIDER_REFRESH_CART_BRANDS_EXPIRING',
    /**
     * Set when any brands in my brands will lose coverage on refresh
     */
    INSIDER_REFRESH_MY_BRANDS_EXPIRING = 'INSIDER_REFRESH_MY_BRANDS_EXPIRING',
    /**
     * Set when retailer dismisses any Sale related announcement
     */
    SALE_ANNOUNCEMENT_DISMISSED = 'SALE_ANNOUNCEMENT_DISMISSED',
    /**
     * Set when retailer sees the Insider CAN/AUS launch announcement modal
     */
    INSIDER_CAN_AUS_LAUNCH_MODAL_SEEN = 'INSIDER_CAN_AUS_LAUNCH_MODAL_SEEN',
    /**
     * Set when retailer submits a purchase order from the pilot entry point
     */
    RETAILER_SUBMITTED_PURCHASE_ORDER_FOR_PILOT = 'RETAILER_SUBMITTED_PURCHASE_ORDER_FOR_PILOT',
    /**
     * Set when retailer has seen the digest modal on the homepage
     */
    DIGEST_PAGE_MODAL_SEEN = 'DIGEST_PAGE_MODAL_SEEN',
    /**
     * Set when retailer has clicked the deals hub banner CTA
     */
    DEALS_HUB_BANNER_CTA_CLICKED = 'DEALS_HUB_BANNER_CTA_CLICKED',
    /**
     * Set when retailer sees the deals hub banner CTA
     */
    DEALS_HUB_BANNER_SEEN = 'DEALS_HUB_BANNER_SEEN',
    /**
     * Set when retailer sees the AI chatbot tooltip
     */
    RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN = 'RETAILER_DECAGON_AI_CHATBOT_TOOLTIP_SEEN',
    /**
     * Set when retailer has seen the digest page (Weekly Drop)
     */
    DIGEST_PAGE_SEEN = 'DIGEST_PAGE_SEEN',
    /**
     * Set when retailer sees the "add a store" button in checkout
     */
    RETAILER_STORE_GTM_CHECKOUT_ADD_A_STORE_SEEN = 'RETAILER_STORE_GTM_CHECKOUT_ADD_A_STORE_SEEN',
    /**
     * Set when retailer dismisses the NUX app download nudge
     */
    APP_DOWNLOAD_NUDGE_DISMISSED = 'APP_DOWNLOAD_NUDGE_DISMISSED',
    /**
     * Set when retailer clicks on the low POS stock carousel
     */
    LOW_POS_STOCK_CAROUSEL_CLICKED = 'LOW_POS_STOCK_CAROUSEL_CLICKED',
    /**
     * Set when retailer sees the brand review suggestion banner in the mobile app homepage
     */
    BRAND_REVIEW_SUGGESTION_MOBILE_BANNER_SEEN = 'BRAND_REVIEW_SUGGESTION_MOBILE_BANNER_SEEN',
  }

  export type BrandMilestoneType =
    | 'ELEVATE_PROMPT_ON_ORDER'
    | 'ELEVATE_FOLLOW_UP_MODAL_SEEN'
    | 'CRM_GUIDED_TOUR_SEEN'
    | 'VIEWED_AND_EDITED_SHOP'
    | 'CREATED_STARTER_COLLECTION'
    | 'INVITED_RETAILERS'
    | 'CLAIMED_WALKTHROUGH_INCENTIVE'
    | 'WALKTHROUGH_MODAL_SEEN'
    | 'UPDATE_CATALOG_NOTIFICATION_SEEN'
    | 'VIEW_MY_SHOP_MOVE_SEEN'
    | 'M2M_HEADER_SEEN'
    | 'ELEVATE_REBRAND_NOTIFICATION_SEEN'
    | 'SHIP_WITH_FAIRE_PROMOTION_MODAL_SEEN'
    | 'FAIRE_DIRECT_INTRO_SEEN'
    | 'FAIRE_DIRECT_EMAIL_MARKETING_LAUNCH_MODAL_SEEN'
    | 'FAIRE_DIRECT_EMAIL_MARKETING_FOLLOW_UP_MODAL_SEEN'
    | 'FAIRE_DIRECT_EMAIL_MARKETING_LAUNCH_BANNER_SEEN'
    | 'FAIRE_DIRECT_INVITED_RETAILERS_AFTER_EMAIL_MARKETING_LAUNCH'
    | 'CUSTOM_EMAIL_CAMPAIGN_INTRO_SEEN'
    | 'NAV_GUIDED_TOUR_COMPLETED'
    | 'INSIDER_MAKER_SUBSIDIES_BANNER_SEEN'
    | 'BRAND_WIDGET_HAS_VIEWS'
    | 'ATTEMPTED_BRAND_WIDGET_EMBED'
    | 'BRAND_COVID_LOANS_HELPER_MODAL_SEEN'
    | 'NEIGHBORHOOD_FULFILLMENT_NOTIFICATION_BANNER_SEEN'
    | 'NEIGHBORHOOD_FULFILLMENT_TOOL_TIP_INTRO_SEEN'
    | 'PRODUCT_EDITOR_TAXONOMY_TYPE_PICKER_BANNER_SEEN'
    | 'NEIGHBORHOOD_M2R_CAMPAIGN_AVAILABLE'
    | 'NEIGHBORHOOD_M2R_CAMPAIGN_VIEWED'
    | 'CRM_LEAD_CAPTURE_GUIDED_TOUR_COMPLETED'
    | 'PRODUCT_LINE_COLLECTIONS_TOOLTIP_SEEN'
    | 'BRAND_WALK_THROUGH_ADD_CUSTOMERS_TOOLTIP'
    | 'BRAND_WALK_THROUGH_MANAGE_SHOP_TOOLTIP'
    | 'BRAND_WALK_THROUGH_VIEW_SHOP_BANNER_TOOLTIP'
    | 'BRAND_WALK_THROUGH_ADD_CUSTOMERS_BANNER_TOOLTIP'
    | 'BRAND_WALK_THROUGH_WIDGET_BANNER_TOOLTIP'
    | 'BRAND_UPLOADED_SIZE_CHART'
    | 'BRAND_SENT_PROMOTE_LINK_EMAIL'
    | 'BRAND_HAS_DISMISSED_PRE_ACTIVATION_BANNER'
    | 'INVOICING_TOOL_EDUCATION_ORDERS_PAGE_TOOLTIP'
    | 'INVOICING_TOOL_EDUCATION_ADD_CUSTOMER_TOOLTIP'
    | 'INVOICING_TOOL_EDUCATION_ADD_PRODUCT_TOOLTIP'
    | 'INVOICING_TOOL_EDUCATION_ADD_PROMOTION_TOOLTIP'
    | 'INVENTORY_EDUCATION_CARD_SEEN'
    | 'BRAND_HAS_SEEN_SAMPLES_TOOLTIP'
    | 'EDIT_ORDER_EDUCATION_TOOLTIP'
    | 'NET90_UPDATE_LEAD_TIMES_BANNER_2020'
    | 'CUSTOMERS_V3_WELCOME_MODAL_SEEN'
    | 'UNCONTACTED_CUSTOMERS_BANNER_DISMISSED'
    | 'SHOPIFY_INTEGRATION_WALKTHROUGH_COMPLETE'
    | 'ATTRIBUTE_UPLOADER_BANNER_DISMISSED_ON_HOME'
    | 'ATTRIBUTE_UPLOADER_BANNER_DISMISSED_ON_PRODUCTS'
    | 'APPAREL_PRODUCT_ATTRIBUTES_COMPLETED'
    | 'PURCHASE_ORDER_SEEN_WELCOME_MODAL'
    | 'FAIRE_DIRECT_EDUCATION_PAGE_SEEN'
    | 'SHOPIFY_INTEGRATION_EARLY_ACCESS_FORM_SUBMITTED'
    | 'BRAND_HAS_DISMISSED_SAMPLES_EDUCATION_BANNER'
    | 'BRAND_HAS_SEEN_VIDEO_UPLOAD_TOOLTIP'
    | 'BRAND_HAS_SEEN_GBR_LAUNCH_ALPHA_MODAL'
    | 'POSTMARK_CREATE_SENDER_SIGNATURE_MODAL_SEEN'
    | 'POSTMARK_CREATE_SENDER_SIGNATURE_SUCCESS_MODAL_SEEN'
    | 'BRAND_DISMISSED_FWM_EMAIL_TEMPLATE_BANNER'
    | 'FWM_2021_UPLOAD_APPAREL_PREORDERS_REMINDER_SEEN_ON_DISTINCT_DAY'
    | 'WALKTHROUGH_PREPAREDNESS_SURVEY_SUBMITTED'
    | 'WALKTHROUGH_PREPAREDNESS_SURVEY_DISMISSED'
    | 'NEW_BRAND_WALKTHROUGH_STARTED'
    | 'NEW_BRAND_WALKTHROUGH_COMPLETED'
    | 'SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_HOME'
    | 'SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_INVENTORY'
    | 'SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_ORDERS'
    | 'SHOPIFY_SETTINGS_TOOLTIP_DISMISSED'
    | 'BRAND_LOYALTY_PROGRAM_BANNER_VIEWED'
    | 'BRAND_LOYALTY_WELCOME_MODAL_SEEN'
    | 'BRAND_ONBOARDING_CATALOG_PAGE_SEEN'
    | 'SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_PRODUCTS'
    | 'SHOPIFY_CATALOG_IMPORT_PRICE_CONVERSION_PREFERENCE_SET'
    | 'BRAND_BULK_UPLOADER_HOME_PAGE_BANNER_DISMISSED'
    | 'BRAND_BULK_UPLOADER_SUBMITTED_UPLOAD'
    | 'BRAND_SKU_UPDATE_FREQUENCY_SURVEY_SHOWN'
    | 'BRAND_INVOICING_CUSTOMER_SELECTION_TOOLTIP_SEEN'
    | 'BRAND_INVOICING_WRITE_ORDER_BUTTON_TOOLTIP_SEEN'
    | 'UPFRONT_PAYMENTS_ENROLLMENT_MODAL_DISMISSED'
    | 'UPFRONT_PAYMENTS_ENROLLED_PRODUCTS_BANNER_DISMISSED'
    | 'UPFRONT_PAYMENTS_ENROLLED_CUSTOMERS_BANNER_DISMISSED'
    | 'SHOP_ASSISTANT_REOPEN_TOOLTIP_DISMISSED'
    | 'BRAND_INVOICE_PRODUCT_RECOMMENDATION_TOOLTIP_SEEN'
    | 'BRAND_BULK_UPLOADER_OVERVIEW_TOOLTIP_DISMISSED'
    | 'FAIRE_SUMMER_MARKET_2021_BRAND_RSVP'
    | 'ORDERS_TABLE_COMMISSION_TOOLTIP_SEEN'
    | 'BRAND_FASHION_WEEK_RSVP_COMPLETED'
    | 'BRAND_FASHION_WEEK_ADD_CUSTOMERS_COMPLETED'
    | 'BRAND_FASHION_WEEK_SEND_FASHION_WEEK_CAMPAIGN_COMPLETED'
    | 'BRAND_FASHION_WEEK_ADD_CUSTOMERS_TOOLTIP_DISMISSED'
    | 'PAYOUTS_TOOLTIP_DISMISSED'
    | 'BRAND_FASHION_WEEK_SEND_PRODUCTS_CAMPAIGN_COMPLETED'
    | 'SELF_SERVE_CATALOG_COMPLETENESS_BANNER_CLOSED'
    | 'TOP_SHOP_LANDING_PAGE_SEEN'
    | 'TOP_SHOP_BANNER_SEEN'
    | 'BRAND_FASHION_WEEK_CAMPAIGN_REMINDERS_COMPLETED'
    | 'BRAND_FASHION_WEEK_PRODUCTS_CAMPAIGN_TASK_SEEN'
    | 'BRAND_ADYEN_ONBOARDING_NUDGE_DISMISSED'
    | 'FAIRE_DIRECT_REWARDS_INTRO_SEEN'
    | 'FAIRE_DIRECT_REWARDS_BANNER_SEEN'
    | 'REVIEW_PRODUCTS_IMPORTED_FROM_SHOPIFY_TOOLTIP_DISMISSED'
    | 'B2B_PENDING_REFERRAL_ELIGIBILITY_MODAL_SEEN'
    | 'BRAND_BULK_PRODUCT_EDITOR_EDIT_ALL_PRODUCTS_TOOLTIP_SEEN'
    | 'FRANCE_BRAND_SIREN_MODAL_SEEN'
    | 'PROFORMA_INVOICE_NEW_TAG_SEEN'
    | 'FINALIZED_INVOICE_NEW_TAG_SEEN'
    | 'TAXABLE_BRAND_INVOICE_TOOLTIP_DISMISSED'
    | 'TAXABLE_BRAND_INVOICE_MODAL_SEEN'
    | 'BRAND_TOP_SHOP_TIP_REORDER_RATE_GENERIC_SEEN'
    | 'BRAND_TOP_SHOP_TIP_REORDER_RATE_CLOSE_TO_THRESHOLD_SEEN'
    | 'BRAND_TOP_SHOP_TIP_REORDER_RATE_COMPREHENSION_SEEN'
    | 'BRAND_TOP_SHOP_TIP_MERCHANDISING_RUN_PROMOTION_SEEN'
    | 'BRAND_TOP_SHOP_TIP_MERCHANDISING_REFRESH_CATALOG_SEEN'
    | 'BRAND_TOP_SHOP_TIP_MERCHANDISING_ACTIVE_PRODUCTS_SEEN'
    | 'BRAND_TOP_SHOP_TIP_MERCHANDISING_ORDER_MINIMUM_SEEN'
    | 'BRAND_TOP_SHOP_TIP_PERFECT_ORDER_RATE_LEAD_TIME_SEEN'
    | 'BRAND_TOP_SHOP_TIP_PERFECT_ORDER_RATE_SHOPIFY_INTEGRATION_SEEN'
    | 'BRAND_TOP_SHOP_TIP_RETAILER_RATING_SEEN'
    | 'BRAND_HAS_DISMISSED_FWM_22_WIDGET'
    | 'BRAND_HAS_VISITED_FWM_22_EVENT_PAGE'
    | 'BRAND_HAS_SEEN_SHOPIFY_ADOPTION'
    | 'BRAND_HAS_OPENED_SHOP_ASSISTANT'
    | 'BRAND_HAS_SEEN_ADYEN_SET_UP_FAILED_POP_UP'
    | 'BRAND_HAS_SEEN_ADYEN_SET_UP_SUCCESS_POP_UP'
    | 'BRAND_HAS_SEEN_ADYEN_NEED_VERIFICATION_INFORMATION_POP_UP'
    | 'BRAND_HAS_SEEN_ADYEN_VERIFYING_POP_UP'
    | 'BRAND_HAS_DISMISSED_FFW_22_WIDGET'
    | 'INSIDER_INTERNATIONAL_CREDITS_WEB_TOAST_DISMISSED'
    | 'CATALOG_COMPLETE_NUDGE_PRODUCT_PAGE_SEEN'
    | 'CATALOG_COMPLETE_NUDGE_HOMEPAGE_SEEN'
    | 'CATALOG_COMPLETE_NUDGE_PRODUCT_PAGE_DISMISSED'
    | 'CATALOG_COMPLETE_NUDGE_SHOPIFY_INTEGRATED_WITH_DRAFT_PRODUCTS'
    | 'CATALOG_COMPLETE_NUDGE_INSUFFICIENT_PRODUCTS_ADDED'
    | 'CATALOG_COMPLETE_NUDGE_ADDED_PRODUCTS_THRESHOLD_1'
    | 'CATALOG_COMPLETE_NUDGE_ADDED_PRODUCTS_THRESHOLD_2'
    | 'CATALOG_COMPLETE_NUDGE_CLOSE_TO_CATALOG_COMPLETE'
    | 'CATALOG_COMPLETE_NUDGE_BANNER_HIDDEN'
    | 'AUS_BRAND_ANNOUNCEMENT_MODAL'
    | 'FAIRE_DIRECT_REWARDS_INTRO_SEEN_V2'
    | 'FIRST_CELL_CLICK_ON_BULK_EDITOR_PAGE'
    | 'FAIRE_DIRECT_REWARDS_BANNER_V2_SEEN'
    | 'LOCAL_BRAND_DISCOUNT_ANNOUNCEMENT_BANNER_DISMISSED'
    | 'BRAND_HAS_CLOSED_PRICE_PARITY_MODAL'
    | 'BRAND_HAS_CLOSED_PRICE_PARITY_REMINDER_MODAL'
    | 'BRAND_NUDGE_HUB_FIRST_TIME_EXPERIENCE_VIEWED'
    | 'SWF_PICKUP_BANNER_SEEN_ORDERS'
    | 'SWF_PICKUP_BANNER_SEEN_ORDER_FULFILLMENT'
    | 'SWF_PICKUP_TAG_SEEN_SHIPPING_INFO'
    | 'BRAND_PROMOTION_SPLIT_FAIRE_SUMMER_MARKET_2022'
    | 'BRAND_NUDGE_HUB_DISMISSED_NOTIFICATION_SHOWN'
    | 'PREORDER_BRAND_IDENTIFICATION_SURVEY_RESPONDED'
    | 'PREORDER_BRAND_IDENTIFICATION_SURVEY_DISMISSED'
    | 'BRAND_CRM_RECOMMENDATION'
    | 'BRAND_DISMISS_REGISTRATION_COMPLETE_MODAL'
    | 'BRAND_HAS_SEEN_MESSENGER_TEMPLATE_PICKER'
    | 'BRAND_HAS_SEEN_CUSTOMERS_PAGE_CHAT_BUBBLE'
    | 'BRAND_HAS_SEEN_NUDGE_HUB_COME_BACK_LATER_EDUCATION_NOTIFICATION'
    | 'B2B_BRAND_CONTENT_HELP_MODAL_SEEN'
    | 'BRAND_HAS_DISMISSED_FSM_22_WIDGET'
    | 'BRAND_HAS_VISITED_FSM_22_EVENT_PAGE'
    | 'BRAND_NUDGE_HUB_SHOP_ASSISTANT_EDUCATION_VIEWED'
    | 'B2B_BRAND_SHOULD_NOT_DISPLAY_HOME_PAGE_BANNER'
    | 'BRAND_HAS_SEEN_SHIP_ALCOHOL_WITH_SHIP_ON_YOUR_OWN_BANNER'
    | 'FIRST_TIME_BULK_EDITOR_WITH_PRICING_VIOLATIONS'
    | 'SUCCESSFUL_PRICING_VIOLATION_RESOLUTION'
    | 'BRAND_HAS_DISMISSED_FFW_V3_WIDGET'
    | 'BRAND_HAS_VISITED_FFW_V3_POST_REGISTRATION_EVENT_PAGE'
    | 'BRAND_HAS_COMPLETED_PROMOTIONAL_EVENTS_TASK_FFW_V3_LET_BUYERS_KNOW'
    | 'BRAND_HAS_COMPLETED_PROMOTIONAL_EVENTS_TASK_FFW_V3_INVITE_CUSTOMERS'
    | 'R2B_CREDIT_REDUCTION_MODAL_SEEN'
    | 'BRAND_HAS_DISMISSED_POST_FSM_22_WIDGET'
    | 'BRAND_PRODUCT_EDITOR_SINGLE_PRODUCT_TOOLTIPS_SEEN'
    | 'BRAND_PRODUCT_EDITOR_MULTI_OPTION_TOOLTIPS_SEEN'
    | 'BRAND_HAS_PRICING_VIOLATIONS'
    | 'PRICING_PARITY_BULK_EDITOR_FIRST_EDIT'
    | 'BRAND_HAS_SEEN_PRODUCT_DELIST_BANNER'
    | 'BRAND_SHOULD_SEE_NEW_ARRIVALS_COUNTDOWN_HOMEPAGE_BANNER'
    | 'BRAND_HAS_SEEN_FOOD_AND_BEVERAGE_ATTRIBUTES_OPTIMIZED_EDIT_FLOW'
    | 'BRAND_HAS_SEEN_FD_EARLY_LIFECYCLE_FIRST_RUN_EXPERIENCE'
    | 'B2B_VALUE_BASED_INCENTIVES_LANDING_MODAL_SEEN'
    | 'BRAND_HAS_SEEN_LUCID_COMPLIANCE_CHECK_BANNER'
    | 'NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED'
    | 'NAM_SUBSIDY_PULLBACK_BANNER_SEEN'
    | 'B2B_HOME_PAGE_INCENTIVES_BANNER_SEEN'
    | 'HOME_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSED'
    | 'CSV_ACTIONS_SINCE_LAST_HOME_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSAL'
    | 'PRODUCT_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSED'
    | 'CSV_ACTIONS_SINCE_LAST_PRODUCT_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSAL'
    | 'GENERAL_INTEGRATION_AWARENESS_BANNER_DISMISSED'
    | 'CSV_ACTIONS_SINCE_LAST_GENERAL_INTEGRATION_AWARENESS_BANNER_DISMISSAL'
    | 'INVENTORY_CSV_UPLOAD'
    | 'ORDER_CSV_EXPORT'
    | 'PRE_ACTIVATION_SHOP_FEEDBACK_TOOLTIP_SEEN'
    | 'PRODUCT_CSV_UPLOAD'
    | 'BRAND_INTEGRATION_ADOPTION_EMAIL_SENT'
    | 'BRAND_APPAREL_COLLECTIONS_TABLE_TOOLTIP_SEEN'
    | 'BRAND_APPAREL_COLLECTION_ITEMS_TABLE_TOOLTIP_SEEN'
    | 'BRAND_SHOPIFY_INTEGRATION_PRICING_SYNC_BANNER_SEEN'
    | 'EUROPEAN_CO_FUNDED_SUBSIDY_HOME_BANNER_DISMISSED'
    | 'EUROPEAN_CO_FUNDED_SUBSIDY_ORDERS_BANNER_DISMISSED'
    | 'EUROPEAN_CO_FUNDED_SUBSIDY_PROMOTIONS_BANNER_DISMISSED'
    | 'BRAND_CUSTOMER_TABLE_UPDATES_MODAL_SEEN'
    | 'PRODUCT_EDITOR_BREAK_DOWN_PREPACKS_TOGGLE_TOOLTIP_DISMISSED'
    | 'EUROPEAN_CO_FUNDED_SUBSIDY_HOME_BANNER_SEEN'
    | 'FAIRE_DIRECT_REWARDS_TERMS_AND_CONDITIONS_MODAL_SEEN'
    | 'FAIRE_DIRECT_REWARDS_TERMS_AND_CONDITIONS_MODAL_DISMISSED'
    | 'BULK_UPLOADER_PRICE_INCREASED'
    | 'BULK_UPLOADER_PRICE_CHECK_BANNER_DISMISSED'
    | 'BCFS_ORDERS_PAGE_DISCOVERY_BANNER_DISMISSED'
    | 'BCFS_PROMOTIONS_PAGE_DISCOVERY_BANNER_DISMISSED'
    | 'BRAND_PROMOTION_SPLIT_FAIRE_WINTER_MARKET_2023'
    | 'BRAND_SEEN_CUSTOMER_SERVICE_GTM_BANNER'
    | 'BRAND_DISMISSED_CUSTOMER_SERVICE_GTM_BANNER'
    | 'SOYO_VALIDATION_INTRO_BANNER_SEEN'
    | 'BRAND_FULL_NAM_SUBSIDY_PULLBACK_ADVANCE_WARNING_BANNER_DISMISSED'
    | 'BCFS_ORDERS_PAGE_DISCOVERY_BANNER_SEEN'
    | 'BCFS_PROMOTIONS_PAGE_DISCOVERY_BANNER_SEEN'
    | 'SAMPLE_EDUCATION_PAGE_ACCEPTED'
    | 'BRAND_FULL_NAM_SUBSIDY_PULLBACK_ADVANCE_WARNING_BANNER_SEEN'
    | 'SUNSET_LOCAL_DISCOUNT_ANNOUNCEMENT_BANNER_DISMISSED'
    | 'SUNSET_LOCAL_DISCOUNT_ANNOUNCEMENT_BANNER_SEEN'
    | 'BRAND_FULL_NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED'
    | 'BRAND_LINE_SHEET_REARRANGE_PRODUCTS_TOOLTIP_DISMISSED'
    | 'BRAND_PRODUCT_BASED_COLLECTIONS_PUBLISH_CAMPAIGN_MODAL_SHOW_COUNT'
    | 'BRAND_PRODUCT_BASED_COLLECTIONS_PUBLISH_CAMPAIGN_PREFILL_BANNER_DISMISSED'
    | 'HAS_SEEN_PRODUCT_BASED_COLLECTIONS'
    | 'HAS_DISMISSED_BRAND_TAGS_ALERT_BANNER'
    | 'SHOPIFY_SALES_CHANNEL_MIGRATION_HOMEPAGE_BANNER_DISMISSED'
    | 'SHOPIFY_SALES_CHANNEL_MIGRATION_HOMEPAGE_MODAL_DISMISSED'
    | 'HAS_UPDATED_BRAND_TAGS'
    | 'SWF_CANADA_ORDERS_PAGE_ANNOUNCEMENT_BANNER_DISMISSED'
    | 'SWF_CANADA_ORDERS_PAGE_ANNOUNCEMENT_BANNER_SEEN'
    | 'SWF_CANADA_ORDER_FULFILLMENT_PAGE_ANNOUNCEMENT_BANNER_SEEN'
    | 'SWF_CANADA_TAB_AUTO_SELECTED'
    | 'HAS_SEEN_INTERNATIONAL_SHIPPING_CHECKLIST'
    | 'FAIRE_DIRECT_WIDGET_V2_HOMEPAGE_BANNER_DISMISSED'
    | 'ULP_G2M_BANNER_SEEN'
    | 'HAS_SEEN_FIRST_INTERNATIONAL_ORDER_MODAL'
    | 'FAIRE_DIRECT_REWARDS_ONBOARDING_OPT_IN_SEEN'
    | 'FAIRE_DIRECT_REWARDS_ONBOARDING_OPT_IN_CLICKED'
    | 'B2B_REFERRAL_POLICY_TOS_MODAL_SEEN'
    | 'BULK_EDITOR_ATTRIBUTE_GTM_TOOLTIP_DISMISSED'
    | 'ATTRIBUTE_GTM_HOMEPAGE_BANNER_DISMISSED'
    | 'ATTRIBUTE_GTM_PRODUCT_PAGE_BANNER_DISMISSED'
    | 'ATTRIBUTE_GTM_BULK_EDITOR_PAGE_BANNER_DISMISSED'
    | 'BRAND_MINIMUM_EU_CONSOLIDATION_CURRENCY_CONVERSION_TOOLTIP_SEEN'
    | 'FAIRE_DIRECT_REWARDS_BRAND_ENGAGEMENT_HOMEPAGE_BANNER_DISMISSED'
    | 'INSIDER_SHIPPING_UPDATE_ANNOUNCEMENT_BANNER_DISMISSED'
    | 'INSIDER_SHIPPING_UPDATE_ANNOUNCEMENT_BANNER_SEEN'
    | 'BRAND_DISMISSED_TOP_SHOP_GTM_HOMEPAGE_BANNER'
    | 'INSIDER_SHIPPING_AVAILABLE_ANNOUNCEMENT_BANNER_DISMISSED'
    | 'INSIDER_SHIPPING_AVAILABLE_ANNOUNCEMENT_BANNER_SEEN'
    | 'BRAND_DISPLAY_COLLECTION_NEW_TAG_SEEN'
    | 'BRAND_DISPLAY_COLLECTION_COLLECTION_PAGE_BANNER_DISMISSED'
    | 'PRODUCT_LANGUAGE_HELPER_TEXT_SEEN'
    | 'SWF_DHL_AND_UPS_PICKUP_BANNER_SEEN'
    | 'COMMISSION_PAYOUTS_NAM_UPDATE_ANNOUNCEMENT_DISMISSED'
    | 'BRAND_PRODUCT_SKU_FILTER_TOOLTIP_DISMISSED'
    | 'TOP_SHOP_INTRO_COMMS_SENT'
    | 'TOP_SHOP_INTERMEDIATE_STATE_VIEWED'
    | 'BRAND_AGREED_TO_PRICING_PARITY_POLICY'
    | 'BRAND_DISMISSED_TOP_SHOP_BANNER_V2'
    | 'BRAND_SEEN_TOP_SHOP_BANNER_V2'
    | 'COMMISSION_PAYOUTS_NAM_UPDATE_PRELAUNCH_REMINDER_BANNER_DISMISSED'
    | 'BRAND_FAIRE_DIRECT_PERCENTAGE_DISCOUNT_REMINDER_BANNER_DISMISSED'
    | 'BRAND_PLAYED_TOP_SHOP_INTRO_REEL'
    | 'COMMISSION_PAYOUTS_NAM_UPDATE_TOS_ACCEPTED'
    | 'COMMISSION_PAYOUTS_NAM_UPDATE_TOS_DISMISSED'
    | 'COMMISSION_PAYOUTS_NAM_UPDATE_ORDER_DETAILS_PAGE_FTU_BANNER_SEEN'
    | 'TAX_ON_SERVICES_CAN_ANNOUNCEMENT_BANNER_SEEN'
    | 'LISTING_QUALITY_EDUCATION_SIDE_SHEET_SEEN'
    | 'LISTING_QUALITY_BANNER_DISMISSED'
    | 'LISTING_QUALITY_BANNER_SEEN'
    | 'SAMPLES_PAGE_VISITED'
    | 'ORDER_MINIMUM_NUDGE_DISMISSED'
    | 'PRODUCT_IMAGE_AUTO_CROP_BANNER_DISMISSED'
    | 'EXCLUDE_RECENTLY_CONTACTED_TOOLTIP_DISMISSED'
    | 'CRM_FILTER_UPDATE_GTM_DISMISSED'
    | 'FAIRE_DIRECT_CREDIT_UPDATE_07_01_2023_DISMISSED'
    | 'PRODUCT_VARIANT_ATTRIBUTE_ROLLOUT_BASIC_INFORMATION_TOOLTIP_SEEN'
    | 'USPS_GROUND_ADVANTAGE_ANNOUNCEMENT_BANNER_SEEN'
    | 'USPS_GROUND_ADVANTAGE_ANNOUNCEMENT_BANNER_DISMISSED'
    | 'PRODUCT_OPTION_INVENTORY_MANEMENT_IMPROVEMENT_TOOLTIP_DISMISSED'
    | 'PRODUCT_IMAGE_AUTO_CROP_REVERT_ALL'
    | 'PRODUCT_IMAGE_AUTO_CROP_REVIEW_PAGE_SEEN'
    | 'ADS_MANAGER_ONBOARDING_GET_STARTED_CLICKED'
    | 'SEGMENT_DROPDOWN_GTM_TOOLTIP_SEEN'
    | 'SEGMENT_SETTINGS_GTM_TOOLTIP_SEEN'
    | 'UPS_HAZMAT_BANNER_SEEN'
    | 'PRODUCT_BASED_COLLECTION_PROMO_ANNOUNCEMENT_BANNER_DISMISSED'
    | 'PRODUCT_BASED_COLLECTION_ADD_DISPLAY_INCENTIVE_BANNER_DISMISSED'
    | 'UPS_HAZMAT_BANNER_DISMISSED'
    | 'EXCLUSIVITY_BANNER_HOMEPAGE_DISMISSED'
    | 'CATALOG_COMPLETENESS_REVIEW_INFO_PAGE_SEEN'
    | 'DOCUMENT_UPLOAD_SECTION_SEEN'
    | 'PRODUCT_IMAGE_AUTO_CROP_BATCH_EXPIRED'
    | 'TAX_ON_SERVICES_EU_ANNOUNCEMENT_BANNER_SEEN'
    | 'ADS_MANAGER_CAMPAIGN_STATUS_CHANGE_NOTICE_DISMISSED'
    | 'CATALOG_COMPLETENESS_INFO_SEEN_TOP_SHOP_BETA'
    | 'Q3_ATTRIBUTE_GTM_PRODUCTS_PAGE_BANNER_DISMISSED'
    | 'Q3_ATTRIBUTE_GTM_HOMEPAGE_BANNER_DISMISSED'
    | 'Q3_ATTRIBUTE_GTM_CATEGORY_TOOLTIP_DISMISSED'
    | 'FAIRE_DIRECT_REWARDS_OFFBOARDING_HOMEPAGE_BANNER_DISMISSED'
    | 'FAIRE_DIRECT_REWARDS_LANDING_PAGE_OFFBOARDING_BANNER_DISMISSED'
    | 'FAIRE_DIRECT_CREDIT_UPDATE_10_01_2023_DISMISSED'
    | 'SUBMIT_PRICING_CATALOG_HOMEPAGE_BANNER_DISMISSED'
    | 'UNDERGOING_REPEAT_VIOLATION_DOWNRANK_BANNER_DISMISSED'
    | 'FAIRE_DIRECT_NEW_POLICY_ANNOUNCEMENT_HOMEPAGE_BANNER_DISMISSED'
    | 'FAIRE_DIRECT_NEW_POLICY_LAUNCH_HOMEPAGE_BANNER_DISMISSED'
    | 'ADS_MANAGER_HOMEPAGE_BANNER_DISMISSED'
    | 'CATALOG_CHECK_INVALID_SOURCES_REQUEST_HELP_MODAL_SUBMITTED'
    | 'CAMPAIGN_PERFORMANCE_TRANSPARENCY_GTM_BANNER_DISMISSED'
    | 'SHIPPING_PROFILE_FIRST_RUN_COMPLETED'
    | 'SHIPPING_PROFILE_DEFAULT_ZONE_MODIFIED'
    | 'EXCLUSIVITY_GTM_BANNER_HOMEPAGE_DISMISSED'
    | 'EXCLUSIVITY_INTRODUCTION_HOMEPAGE_BANNER_DISMISSED'
    | 'INSTALL_FAIRE_ON_SHOPIFY_NUDGE_BANNER_SEEN'
    | 'NEW_PRODUCT_TAGS_NUDGE_BANNER_SEEN'
    | 'REVIEW_LISTING_UPDATES_NUDGE_BANNER_SEEN'
    | 'REVIEW_PRICING_PARITY_NUDGE_BANNER_SEEN'
    | 'BRAND_HAS_VISITED_PRODUCT_EDITOR_PAGE'
    | 'HAS_ACCEPTED_GUARANTEED_SHIPPING_TERMS_AND_CONDITIONS'
    | 'HAS_CLICKED_CONTINUE_OR_CLOSE_ON_SHIPPING_ESTIMATE_MODAL'
    | 'HAS_CLICKED_SKIP_SAVED_PACKAGE_CHECKLIST_ITEM'
    | 'BRAND_HAS_SEEN_SHOP_ASSISTANT_INTRODUCTION_TOOLTIP'
    | 'BRAND_HAS_SEEN_GUARANTEED_SHIPPING_LANDING_PAGE'
    | 'EXCLUSIVITY_INTERESTED_RETAILERS_HOMEPAGE_BANNER_DISMISSAL_COUNT'
    | 'EXCLUSIVITY_INTERESTED_RETAILERS_HOMEPAGE_BANNER_DISABLED'
    | 'SENT_BRAZE_EVENT_FOR_FIRST_GUARANTEED_SHIPPING_ZONE'
    | 'DOMAIN_AUTHENTICATION_REQUIRED_HOMEPAGE_BANNER_DISMISSED'
    | 'BRAND_HAS_SEEN_SHOP_ASSISTANT_WELCOME_TO_UPDATES_MESSAGE'
    | 'BRAND_HAS_SEEN_EDUCATION_PANEL_FOR_CONTENT_RECOMMENDATIONS'
    | 'HAS_DISMISSED_NEW_WAY_TO_CUSTOMIZE_EMAIL_BANNER'
    | 'BRAND_HAS_SEEN_EDUCATION_PANEL_FOR_POST_PUBLISH_CONTENT_RECOMMENDATIONS'
    | 'BRAND_HAS_SET_BASED_IN_DURING_SIGN_UP'
    | 'FIRST_GUARANTEED_SHIPPING_RATE_BANNER_DISMISSED'
    | 'EXCLUSIVITY_UNENROLLED_LANDING_PAGE_BANNER_DISMISSED'
    | 'EXCLUSIVITY_UNENROLLED_LANDING_PAGE_BANNER_VIEWED'
    | 'INSIDER_PARTNERSHIP_AUTO_ENROLLED_BANNER_DISMISSED'
    | 'INSIDER_PARTNERSHIP_TERMS_AND_CONDITIONS_ACCEPTED'
    | 'INSIDER_PARTNERSHIP_HOMEPAGE_BANNER_DISMISSED'
    | 'BRAND_ANNOUNCEMENT_SYSTEM_INTRODUCTION_TOOLTIP_SEEN'
    | 'BRAND_APP_EDUCATION_HOMEPAGE_BANNER_DISMISSED'
    | 'BRAND_APP_EDUCATION_SIDEBAR_BANNER_DISMISSED'
    | 'BRAND_APP_EDUCATION_ORDERS_BANNER_DISMISSED'
    | 'BRAND_APP_EDUCATION_MESSENGER_BANNER_DISMISSED'
    | 'BRAND_APP_EDUCATION_CUSTOMERS_BANNER_DISMISSED'
    | 'FREE_SHIPPING_THRESHOLD_INSIDER_SIDE_DOOR_DISMISSED'
    | 'BRAND_PORTAL_FAIRE_DIRECT_WIDGET_TASK_CLICKED'
    | 'BRAND_PORTAL_FAIRE_DIRECT_PROFILE_LINK_TASK_CLICKED'
    | 'BRAND_PORTAL_FAIRE_DIRECT_EMAIL_SIGNATURE_TASK_CLICKED'
    | 'BRAND_PORTAL_FAIRE_DIRECT_MARKETING_COLLATERAL_TASK_CLICKED'
    | 'BRAND_PORTAL_FAIRE_DIRECT_ANNOUNCEMENT_TASK_CLICKED'
    | 'BRAND_PORTAL_FAIRE_DIRECT_DIRECT_MESSAGE_TASK_CLICKED'
    | 'BRAND_PORTAL_FAIRE_DIRECT_QR_CODE_TASK_CLICKED'
    | 'BRAND_PORTAL_FAIRE_DIRECT_BRAND_APP_TASK_CLICKED'
    | 'BRAND_PORTAL_SINGLE_PRODUCT_EDITOR_SHOPIFY_PRICE_SYNC_ON_BANNER_DISMISSED'
    | 'BRAND_APP_EDUCATION_INVOICES_BANNER_DISMISSED'
    | 'BRAND_SIGNED_UP_FOR_CARRIER_CALCULATED_SHIPPING_WAITLIST'
    | 'BRAND_CLOSED_CARRIER_CALCULATED_SHIPPING_WAITLIST_BANNER'
    | 'BRAND_DISMISSED_ADD_TEAM_MEMBER_BANNER'
    | 'BRAND_HAS_VISITED_POST_ACTIVATION_BRAND_PORTAL'
    | 'SWF_PICKUP_NAM_TAG_SEEN'
    | 'BRAND_PORTAL_INACTIVE_RECIPIENT_BANNER'
    | 'BRAND_HAS_VISITED_BRAND_ACTIVATION_PORTAL_WELCOME'
    | 'BRAND_TOP_SHOP_PAGE_FAIRE_DIRECT_WIDGET_BANNER_DISMISSED'
    | 'BRAND_HAS_SEEN_FIRST_ORDER_MODAL'
    | 'BRAND_HAS_SEEN_FEATURED_IN_NEW_ARRIVALS_CELEBRATION_MODAL'
    | 'BRAND_HAS_SEEN_ADD_FULL_CATALOG_EDUCATION_PANEL'
    | 'BRAND_HAS_SEEN_WRITE_DETAILED_DESCRIPTION_EDUCATION_PANEL'
    | 'BRAND_HAS_SEEN_ADD_CLEAR_IMAGES_EDUCATION_PANEL'
    | 'BRAND_PORTAL_INACTIVE_RECIPIENT_BANNER_SEEN_COUNT'
    | 'BRAND_PRODUCT_ADD_TEAM_MEMBER_BANNER_DISMISSED'
    | 'BRAND_CUSTOM_EXCLUSIVITY_AREA_SIZE_BANNER_DISMISSED'
    | 'BRAND_INVITED_TEAM_MEMBER'
    | 'TOP_SHOP_CELEBRATION_SEEN_TIMES'
    | 'BRAND_FAIRE_FOR_TEAMS_GTM_MODAL_DISMISSED'
    | 'BRAND_FAIRE_FOR_TEAMS_GTM_MODAL_SEEN'
    | 'LISTING_QUALITY_IMAGE_ISSUES_BANNER_DISMISSED'
    | 'HAS_SEEN_DESCRIPTION_RECOMMENDATION_FEEDBACK_MODAL'
    | 'HAS_SEEN_FAIRE_FOR_TEAMS_PAGE'
    | 'BRAND_HAS_EDITED_FAIRE_DIRECT_TOKEN_ALIAS'
    | 'BRAND_HAS_SEEN_FAIRE_DIRECT_ADOPTION_INCENTIVE_ACTIVATED_MODAL'
    | 'BRAND_HAS_SEEN_BULK_UPLOAD_UPDATE_BANNER'
    | 'BRAND_HAS_SEEN_UNLOCKED_AD_CREDITS_MODAL'
    | 'BRAND_HAS_NEW_OR_UPDATED_CATALOG_UPDATE_REQUISITION'
    | 'INSIDER_EXPANSION_ANNOUNCEMENT_BANNER_DISMISSED'
    | 'FAIRE_FOR_TEAMS_MARKETING_BANNER_DISMISSED'
    | 'CONTEXTUAL_ENTRYPOINT_PRODUCT_PERFORMANCE_PAGE_BANNER_DISMISSED'
    | 'BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN'
    | 'CONTEXTUAL_ENTRYPOINT_PROMOTIONS_PAGE_BANNER_DISMISSED'
    | 'CONTEXTUAL_ENTRYPOINT_CRM_RECOMMENDATIONS_DISMISSED'
    | 'BRAND_REQUEST_A_REVIEW_NUDGE_IN_MESSENGER_DISMISSED'
    | 'FIRST_INSIDER_MP_ORDERS_INTERSTITIAL_SEEN'
    | 'FIRST_INSIDER_FD_ORDER_INTERSTITIAL_SEEN'
    | 'INSIDER_PARTNERSHIP_DEFAULT_ENROLL_TERMS_ACCEPTED'
    | 'INSIDER_PARTNERSHIP_HOW_IT_WORKS_BANNER_SEEN'
    | 'PRODUCT_TAXONOMY_PREDICTION_BANNER_SEEN'
    | 'BRAND_HAS_SEEN_TITLE_RECOMMENDATION_FEEDBACK_MODAL'
    | 'BRAND_TO_RETAILER_REVIEW_REQUEST_ANNOUNCEMENT_BANNER_SEEN'
    | 'NO_BRAND_MILESTONE';

  export enum BrandMilestone {
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    ELEVATE_PROMPT_ON_ORDER = 'ELEVATE_PROMPT_ON_ORDER',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    ELEVATE_FOLLOW_UP_MODAL_SEEN = 'ELEVATE_FOLLOW_UP_MODAL_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CRM_GUIDED_TOUR_SEEN = 'CRM_GUIDED_TOUR_SEEN',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    VIEWED_AND_EDITED_SHOP = 'VIEWED_AND_EDITED_SHOP',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CREATED_STARTER_COLLECTION = 'CREATED_STARTER_COLLECTION',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    INVITED_RETAILERS = 'INVITED_RETAILERS',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CLAIMED_WALKTHROUGH_INCENTIVE = 'CLAIMED_WALKTHROUGH_INCENTIVE',
    /**
     * @protobufOption (milestoneType) = USER
     */
    WALKTHROUGH_MODAL_SEEN = 'WALKTHROUGH_MODAL_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    UPDATE_CATALOG_NOTIFICATION_SEEN = 'UPDATE_CATALOG_NOTIFICATION_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    VIEW_MY_SHOP_MOVE_SEEN = 'VIEW_MY_SHOP_MOVE_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    M2M_HEADER_SEEN = 'M2M_HEADER_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    ELEVATE_REBRAND_NOTIFICATION_SEEN = 'ELEVATE_REBRAND_NOTIFICATION_SEEN',
    /**
     * @protobufOption (milestoneType) = USER
     */
    SHIP_WITH_FAIRE_PROMOTION_MODAL_SEEN = 'SHIP_WITH_FAIRE_PROMOTION_MODAL_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_INTRO_SEEN = 'FAIRE_DIRECT_INTRO_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_EMAIL_MARKETING_LAUNCH_MODAL_SEEN = 'FAIRE_DIRECT_EMAIL_MARKETING_LAUNCH_MODAL_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_EMAIL_MARKETING_FOLLOW_UP_MODAL_SEEN = 'FAIRE_DIRECT_EMAIL_MARKETING_FOLLOW_UP_MODAL_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_EMAIL_MARKETING_LAUNCH_BANNER_SEEN = 'FAIRE_DIRECT_EMAIL_MARKETING_LAUNCH_BANNER_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_INVITED_RETAILERS_AFTER_EMAIL_MARKETING_LAUNCH = 'FAIRE_DIRECT_INVITED_RETAILERS_AFTER_EMAIL_MARKETING_LAUNCH',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CUSTOM_EMAIL_CAMPAIGN_INTRO_SEEN = 'CUSTOM_EMAIL_CAMPAIGN_INTRO_SEEN',
    /**
     * @protobufOption (milestoneType) = USER
     */
    NAV_GUIDED_TOUR_COMPLETED = 'NAV_GUIDED_TOUR_COMPLETED',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_MAKER_SUBSIDIES_BANNER_SEEN = 'INSIDER_MAKER_SUBSIDIES_BANNER_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_WIDGET_HAS_VIEWS = 'BRAND_WIDGET_HAS_VIEWS',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    ATTEMPTED_BRAND_WIDGET_EMBED = 'ATTEMPTED_BRAND_WIDGET_EMBED',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_COVID_LOANS_HELPER_MODAL_SEEN = 'BRAND_COVID_LOANS_HELPER_MODAL_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    NEIGHBORHOOD_FULFILLMENT_NOTIFICATION_BANNER_SEEN = 'NEIGHBORHOOD_FULFILLMENT_NOTIFICATION_BANNER_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    NEIGHBORHOOD_FULFILLMENT_TOOL_TIP_INTRO_SEEN = 'NEIGHBORHOOD_FULFILLMENT_TOOL_TIP_INTRO_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_EDITOR_TAXONOMY_TYPE_PICKER_BANNER_SEEN = 'PRODUCT_EDITOR_TAXONOMY_TYPE_PICKER_BANNER_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    NEIGHBORHOOD_M2R_CAMPAIGN_AVAILABLE = 'NEIGHBORHOOD_M2R_CAMPAIGN_AVAILABLE',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    NEIGHBORHOOD_M2R_CAMPAIGN_VIEWED = 'NEIGHBORHOOD_M2R_CAMPAIGN_VIEWED',
    /**
     * @protobufOption (milestoneType) = USER
     */
    CRM_LEAD_CAPTURE_GUIDED_TOUR_COMPLETED = 'CRM_LEAD_CAPTURE_GUIDED_TOUR_COMPLETED',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_LINE_COLLECTIONS_TOOLTIP_SEEN = 'PRODUCT_LINE_COLLECTIONS_TOOLTIP_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_WALK_THROUGH_ADD_CUSTOMERS_TOOLTIP = 'BRAND_WALK_THROUGH_ADD_CUSTOMERS_TOOLTIP',
    /**
     * @protobufOption (milestoneType) = USER
     */
    BRAND_WALK_THROUGH_MANAGE_SHOP_TOOLTIP = 'BRAND_WALK_THROUGH_MANAGE_SHOP_TOOLTIP',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_WALK_THROUGH_VIEW_SHOP_BANNER_TOOLTIP = 'BRAND_WALK_THROUGH_VIEW_SHOP_BANNER_TOOLTIP',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_WALK_THROUGH_ADD_CUSTOMERS_BANNER_TOOLTIP = 'BRAND_WALK_THROUGH_ADD_CUSTOMERS_BANNER_TOOLTIP',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_WALK_THROUGH_WIDGET_BANNER_TOOLTIP = 'BRAND_WALK_THROUGH_WIDGET_BANNER_TOOLTIP',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_UPLOADED_SIZE_CHART = 'BRAND_UPLOADED_SIZE_CHART',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_SENT_PROMOTE_LINK_EMAIL = 'BRAND_SENT_PROMOTE_LINK_EMAIL',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_DISMISSED_PRE_ACTIVATION_BANNER = 'BRAND_HAS_DISMISSED_PRE_ACTIVATION_BANNER',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    INVOICING_TOOL_EDUCATION_ORDERS_PAGE_TOOLTIP = 'INVOICING_TOOL_EDUCATION_ORDERS_PAGE_TOOLTIP',
    /**
     * @protobufOption (milestoneType) = USER
     */
    INVOICING_TOOL_EDUCATION_ADD_CUSTOMER_TOOLTIP = 'INVOICING_TOOL_EDUCATION_ADD_CUSTOMER_TOOLTIP',
    /**
     * @protobufOption (milestoneType) = USER
     */
    INVOICING_TOOL_EDUCATION_ADD_PRODUCT_TOOLTIP = 'INVOICING_TOOL_EDUCATION_ADD_PRODUCT_TOOLTIP',
    /**
     * @protobufOption (milestoneType) = USER
     */
    INVOICING_TOOL_EDUCATION_ADD_PROMOTION_TOOLTIP = 'INVOICING_TOOL_EDUCATION_ADD_PROMOTION_TOOLTIP',
    /**
     * @protobufOption (milestoneType) = USER
     */
    INVENTORY_EDUCATION_CARD_SEEN = 'INVENTORY_EDUCATION_CARD_SEEN',
    /**
     * @protobufOption (milestoneType) = USER
     */
    BRAND_HAS_SEEN_SAMPLES_TOOLTIP = 'BRAND_HAS_SEEN_SAMPLES_TOOLTIP',
    /**
     * @protobufOption (milestoneType) = USER
     */
    EDIT_ORDER_EDUCATION_TOOLTIP = 'EDIT_ORDER_EDUCATION_TOOLTIP',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    NET90_UPDATE_LEAD_TIMES_BANNER_2020 = 'NET90_UPDATE_LEAD_TIMES_BANNER_2020',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    CUSTOMERS_V3_WELCOME_MODAL_SEEN = 'CUSTOMERS_V3_WELCOME_MODAL_SEEN',
    /**
     * Controls whether the un-contacted customers banner should be displayed or not
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    UNCONTACTED_CUSTOMERS_BANNER_DISMISSED = 'UNCONTACTED_CUSTOMERS_BANNER_DISMISSED',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_INTEGRATION_WALKTHROUGH_COMPLETE = 'SHOPIFY_INTEGRATION_WALKTHROUGH_COMPLETE',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    ATTRIBUTE_UPLOADER_BANNER_DISMISSED_ON_HOME = 'ATTRIBUTE_UPLOADER_BANNER_DISMISSED_ON_HOME',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    ATTRIBUTE_UPLOADER_BANNER_DISMISSED_ON_PRODUCTS = 'ATTRIBUTE_UPLOADER_BANNER_DISMISSED_ON_PRODUCTS',
    /**
     * Set when brand has provided a sufficient threshold of apparel product attribute data so we stop prompting them in
     * brand portal. Currently for apparel products / attributes only.
     * Retired with the shutting down of the apparel attribute uploader.
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    APPAREL_PRODUCT_ATTRIBUTES_COMPLETED = 'APPAREL_PRODUCT_ATTRIBUTES_COMPLETED',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    PURCHASE_ORDER_SEEN_WELCOME_MODAL = 'PURCHASE_ORDER_SEEN_WELCOME_MODAL',
    /**
     * @protobufOption (milestoneType) = USER
     */
    FAIRE_DIRECT_EDUCATION_PAGE_SEEN = 'FAIRE_DIRECT_EDUCATION_PAGE_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_INTEGRATION_EARLY_ACCESS_FORM_SUBMITTED = 'SHOPIFY_INTEGRATION_EARLY_ACCESS_FORM_SUBMITTED',
    /**
     * @protobufOption (milestoneType) = USER
     */
    BRAND_HAS_DISMISSED_SAMPLES_EDUCATION_BANNER = 'BRAND_HAS_DISMISSED_SAMPLES_EDUCATION_BANNER',
    /**
     * @protobufOption (milestoneType) = USER
     */
    BRAND_HAS_SEEN_VIDEO_UPLOAD_TOOLTIP = 'BRAND_HAS_SEEN_VIDEO_UPLOAD_TOOLTIP',
    /**
     * Set when brand sees the modal prompting them GBR alpha launch and gives them the option to opt-out.
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_GBR_LAUNCH_ALPHA_MODAL = 'BRAND_HAS_SEEN_GBR_LAUNCH_ALPHA_MODAL',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    POSTMARK_CREATE_SENDER_SIGNATURE_MODAL_SEEN = 'POSTMARK_CREATE_SENDER_SIGNATURE_MODAL_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    POSTMARK_CREATE_SENDER_SIGNATURE_SUCCESS_MODAL_SEEN = 'POSTMARK_CREATE_SENDER_SIGNATURE_SUCCESS_MODAL_SEEN',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DISMISSED_FWM_EMAIL_TEMPLATE_BANNER = 'BRAND_DISMISSED_FWM_EMAIL_TEMPLATE_BANNER',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    FWM_2021_UPLOAD_APPAREL_PREORDERS_REMINDER_SEEN_ON_DISTINCT_DAY = 'FWM_2021_UPLOAD_APPAREL_PREORDERS_REMINDER_SEEN_ON_DISTINCT_DAY',
    /**
     * Set when a brand submits the preparedness survey after walkthrough
     * @protobufOption (milestoneType) = BRAND
     */
    WALKTHROUGH_PREPAREDNESS_SURVEY_SUBMITTED = 'WALKTHROUGH_PREPAREDNESS_SURVEY_SUBMITTED',
    /**
     * Set when a brand dismisses the preparedness survey after walkthrough
     * @protobufOption (milestoneType) = BRAND
     */
    WALKTHROUGH_PREPAREDNESS_SURVEY_DISMISSED = 'WALKTHROUGH_PREPAREDNESS_SURVEY_DISMISSED',
    /**
     * Set when a brand beings the introductory walkthrough
     * @protobufOption (milestoneType) = BRAND
     */
    NEW_BRAND_WALKTHROUGH_STARTED = 'NEW_BRAND_WALKTHROUGH_STARTED',
    /**
     * Set when a brand completes all required steps in the introductory walkthrough
     * @protobufOption (milestoneType) = BRAND
     */
    NEW_BRAND_WALKTHROUGH_COMPLETED = 'NEW_BRAND_WALKTHROUGH_COMPLETED',
    /**
     * Set when brand dismisses Shopify banner in home page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_HOME = 'SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_HOME',
    /**
     * Set when brand dismisses Shopify banner in inventory page
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_INVENTORY = 'SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_INVENTORY',
    /**
     * Set when brand dismisses Shopify banner in orders page
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_ORDERS = 'SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_ORDERS',
    /**
     * Set when brand dismisses Shopify settings tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_SETTINGS_TOOLTIP_DISMISSED = 'SHOPIFY_SETTINGS_TOOLTIP_DISMISSED',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_LOYALTY_PROGRAM_BANNER_VIEWED = 'BRAND_LOYALTY_PROGRAM_BANNER_VIEWED',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_LOYALTY_WELCOME_MODAL_SEEN = 'BRAND_LOYALTY_WELCOME_MODAL_SEEN',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_ONBOARDING_CATALOG_PAGE_SEEN = 'BRAND_ONBOARDING_CATALOG_PAGE_SEEN',
    /**
     * Set when brand dismisses Shopify banner in Products page
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_PRODUCTS = 'SHOPIFY_ENTRYPOINT_BANNER_DISMISSED_PRODUCTS',
    /**
     * Set when brand performs their first catalog import or chooses a pricing method in the integrations setting page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_CATALOG_IMPORT_PRICE_CONVERSION_PREFERENCE_SET = 'SHOPIFY_CATALOG_IMPORT_PRICE_CONVERSION_PREFERENCE_SET',
    /**
     * Set when a brand dismisses the bulk uploader banner on the homepage
     * Retired due to removal of the bulk uploader banner
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_BULK_UPLOADER_HOME_PAGE_BANNER_DISMISSED = 'BRAND_BULK_UPLOADER_HOME_PAGE_BANNER_DISMISSED',
    /**
     * Set when a brand submits a bulk upload
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_BULK_UPLOADER_SUBMITTED_UPLOAD = 'BRAND_BULK_UPLOADER_SUBMITTED_UPLOAD',
    /**
     * Set when the survey for sku update frequency is shown
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_SKU_UPDATE_FREQUENCY_SURVEY_SHOWN = 'BRAND_SKU_UPDATE_FREQUENCY_SURVEY_SHOWN',
    /**
     * Set when brand see and close the tooltip for customer selection modal
     * @protobufOption (milestoneType) = USER
     */
    BRAND_INVOICING_CUSTOMER_SELECTION_TOOLTIP_SEEN = 'BRAND_INVOICING_CUSTOMER_SELECTION_TOOLTIP_SEEN',
    /**
     * Set when brand see and close the tooltip for write order button on CRM/Messenger
     * @protobufOption (milestoneType) = USER
     */
    BRAND_INVOICING_WRITE_ORDER_BUTTON_TOOLTIP_SEEN = 'BRAND_INVOICING_WRITE_ORDER_BUTTON_TOOLTIP_SEEN',
    /**
     * Set when brand dismisses the upfront payments (Faire Advance) enrollment modal
     * @protobufOption (milestoneType) = BRAND
     */
    UPFRONT_PAYMENTS_ENROLLMENT_MODAL_DISMISSED = 'UPFRONT_PAYMENTS_ENROLLMENT_MODAL_DISMISSED',
    /**
     * Set when brand dismisses the upfront payments (Faire Advance) enrolled banner for add preorder products
     * @protobufOption (milestoneType) = BRAND
     */
    UPFRONT_PAYMENTS_ENROLLED_PRODUCTS_BANNER_DISMISSED = 'UPFRONT_PAYMENTS_ENROLLED_PRODUCTS_BANNER_DISMISSED',
    /**
     * Set when brand dismisses the upfront payments (Faire Advance) enrolled banner for invite FD customers
     * @protobufOption (milestoneType) = BRAND
     */
    UPFRONT_PAYMENTS_ENROLLED_CUSTOMERS_BANNER_DISMISSED = 'UPFRONT_PAYMENTS_ENROLLED_CUSTOMERS_BANNER_DISMISSED',
    /**
     * Set when brand dismisses the shop assistant tooltip upon reopening
     * @protobufOption (milestoneType) = BRAND
     */
    SHOP_ASSISTANT_REOPEN_TOOLTIP_DISMISSED = 'SHOP_ASSISTANT_REOPEN_TOOLTIP_DISMISSED',
    /**
     * Set when brand see and close the tooltip for product recommendation
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_INVOICE_PRODUCT_RECOMMENDATION_TOOLTIP_SEEN = 'BRAND_INVOICE_PRODUCT_RECOMMENDATION_TOOLTIP_SEEN',
    /**
     * Set when brand see and close the tooltip on the bulk upload overview page prompting them on next steps
     * @protobufOption (milestoneType) = USER
     */
    BRAND_BULK_UPLOADER_OVERVIEW_TOOLTIP_DISMISSED = 'BRAND_BULK_UPLOADER_OVERVIEW_TOOLTIP_DISMISSED',
    /**
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_SUMMER_MARKET_2021_BRAND_RSVP = 'FAIRE_SUMMER_MARKET_2021_BRAND_RSVP',
    /**
     * Set when brand see and close the tooltip on the Orders table telling them about the new commission column
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    ORDERS_TABLE_COMMISSION_TOOLTIP_SEEN = 'ORDERS_TABLE_COMMISSION_TOOLTIP_SEEN',
    /**
     * Set when the brand completes the Faire Fashion Week RSVP flow
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FASHION_WEEK_RSVP_COMPLETED = 'BRAND_FASHION_WEEK_RSVP_COMPLETED',
    /**
     * Set when the brand completes the Faire Fashion add customers flow
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FASHION_WEEK_ADD_CUSTOMERS_COMPLETED = 'BRAND_FASHION_WEEK_ADD_CUSTOMERS_COMPLETED',
    /**
     * Set when the brand sends a fashion week campaign
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FASHION_WEEK_SEND_FASHION_WEEK_CAMPAIGN_COMPLETED = 'BRAND_FASHION_WEEK_SEND_FASHION_WEEK_CAMPAIGN_COMPLETED',
    /**
     * Set to ensure the brand only sees the Add Customer tooltip for Faire Fashion Week once
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FASHION_WEEK_ADD_CUSTOMERS_TOOLTIP_DISMISSED = 'BRAND_FASHION_WEEK_ADD_CUSTOMERS_TOOLTIP_DISMISSED',
    /**
     * Set to ensure the brand is only informed of the existence of the Payouts page until they
     * visit the page for the first time.
     * @protobufOption (milestoneType) = BRAND
     */
    PAYOUTS_TOOLTIP_DISMISSED = 'PAYOUTS_TOOLTIP_DISMISSED',
    /**
     * Set when the brand sends a Faire Fashion Week campaign to promote their product line
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FASHION_WEEK_SEND_PRODUCTS_CAMPAIGN_COMPLETED = 'BRAND_FASHION_WEEK_SEND_PRODUCTS_CAMPAIGN_COMPLETED',
    /**
     * Set when a self-serve onboarding brand closes the catalog completeness banner
     * @protobufOption (milestoneType) = BRAND
     */
    SELF_SERVE_CATALOG_COMPLETENESS_BANNER_CLOSED = 'SELF_SERVE_CATALOG_COMPLETENESS_BANNER_CLOSED',
    /**
     * Set when the brand views the Top Shop landing page
     * @protobufOption (milestoneType) = USER
     */
    TOP_SHOP_LANDING_PAGE_SEEN = 'TOP_SHOP_LANDING_PAGE_SEEN',
    /**
     * Set when the brand closes the Homepage Top Shop banner
     * @protobufOption (milestoneType) = USER
     */
    TOP_SHOP_BANNER_SEEN = 'TOP_SHOP_BANNER_SEEN',
    /**
     * Set when the brand finishes enabling Faire Direct marketing campaign reminders
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FASHION_WEEK_CAMPAIGN_REMINDERS_COMPLETED = 'BRAND_FASHION_WEEK_CAMPAIGN_REMINDERS_COMPLETED',
    /**
     * Set when the brand clicks into Faire Fashion Week campaign to promote their product line
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FASHION_WEEK_PRODUCTS_CAMPAIGN_TASK_SEEN = 'BRAND_FASHION_WEEK_PRODUCTS_CAMPAIGN_TASK_SEEN',
    /**
     * Set when brand user completes adyen onboarding and dismiss the nudge
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_ADYEN_ONBOARDING_NUDGE_DISMISSED = 'BRAND_ADYEN_ONBOARDING_NUDGE_DISMISSED',
    /**
     * Set when the brand closes the Faire Direct Rewards intro page
     * @protobufOption (milestoneType) = USER
     */
    FAIRE_DIRECT_REWARDS_INTRO_SEEN = 'FAIRE_DIRECT_REWARDS_INTRO_SEEN',
    /**
     * Set when the brand closes the Homepage Faire Direct Rewards banner
     * @protobufOption (milestoneType) = USER
     */
    FAIRE_DIRECT_REWARDS_BANNER_SEEN = 'FAIRE_DIRECT_REWARDS_BANNER_SEEN',
    /**
     * Set when the brand closes the tooltip that nudges them to review draft products imported from Shopify
     * @protobufOption (milestoneType) = BRAND
     */
    REVIEW_PRODUCTS_IMPORTED_FROM_SHOPIFY_TOOLTIP_DISMISSED = 'REVIEW_PRODUCTS_IMPORTED_FROM_SHOPIFY_TOOLTIP_DISMISSED',
    /**
     * Set when pending referral eligibility modal is seen on b2b page
     * @protobufOption (milestoneType) = BRAND
     */
    B2B_PENDING_REFERRAL_ELIGIBILITY_MODAL_SEEN = 'B2B_PENDING_REFERRAL_ELIGIBILITY_MODAL_SEEN',
    /**
     * Whether the brand has seen the "Edit all products at once" tooltip
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_BULK_PRODUCT_EDITOR_EDIT_ALL_PRODUCTS_TOOLTIP_SEEN = 'BRAND_BULK_PRODUCT_EDITOR_EDIT_ALL_PRODUCTS_TOOLTIP_SEEN',
    /**
     * Set when brand has not filled out SIREN number and see and close the reminder modal prompt
     * @protobufOption (milestoneType) = BRAND
     */
    FRANCE_BRAND_SIREN_MODAL_SEEN = 'FRANCE_BRAND_SIREN_MODAL_SEEN',
    /**
     * Set when brand has clicked the proforma invoice, the new tag will be removed
     * @protobufOption (milestoneType) = BRAND
     */
    PROFORMA_INVOICE_NEW_TAG_SEEN = 'PROFORMA_INVOICE_NEW_TAG_SEEN',
    /**
     * Set when brand has clicked the finalized invoice, the new tag will be removed
     * @protobufOption (milestoneType) = BRAND
     */
    FINALIZED_INVOICE_NEW_TAG_SEEN = 'FINALIZED_INVOICE_NEW_TAG_SEEN',
    /**
     * Set when brand see and close the tooltip on the invoice section of brand order fulfillment page
     * @protobufOption (milestoneType) = BRAND
     */
    TAXABLE_BRAND_INVOICE_TOOLTIP_DISMISSED = 'TAXABLE_BRAND_INVOICE_TOOLTIP_DISMISSED',
    /**
     * Set when brand see and close the brand invoice modal on the brand portal home page
     * @protobufOption (milestoneType) = BRAND
     */
    TAXABLE_BRAND_INVOICE_MODAL_SEEN = 'TAXABLE_BRAND_INVOICE_MODAL_SEEN',
    /**
     * Set when the brand sees the generic reoder rate tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_REORDER_RATE_GENERIC_SEEN = 'BRAND_TOP_SHOP_TIP_REORDER_RATE_GENERIC_SEEN',
    /**
     * Set when the brand sees the close to threshold reoder rate tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_REORDER_RATE_CLOSE_TO_THRESHOLD_SEEN = 'BRAND_TOP_SHOP_TIP_REORDER_RATE_CLOSE_TO_THRESHOLD_SEEN',
    /**
     * Set when the brand sees the reoder rate comprehension tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_REORDER_RATE_COMPREHENSION_SEEN = 'BRAND_TOP_SHOP_TIP_REORDER_RATE_COMPREHENSION_SEEN',
    /**
     * Set when the brand sees the run promotion tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_MERCHANDISING_RUN_PROMOTION_SEEN = 'BRAND_TOP_SHOP_TIP_MERCHANDISING_RUN_PROMOTION_SEEN',
    /**
     * Set when the brand sees the refresh catalog tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_MERCHANDISING_REFRESH_CATALOG_SEEN = 'BRAND_TOP_SHOP_TIP_MERCHANDISING_REFRESH_CATALOG_SEEN',
    /**
     * Set when the brand sees the active products tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_MERCHANDISING_ACTIVE_PRODUCTS_SEEN = 'BRAND_TOP_SHOP_TIP_MERCHANDISING_ACTIVE_PRODUCTS_SEEN',
    /**
     * Set when the brand sees the order minimum tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_MERCHANDISING_ORDER_MINIMUM_SEEN = 'BRAND_TOP_SHOP_TIP_MERCHANDISING_ORDER_MINIMUM_SEEN',
    /**
     * Set when the brand sees the lead time tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_PERFECT_ORDER_RATE_LEAD_TIME_SEEN = 'BRAND_TOP_SHOP_TIP_PERFECT_ORDER_RATE_LEAD_TIME_SEEN',
    /**
     * Set when the brand sees the shopify integration tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_PERFECT_ORDER_RATE_SHOPIFY_INTEGRATION_SEEN = 'BRAND_TOP_SHOP_TIP_PERFECT_ORDER_RATE_SHOPIFY_INTEGRATION_SEEN',
    /**
     * Set when the brand sees the retailer rating tip in homepage Top Shop widget
     * @protobufOption (milestoneType) = USER
     */
    BRAND_TOP_SHOP_TIP_RETAILER_RATING_SEEN = 'BRAND_TOP_SHOP_TIP_RETAILER_RATING_SEEN',
    /**
     * Whether the brand has dismissed the widget on the FF 2022 event page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_DISMISSED_FWM_22_WIDGET = 'BRAND_HAS_DISMISSED_FWM_22_WIDGET',
    /**
     * Count how many times the brand has visit the FFW 2022 event page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_VISITED_FWM_22_EVENT_PAGE = 'BRAND_HAS_VISITED_FWM_22_EVENT_PAGE',
    /**
     * Count how many times the brand has seen the Shopify Adoption button
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_SHOPIFY_ADOPTION = 'BRAND_HAS_SEEN_SHOPIFY_ADOPTION',
    /**
     * Track whether the brand has opened the shop assistant
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_OPENED_SHOP_ASSISTANT = 'BRAND_HAS_OPENED_SHOP_ASSISTANT',
    /**
     * Track whether the brand has seen the pop-up modal for being in the SET_UP_FAILED state
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_ADYEN_SET_UP_FAILED_POP_UP = 'BRAND_HAS_SEEN_ADYEN_SET_UP_FAILED_POP_UP',
    /**
     * Track whether the brand has seen the pop-up modal for being in the SET_UP_SUCCESS state
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_ADYEN_SET_UP_SUCCESS_POP_UP = 'BRAND_HAS_SEEN_ADYEN_SET_UP_SUCCESS_POP_UP',
    /**
     * Track whether the brand has seen the pop-up modal for being in the NEED_VERIFICATION_INFORMATION state
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_ADYEN_NEED_VERIFICATION_INFORMATION_POP_UP = 'BRAND_HAS_SEEN_ADYEN_NEED_VERIFICATION_INFORMATION_POP_UP',
    /**
     * Track whether the brand has seen the pop-up modal for being in the VERIFYING state
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_ADYEN_VERIFYING_POP_UP = 'BRAND_HAS_SEEN_ADYEN_VERIFYING_POP_UP',
    /**
     * Whether the brand has dismissed the Fashion Week '22 widget on the home page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_DISMISSED_FFW_22_WIDGET = 'BRAND_HAS_DISMISSED_FFW_22_WIDGET',
    /**
     * Whether the retailer has dismissed the Insider credits toast on the web retailer portal
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_INTERNATIONAL_CREDITS_WEB_TOAST_DISMISSED = 'INSIDER_INTERNATIONAL_CREDITS_WEB_TOAST_DISMISSED',
    /**
     * Track whether the brand has seen the banner on product page that encourage it to upload more products
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_PRODUCT_PAGE_SEEN = 'CATALOG_COMPLETE_NUDGE_PRODUCT_PAGE_SEEN',
    /**
     * Track whether the brand has seen the banner on homepage that encourage it to upload more products
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_HOMEPAGE_SEEN = 'CATALOG_COMPLETE_NUDGE_HOMEPAGE_SEEN',
    /**
     * Track whether the brand has dismissed the banner on product page that encourage it to upload more products
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_PRODUCT_PAGE_DISMISSED = 'CATALOG_COMPLETE_NUDGE_PRODUCT_PAGE_DISMISSED',
    /**
     * Set when the brand has integrated with Shopify and has any draft products
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_SHOPIFY_INTEGRATED_WITH_DRAFT_PRODUCTS = 'CATALOG_COMPLETE_NUDGE_SHOPIFY_INTEGRATED_WITH_DRAFT_PRODUCTS',
    /**
     * Set when the brand has less than 10 products added during their first 14 days on Faire
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_INSUFFICIENT_PRODUCTS_ADDED = 'CATALOG_COMPLETE_NUDGE_INSUFFICIENT_PRODUCTS_ADDED',
    /**
     * Set when the brand meets a threshold to add more products during their first 14 days on Faire
     * (e.g. 10 and 39 products added)
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_ADDED_PRODUCTS_THRESHOLD_1 = 'CATALOG_COMPLETE_NUDGE_ADDED_PRODUCTS_THRESHOLD_1',
    /**
     * Set when the brand meets a threshold to add more products during their first 14 days on Faire
     * (e.g. 40+ products added)
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_ADDED_PRODUCTS_THRESHOLD_2 = 'CATALOG_COMPLETE_NUDGE_ADDED_PRODUCTS_THRESHOLD_2',
    /**
     * Set when the brand meets a threshold to add more products during their first 14 days on Faire
     * (e.g. < 7 products away from their self reported total product count)
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_CLOSE_TO_CATALOG_COMPLETE = 'CATALOG_COMPLETE_NUDGE_CLOSE_TO_CATALOG_COMPLETE',
    /**
     * Set when the brand should not see a CCF14 Day Nudge banner anymore
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETE_NUDGE_BANNER_HIDDEN = 'CATALOG_COMPLETE_NUDGE_BANNER_HIDDEN',
    /**
     * Set when the brand sees the Australian announcement modal
     * @protobufOption (milestoneType) = USER
     */
    AUS_BRAND_ANNOUNCEMENT_MODAL = 'AUS_BRAND_ANNOUNCEMENT_MODAL',
    /**
     * Set when the brand closes the Faire Direct Rewards intro page V2
     * @protobufOption (milestoneType) = USER
     */
    FAIRE_DIRECT_REWARDS_INTRO_SEEN_V2 = 'FAIRE_DIRECT_REWARDS_INTRO_SEEN_V2',
    /**
     * Set when the brand clicks a cell on the bulk editor page for the first time
     * @protobufOption (milestoneType) = USER
     */
    FIRST_CELL_CLICK_ON_BULK_EDITOR_PAGE = 'FIRST_CELL_CLICK_ON_BULK_EDITOR_PAGE',
    /**
     * Set when the brand sees the Faire Direct Rewards Banner V2
     * @protobufOption (milestoneType) = USER
     */
    FAIRE_DIRECT_REWARDS_BANNER_V2_SEEN = 'FAIRE_DIRECT_REWARDS_BANNER_V2_SEEN',
    /**
     * Whether the brand has dismissed the local brand discount widget on the home page
     * @protobufOption (milestoneType) = BRAND
     */
    LOCAL_BRAND_DISCOUNT_ANNOUNCEMENT_BANNER_DISMISSED = 'LOCAL_BRAND_DISCOUNT_ANNOUNCEMENT_BANNER_DISMISSED',
    /**
     * Milestone to determine whether a brand has closed the Price parity modal
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_CLOSED_PRICE_PARITY_MODAL = 'BRAND_HAS_CLOSED_PRICE_PARITY_MODAL',
    /**
     * Milestone to determine whether a brand has closed the price parity reminder modal
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_CLOSED_PRICE_PARITY_REMINDER_MODAL = 'BRAND_HAS_CLOSED_PRICE_PARITY_REMINDER_MODAL',
    /**
     * Set when a brand user dismisses the initial notification for Nudge Hub
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_NUDGE_HUB_FIRST_TIME_EXPERIENCE_VIEWED = 'BRAND_NUDGE_HUB_FIRST_TIME_EXPERIENCE_VIEWED',
    /**
     * Brand has seen SWF Pickup banner for new features enabled by setting SWF_PICKUP_ENABLED_220422,
     * in Orders page
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_PICKUP_BANNER_SEEN_ORDERS = 'SWF_PICKUP_BANNER_SEEN_ORDERS',
    /**
     * Brand has seen SWF Pickup banner for new features enabled by setting SWF_PICKUP_ENABLED_220422,
     * in Brand Order Fulfillment page
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_PICKUP_BANNER_SEEN_ORDER_FULFILLMENT = 'SWF_PICKUP_BANNER_SEEN_ORDER_FULFILLMENT',
    /**
     * Brand has seen SWF Pickup tag for new features enabled by setting SWF_PICKUP_ENABLED_220422,
     * in Brand Order Fulfillment - Shipping Info
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_PICKUP_TAG_SEEN_SHIPPING_INFO = 'SWF_PICKUP_TAG_SEEN_SHIPPING_INFO',
    /**
     * Brand has a promotion collection split for Faire Summer Market 2022
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PROMOTION_SPLIT_FAIRE_SUMMER_MARKET_2022 = 'BRAND_PROMOTION_SPLIT_FAIRE_SUMMER_MARKET_2022',
    /**
     * Set when a brand user sees the notification triggered by a dismissal of a task notification
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_NUDGE_HUB_DISMISSED_NOTIFICATION_SHOWN = 'BRAND_NUDGE_HUB_DISMISSED_NOTIFICATION_SHOWN',
    /**
     * Brand has completed the modal containing the preorder brand identification survey
     * @protobufOption (milestoneType) = BRAND
     */
    PREORDER_BRAND_IDENTIFICATION_SURVEY_RESPONDED = 'PREORDER_BRAND_IDENTIFICATION_SURVEY_RESPONDED',
    /**
     * Brand has seen and dismissed the modal containing the preorder brand identification survey
     * @protobufOption (milestoneType) = BRAND
     */
    PREORDER_BRAND_IDENTIFICATION_SURVEY_DISMISSED = 'PREORDER_BRAND_IDENTIFICATION_SURVEY_DISMISSED',
    /**
     * Brand has seen CRM recommendation
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_CRM_RECOMMENDATION = 'BRAND_CRM_RECOMMENDATION',
    /**
     * Set when the brand is redirected to the Products page after registration and closes the modal prompting them to add products.
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DISMISS_REGISTRATION_COMPLETE_MODAL = 'BRAND_DISMISS_REGISTRATION_COMPLETE_MODAL',
    /**
     * Brand has seen the messenger template picker.
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_MESSENGER_TEMPLATE_PICKER = 'BRAND_HAS_SEEN_MESSENGER_TEMPLATE_PICKER',
    /**
     * Brand has seen the customers page chat bubble.
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_CUSTOMERS_PAGE_CHAT_BUBBLE = 'BRAND_HAS_SEEN_CUSTOMERS_PAGE_CHAT_BUBBLE',
    /**
     * Brand has seen nudge hub education for users reminding them they can come back later to see nudge hub tasks
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_NUDGE_HUB_COME_BACK_LATER_EDUCATION_NOTIFICATION = 'BRAND_HAS_SEEN_NUDGE_HUB_COME_BACK_LATER_EDUCATION_NOTIFICATION',
    /**
     * Brand has seen the content help modal on B2B page
     * @protobufOption (milestoneType) = USER
     */
    B2B_BRAND_CONTENT_HELP_MODAL_SEEN = 'B2B_BRAND_CONTENT_HELP_MODAL_SEEN',
    /**
     * Whether the brand has dismissed the widget on the FSM 2022 event page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_DISMISSED_FSM_22_WIDGET = 'BRAND_HAS_DISMISSED_FSM_22_WIDGET',
    /**
     * Count how many times the brand has visit the FSM 2022 event page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_VISITED_FSM_22_EVENT_PAGE = 'BRAND_HAS_VISITED_FSM_22_EVENT_PAGE',
    /**
     * Track if brand user has seen Shop Assistant first-time experience
     * @protobufOption (milestoneType) = USER
     */
    BRAND_NUDGE_HUB_SHOP_ASSISTANT_EDUCATION_VIEWED = 'BRAND_NUDGE_HUB_SHOP_ASSISTANT_EDUCATION_VIEWED',
    /**
     * Brand has seen the home page banner on B2B page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    B2B_BRAND_SHOULD_NOT_DISPLAY_HOME_PAGE_BANNER = 'B2B_BRAND_SHOULD_NOT_DISPLAY_HOME_PAGE_BANNER',
    /**
     * Brand has seen the banner to ship alcohol products with Ship On Your Own
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_SHIP_ALCOHOL_WITH_SHIP_ON_YOUR_OWN_BANNER = 'BRAND_HAS_SEEN_SHIP_ALCOHOL_WITH_SHIP_ON_YOUR_OWN_BANNER',
    /**
     * Brand is using Pricing Parity Specific Bulk Editor for the first time
     * @protobufOption (milestoneType) = USER
     */
    FIRST_TIME_BULK_EDITOR_WITH_PRICING_VIOLATIONS = 'FIRST_TIME_BULK_EDITOR_WITH_PRICING_VIOLATIONS',
    /**
     * Brand has successfully resolved pricing violations and banner is dismissed
     * @protobufOption (milestoneType) = BRAND
     */
    SUCCESSFUL_PRICING_VIOLATION_RESOLUTION = 'SUCCESSFUL_PRICING_VIOLATION_RESOLUTION',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_DISMISSED_FFW_V3_WIDGET = 'BRAND_HAS_DISMISSED_FFW_V3_WIDGET',
    /**
     * Brand has visited the Faire Fashion Week V3 post registration event page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_VISITED_FFW_V3_POST_REGISTRATION_EVENT_PAGE = 'BRAND_HAS_VISITED_FFW_V3_POST_REGISTRATION_EVENT_PAGE',
    /**
     * Brand has completed Faire Fashion Week V3 promotional events task - let retailers know you’re participating
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_COMPLETED_PROMOTIONAL_EVENTS_TASK_FFW_V3_LET_BUYERS_KNOW = 'BRAND_HAS_COMPLETED_PROMOTIONAL_EVENTS_TASK_FFW_V3_LET_BUYERS_KNOW',
    /**
     * Brand has completed Faire Fashion Week V3 promotional events task - invite customers to join Faire to shop the event
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_COMPLETED_PROMOTIONAL_EVENTS_TASK_FFW_V3_INVITE_CUSTOMERS = 'BRAND_HAS_COMPLETED_PROMOTIONAL_EVENTS_TASK_FFW_V3_INVITE_CUSTOMERS',
    /**
     * Set when credit reduction modal is seen on r2b page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    R2B_CREDIT_REDUCTION_MODAL_SEEN = 'R2B_CREDIT_REDUCTION_MODAL_SEEN',
    /**
     * Brand has dismissed the banner notifying them that FSM22 has ended
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_DISMISSED_POST_FSM_22_WIDGET = 'BRAND_HAS_DISMISSED_POST_FSM_22_WIDGET',
    /**
     * Brand has seen the new PPOL Product Editor Tooltip flow for Single Product
     * @protobufOption (milestoneType) = USER
     */
    BRAND_PRODUCT_EDITOR_SINGLE_PRODUCT_TOOLTIPS_SEEN = 'BRAND_PRODUCT_EDITOR_SINGLE_PRODUCT_TOOLTIPS_SEEN',
    /**
     * Brand has seen the new PPOL Product Editor Tooltip flow for Multiple Options
     * @protobufOption (milestoneType) = USER
     */
    BRAND_PRODUCT_EDITOR_MULTI_OPTION_TOOLTIPS_SEEN = 'BRAND_PRODUCT_EDITOR_MULTI_OPTION_TOOLTIPS_SEEN',
    /**
     * Brand has pricing violations and should see banner when resolved
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_PRICING_VIOLATIONS = 'BRAND_HAS_PRICING_VIOLATIONS',
    /**
     * Brand has made it's first edit using the pricing parity bulk editor
     * @protobufOption (milestoneType) = USER
     */
    PRICING_PARITY_BULK_EDITOR_FIRST_EDIT = 'PRICING_PARITY_BULK_EDITOR_FIRST_EDIT',
    /**
     * Count how many times the brand has visit the product delist banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_PRODUCT_DELIST_BANNER = 'BRAND_HAS_SEEN_PRODUCT_DELIST_BANNER',
    /**
     * Brand has opened Shop Assistant or after one day should show countdown New Arrivals Homepage banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_SHOULD_SEE_NEW_ARRIVALS_COUNTDOWN_HOMEPAGE_BANNER = 'BRAND_SHOULD_SEE_NEW_ARRIVALS_COUNTDOWN_HOMEPAGE_BANNER',
    /**
     * Brand has made its first visit to the product bulk editor to add food and beverage ingredients and attributes
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_FOOD_AND_BEVERAGE_ATTRIBUTES_OPTIMIZED_EDIT_FLOW = 'BRAND_HAS_SEEN_FOOD_AND_BEVERAGE_ATTRIBUTES_OPTIMIZED_EDIT_FLOW',
    /**
     * Brand has seen faire direct early life cycle first run and set their token_alias
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_FD_EARLY_LIFECYCLE_FIRST_RUN_EXPERIENCE = 'BRAND_HAS_SEEN_FD_EARLY_LIFECYCLE_FIRST_RUN_EXPERIENCE',
    /**
     * Brand has seen the B2B value-based incentives landing modal
     * @protobufOption (milestoneType) = BRAND
     */
    B2B_VALUE_BASED_INCENTIVES_LANDING_MODAL_SEEN = 'B2B_VALUE_BASED_INCENTIVES_LANDING_MODAL_SEEN',
    /**
     * Brand has seen the LUCID compliance check banner to add their registered LUCID number
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_LUCID_COMPLIANCE_CHECK_BANNER = 'BRAND_HAS_SEEN_LUCID_COMPLIANCE_CHECK_BANNER',
    /**
     * Brand has dismissed the NAM subsidy pullback banner
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED = 'NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED',
    /**
     * Brand has seen the NAM subsidy pullback banner
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    NAM_SUBSIDY_PULLBACK_BANNER_SEEN = 'NAM_SUBSIDY_PULLBACK_BANNER_SEEN',
    /**
     * Brand has seen the B2B value-based incentives banner in homepage
     * @protobufOption (milestoneType) = BRAND
     */
    B2B_HOME_PAGE_INCENTIVES_BANNER_SEEN = 'B2B_HOME_PAGE_INCENTIVES_BANNER_SEEN',
    /**
     * Brand has dismissed the integration awareness banner in homepage
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    HOME_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSED = 'HOME_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSED',
    /**
     * total # of product csv uploads/ inventory csv uploads/ order csv exports post the last time homepage integration awareness banner dismissal
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CSV_ACTIONS_SINCE_LAST_HOME_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSAL = 'CSV_ACTIONS_SINCE_LAST_HOME_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSAL',
    /**
     * Brand has dismissed the integration awareness banner in product page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSED = 'PRODUCT_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSED',
    /**
     * total # of product csv uploads/ inventory csv uploads/ order csv exports post the last time product page integration awareness banner dismissal
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CSV_ACTIONS_SINCE_LAST_PRODUCT_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSAL = 'CSV_ACTIONS_SINCE_LAST_PRODUCT_PAGE_INTEGRATION_AWARENESS_BANNER_DISMISSAL',
    /**
     * Brand has dismissed any integration awareness banner in bulk uploader page/ inventory page/ order page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    GENERAL_INTEGRATION_AWARENESS_BANNER_DISMISSED = 'GENERAL_INTEGRATION_AWARENESS_BANNER_DISMISSED',
    /**
     * total # of product csv uploads/ inventory csv uploads/ order csv exports post the last time product page integration awareness banner dismissal
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CSV_ACTIONS_SINCE_LAST_GENERAL_INTEGRATION_AWARENESS_BANNER_DISMISSAL = 'CSV_ACTIONS_SINCE_LAST_GENERAL_INTEGRATION_AWARENESS_BANNER_DISMISSAL',
    /**
     * total # of inventory csv uploads
     * @protobufOption (milestoneType) = BRAND
     */
    INVENTORY_CSV_UPLOAD = 'INVENTORY_CSV_UPLOAD',
    /**
     * total # of order csv exports
     * @protobufOption (milestoneType) = BRAND
     */
    ORDER_CSV_EXPORT = 'ORDER_CSV_EXPORT',
    /**
     * Brand has seen the pre activation shop feedback tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    PRE_ACTIVATION_SHOP_FEEDBACK_TOOLTIP_SEEN = 'PRE_ACTIVATION_SHOP_FEEDBACK_TOOLTIP_SEEN',
    /**
     * total # of product csv uploads
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_CSV_UPLOAD = 'PRODUCT_CSV_UPLOAD',
    /**
     * Brand has received an integration adoption email
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_INTEGRATION_ADOPTION_EMAIL_SENT = 'BRAND_INTEGRATION_ADOPTION_EMAIL_SENT',
    /**
     * Brand has seen the Apparel Collections Table Tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_APPAREL_COLLECTIONS_TABLE_TOOLTIP_SEEN = 'BRAND_APPAREL_COLLECTIONS_TABLE_TOOLTIP_SEEN',
    /**
     * Brand has seen the Apparel Collection Editor Items Table Tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_APPAREL_COLLECTION_ITEMS_TABLE_TOOLTIP_SEEN = 'BRAND_APPAREL_COLLECTION_ITEMS_TABLE_TOOLTIP_SEEN',
    /**
     * Brand has seen the Shopify Integration pricing sync education banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_SHOPIFY_INTEGRATION_PRICING_SYNC_BANNER_SEEN = 'BRAND_SHOPIFY_INTEGRATION_PRICING_SYNC_BANNER_SEEN',
    /**
     * Brand has dismissed the European Co-funded Subsidy home banner
     * @protobufOption (milestoneType) = BRAND
     */
    EUROPEAN_CO_FUNDED_SUBSIDY_HOME_BANNER_DISMISSED = 'EUROPEAN_CO_FUNDED_SUBSIDY_HOME_BANNER_DISMISSED',
    /**
     * Brand has dismissed the European Co-funded Subsidy order banner
     * @protobufOption (milestoneType) = BRAND
     */
    EUROPEAN_CO_FUNDED_SUBSIDY_ORDERS_BANNER_DISMISSED = 'EUROPEAN_CO_FUNDED_SUBSIDY_ORDERS_BANNER_DISMISSED',
    /**
     * Brand has dismissed the European Co-funded Subsidy promotions banner
     * @protobufOption (milestoneType) = BRAND
     */
    EUROPEAN_CO_FUNDED_SUBSIDY_PROMOTIONS_BANNER_DISMISSED = 'EUROPEAN_CO_FUNDED_SUBSIDY_PROMOTIONS_BANNER_DISMISSED',
    /**
     * Brand has seen the Customer Table Updates Modal
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_CUSTOMER_TABLE_UPDATES_MODAL_SEEN = 'BRAND_CUSTOMER_TABLE_UPDATES_MODAL_SEEN',
    /**
     * Brand has seen and dismissed the tooltip above "Break Down Prepacks" toggle in Product Editor
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_EDITOR_BREAK_DOWN_PREPACKS_TOGGLE_TOOLTIP_DISMISSED = 'PRODUCT_EDITOR_BREAK_DOWN_PREPACKS_TOGGLE_TOOLTIP_DISMISSED',
    /**
     * Brand has seen banner rendered on home page
     * @protobufOption (milestoneType) = BRAND
     */
    EUROPEAN_CO_FUNDED_SUBSIDY_HOME_BANNER_SEEN = 'EUROPEAN_CO_FUNDED_SUBSIDY_HOME_BANNER_SEEN',
    /**
     * Set when the brand sees the Faire Direct Rewards announcement of new terms and conditions
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_REWARDS_TERMS_AND_CONDITIONS_MODAL_SEEN = 'FAIRE_DIRECT_REWARDS_TERMS_AND_CONDITIONS_MODAL_SEEN',
    /**
     * Set when the brand dismisses the Faire Direct Rewards announcement of new terms and conditions
     * either by clicking `x` or `close`
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_REWARDS_TERMS_AND_CONDITIONS_MODAL_DISMISSED = 'FAIRE_DIRECT_REWARDS_TERMS_AND_CONDITIONS_MODAL_DISMISSED',
    /**
     * Set when brand uploads product catalog and price increases more than 5%
     * @protobufOption (milestoneType) = BRAND
     */
    BULK_UPLOADER_PRICE_INCREASED = 'BULK_UPLOADER_PRICE_INCREASED',
    /**
     * Set when the brand dismisses the bulk uploader price increase check banner by clicking `x`
     * Reset when brand uploads product catalog and price increases more than 5%
     * @protobufOption (milestoneType) = BRAND
     */
    BULK_UPLOADER_PRICE_CHECK_BANNER_DISMISSED = 'BULK_UPLOADER_PRICE_CHECK_BANNER_DISMISSED',
    /**
     * Set when the brand dismisses the BCFS discovery banner on Orders page by clicking `x`
     * @protobufOption (milestoneType) = BRAND
     */
    BCFS_ORDERS_PAGE_DISCOVERY_BANNER_DISMISSED = 'BCFS_ORDERS_PAGE_DISCOVERY_BANNER_DISMISSED',
    /**
     * Set when the brand dismisses the BCFS discovery banner on Promotions page by clicking `x`
     * @protobufOption (milestoneType) = BRAND
     */
    BCFS_PROMOTIONS_PAGE_DISCOVERY_BANNER_DISMISSED = 'BCFS_PROMOTIONS_PAGE_DISCOVERY_BANNER_DISMISSED',
    /**
     * Brand has a promotion collection split for Faire Winter Market 2023
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PROMOTION_SPLIT_FAIRE_WINTER_MARKET_2023 = 'BRAND_PROMOTION_SPLIT_FAIRE_WINTER_MARKET_2023',
    /**
     * Set when the brand sees the go-to-market banner for the brand customer service page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_SEEN_CUSTOMER_SERVICE_GTM_BANNER = 'BRAND_SEEN_CUSTOMER_SERVICE_GTM_BANNER',
    /**
     * Set when the brand dismisses the go-to-market banner for the brand customer service page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DISMISSED_CUSTOMER_SERVICE_GTM_BANNER = 'BRAND_DISMISSED_CUSTOMER_SERVICE_GTM_BANNER',
    /**
     * Set when the brand sees the intro banner for SOYO Validation
     * @protobufOption (milestoneType) = BRAND
     */
    SOYO_VALIDATION_INTRO_BANNER_SEEN = 'SOYO_VALIDATION_INTRO_BANNER_SEEN',
    /**
     * Brand has dismissed full name subsidy pullback warning
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FULL_NAM_SUBSIDY_PULLBACK_ADVANCE_WARNING_BANNER_DISMISSED = 'BRAND_FULL_NAM_SUBSIDY_PULLBACK_ADVANCE_WARNING_BANNER_DISMISSED',
    /**
     * Set when the brand has seen the BCFS discovery banner on Orders page
     * @protobufOption (milestoneType) = BRAND
     */
    BCFS_ORDERS_PAGE_DISCOVERY_BANNER_SEEN = 'BCFS_ORDERS_PAGE_DISCOVERY_BANNER_SEEN',
    /**
     * Set when the brand has seen the BCFS discovery banner on Promotions page
     * @protobufOption (milestoneType) = BRAND
     */
    BCFS_PROMOTIONS_PAGE_DISCOVERY_BANNER_SEEN = 'BCFS_PROMOTIONS_PAGE_DISCOVERY_BANNER_SEEN',
    /**
     * Set when the brand has seen the sample education page and started accepting samples for the first time
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    SAMPLE_EDUCATION_PAGE_ACCEPTED = 'SAMPLE_EDUCATION_PAGE_ACCEPTED',
    /**
     * Brand has seen full NAM subsidy pullback warning banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FULL_NAM_SUBSIDY_PULLBACK_ADVANCE_WARNING_BANNER_SEEN = 'BRAND_FULL_NAM_SUBSIDY_PULLBACK_ADVANCE_WARNING_BANNER_SEEN',
    /**
     * set when a brand user has dismissed the sunset local discount banner
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    SUNSET_LOCAL_DISCOUNT_ANNOUNCEMENT_BANNER_DISMISSED = 'SUNSET_LOCAL_DISCOUNT_ANNOUNCEMENT_BANNER_DISMISSED',
    /**
     * Tracks how many times the sunset local discount banner has been seen
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    SUNSET_LOCAL_DISCOUNT_ANNOUNCEMENT_BANNER_SEEN = 'SUNSET_LOCAL_DISCOUNT_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * Brand has dismissed the full NAM subsidy pullback banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FULL_NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED = 'BRAND_FULL_NAM_SUBSIDY_PULLBACK_BANNER_DISMISSED',
    /**
     * Set when a brand user has dismissed the line sheet rearrange products tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_LINE_SHEET_REARRANGE_PRODUCTS_TOOLTIP_DISMISSED = 'BRAND_LINE_SHEET_REARRANGE_PRODUCTS_TOOLTIP_DISMISSED',
    /**
     * Incremented when a brand user is shown the email campaign educational modal when publishing a product based collection
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PRODUCT_BASED_COLLECTIONS_PUBLISH_CAMPAIGN_MODAL_SHOW_COUNT = 'BRAND_PRODUCT_BASED_COLLECTIONS_PUBLISH_CAMPAIGN_MODAL_SHOW_COUNT',
    /**
     * Set when a brand user has dismissed the email composer banner letting the user know that we prefilled their template
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PRODUCT_BASED_COLLECTIONS_PUBLISH_CAMPAIGN_PREFILL_BANNER_DISMISSED = 'BRAND_PRODUCT_BASED_COLLECTIONS_PUBLISH_CAMPAIGN_PREFILL_BANNER_DISMISSED',
    /**
     * Set when a brand user has seen product based collections
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_SEEN_PRODUCT_BASED_COLLECTIONS = 'HAS_SEEN_PRODUCT_BASED_COLLECTIONS',
    /**
     * Set when a brand has dismissed the brand tags alert banner
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_DISMISSED_BRAND_TAGS_ALERT_BANNER = 'HAS_DISMISSED_BRAND_TAGS_ALERT_BANNER',
    /**
     * Set when a brand has dismissed the Shopify Sales Channel migration reminder banner in brand portal homepage
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_SALES_CHANNEL_MIGRATION_HOMEPAGE_BANNER_DISMISSED = 'SHOPIFY_SALES_CHANNEL_MIGRATION_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set when a brand has dismissed the Shopify Sales Channel migration reminder modal in brand portal homepage
     * @protobufOption (milestoneType) = BRAND
     */
    SHOPIFY_SALES_CHANNEL_MIGRATION_HOMEPAGE_MODAL_DISMISSED = 'SHOPIFY_SALES_CHANNEL_MIGRATION_HOMEPAGE_MODAL_DISMISSED',
    /**
     * Set when a brand user has updated their brand tags
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_UPDATED_BRAND_TAGS = 'HAS_UPDATED_BRAND_TAGS',
    /**
     * Set when the brand dismisses the SWF Canada announcement banner on Orders page by clicking `x`
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_CANADA_ORDERS_PAGE_ANNOUNCEMENT_BANNER_DISMISSED = 'SWF_CANADA_ORDERS_PAGE_ANNOUNCEMENT_BANNER_DISMISSED',
    /**
     * Set when the brand sees the SWF Canada announcement banner on Orders page
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_CANADA_ORDERS_PAGE_ANNOUNCEMENT_BANNER_SEEN = 'SWF_CANADA_ORDERS_PAGE_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * Set when the brand sees the SWF Canada announcement banner on Order Fulfillment page
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_CANADA_ORDER_FULFILLMENT_PAGE_ANNOUNCEMENT_BANNER_SEEN = 'SWF_CANADA_ORDER_FULFILLMENT_PAGE_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * Set when we auto-select SWF tab for the brand in Order Fulfillment page
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_CANADA_TAB_AUTO_SELECTED = 'SWF_CANADA_TAB_AUTO_SELECTED',
    /**
     * Set when brand has seen the international shipping checklist
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_SEEN_INTERNATIONAL_SHIPPING_CHECKLIST = 'HAS_SEEN_INTERNATIONAL_SHIPPING_CHECKLIST',
    /**
     * Set when the brand dismisses the homepage banner for Faire Direct widget v2 announcement
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_WIDGET_V2_HOMEPAGE_BANNER_DISMISSED = 'FAIRE_DIRECT_WIDGET_V2_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set when brand has seen the User-Level Promotion (ULP) banner
     * @protobufOption (milestoneType) = BRAND
     */
    ULP_G2M_BANNER_SEEN = 'ULP_G2M_BANNER_SEEN',
    /**
     * Set when brand has seen the first international order modal
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_SEEN_FIRST_INTERNATIONAL_ORDER_MODAL = 'HAS_SEEN_FIRST_INTERNATIONAL_ORDER_MODAL',
    /**
     * Set when the brand sees the Faire Direct Rewards opt-in page
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_REWARDS_ONBOARDING_OPT_IN_SEEN = 'FAIRE_DIRECT_REWARDS_ONBOARDING_OPT_IN_SEEN',
    /**
     * Set when the brand clicks to opt in to Faire Direct Rewards
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_REWARDS_ONBOARDING_OPT_IN_CLICKED = 'FAIRE_DIRECT_REWARDS_ONBOARDING_OPT_IN_CLICKED',
    /**
     * Set when the brand sees the referral policy TOS modal
     * @protobufOption (milestoneType) = BRAND
     */
    B2B_REFERRAL_POLICY_TOS_MODAL_SEEN = 'B2B_REFERRAL_POLICY_TOS_MODAL_SEEN',
    /**
     * Set when the brand dismisses the attribute GTM tooltip in products bulk editor page
     * @protobufOption (milestoneType) = BRAND
     */
    BULK_EDITOR_ATTRIBUTE_GTM_TOOLTIP_DISMISSED = 'BULK_EDITOR_ATTRIBUTE_GTM_TOOLTIP_DISMISSED',
    /**
     * Set when the brand dismisses the attribute GTM homepage banner
     * @protobufOption (milestoneType) = BRAND
     */
    ATTRIBUTE_GTM_HOMEPAGE_BANNER_DISMISSED = 'ATTRIBUTE_GTM_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set when the brand dismisses the attribute GTM product page banner
     * @protobufOption (milestoneType) = BRAND
     */
    ATTRIBUTE_GTM_PRODUCT_PAGE_BANNER_DISMISSED = 'ATTRIBUTE_GTM_PRODUCT_PAGE_BANNER_DISMISSED',
    /**
     * Set when the brand dismisses the attribute GTM bulk editor page banner
     * @protobufOption (milestoneType) = BRAND
     */
    ATTRIBUTE_GTM_BULK_EDITOR_PAGE_BANNER_DISMISSED = 'ATTRIBUTE_GTM_BULK_EDITOR_PAGE_BANNER_DISMISSED',
    /**
     * Set when the brand dimisses the currency conversion notification tooltip on brand minimum page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_MINIMUM_EU_CONSOLIDATION_CURRENCY_CONVERSION_TOOLTIP_SEEN = 'BRAND_MINIMUM_EU_CONSOLIDATION_CURRENCY_CONVERSION_TOOLTIP_SEEN',
    /**
     * Set when the brand dismisses the Faire Direct Rewards enrolled brand engagement banner on the home page
     * by clicking `x` [FD-134629]
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_REWARDS_BRAND_ENGAGEMENT_HOMEPAGE_BANNER_DISMISSED = 'FAIRE_DIRECT_REWARDS_BRAND_ENGAGEMENT_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set when the brand dismisses the Insider shipping update and evergreen free shipping and duties pullback notification banner on brand portal
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_SHIPPING_UPDATE_ANNOUNCEMENT_BANNER_DISMISSED = 'INSIDER_SHIPPING_UPDATE_ANNOUNCEMENT_BANNER_DISMISSED',
    /**
     * Set when the brand sees the Insider shipping update and evergreen free shipping and duties pullback notification banner on brand portal
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_SHIPPING_UPDATE_ANNOUNCEMENT_BANNER_SEEN = 'INSIDER_SHIPPING_UPDATE_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * Set when the brand dismisses the go-to-market home page banner for top shop revamp
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DISMISSED_TOP_SHOP_GTM_HOMEPAGE_BANNER = 'BRAND_DISMISSED_TOP_SHOP_GTM_HOMEPAGE_BANNER',
    /**
     * Set when the brand dismisses the Insider shipping available in France, Germany and Nordics notification banner on brand portal
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_SHIPPING_AVAILABLE_ANNOUNCEMENT_BANNER_DISMISSED = 'INSIDER_SHIPPING_AVAILABLE_ANNOUNCEMENT_BANNER_DISMISSED',
    /**
     * Set when the brand sees the Insider shipping available in France, Germany and Nordics notification banner on brand portal
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_SHIPPING_AVAILABLE_ANNOUNCEMENT_BANNER_SEEN = 'INSIDER_SHIPPING_AVAILABLE_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * Set when brand with collections click into collections tab with a new tag, or set for brands don't have collections when feature launch
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DISPLAY_COLLECTION_NEW_TAG_SEEN = 'BRAND_DISPLAY_COLLECTION_NEW_TAG_SEEN',
    /**
     * Set when brand dismiss display collection announcement banner on collection page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DISPLAY_COLLECTION_COLLECTION_PAGE_BANNER_DISMISSED = 'BRAND_DISPLAY_COLLECTION_COLLECTION_PAGE_BANNER_DISMISSED',
    /**
     * Set when the brand sees the helper text for the Product Language attribute on the product page
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_LANGUAGE_HELPER_TEXT_SEEN = 'PRODUCT_LANGUAGE_HELPER_TEXT_SEEN',
    /**
     * Set when brand has seen the SwF DHL and UPS Pickups banner on the Orders or Order Fulfillment page
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_DHL_AND_UPS_PICKUP_BANNER_SEEN = 'SWF_DHL_AND_UPS_PICKUP_BANNER_SEEN',
    /**
     * Set when brand dismissed commission update announcement banner
     * @protobufOption (milestoneType) = BRAND
     */
    COMMISSION_PAYOUTS_NAM_UPDATE_ANNOUNCEMENT_DISMISSED = 'COMMISSION_PAYOUTS_NAM_UPDATE_ANNOUNCEMENT_DISMISSED',
    /**
     * Set when brand dismissed sku filter tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PRODUCT_SKU_FILTER_TOOLTIP_DISMISSED = 'BRAND_PRODUCT_SKU_FILTER_TOOLTIP_DISMISSED',
    /**
     * Set when brand receives introductory Top Shop comms after fulfilling their second order
     * @protobufOption (milestoneType) = BRAND
     */
    TOP_SHOP_INTRO_COMMS_SENT = 'TOP_SHOP_INTRO_COMMS_SENT',
    /**
     * Set when brand views the Top Shop page in the intermediate intro state
     * @protobufOption (milestoneType) = BRAND
     */
    TOP_SHOP_INTERMEDIATE_STATE_VIEWED = 'TOP_SHOP_INTERMEDIATE_STATE_VIEWED',
    /**
     * Milestone to determine whether a brand has agreed to our pricing policy
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_AGREED_TO_PRICING_PARITY_POLICY = 'BRAND_AGREED_TO_PRICING_PARITY_POLICY',
    /**
     * Set when the brand dismisses the new home page banner after top shop revamp
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DISMISSED_TOP_SHOP_BANNER_V2 = 'BRAND_DISMISSED_TOP_SHOP_BANNER_V2',
    /**
     * Set when brand has seen the new home page banner after top shop revamp
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_SEEN_TOP_SHOP_BANNER_V2 = 'BRAND_SEEN_TOP_SHOP_BANNER_V2',
    /**
     * Set when brand dismissed commission update pre-launch reminder banner
     * @protobufOption (milestoneType) = BRAND
     */
    COMMISSION_PAYOUTS_NAM_UPDATE_PRELAUNCH_REMINDER_BANNER_DISMISSED = 'COMMISSION_PAYOUTS_NAM_UPDATE_PRELAUNCH_REMINDER_BANNER_DISMISSED',
    /**
     * Set when brand dismisses the faire direct % discount restructure reminder banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FAIRE_DIRECT_PERCENTAGE_DISCOUNT_REMINDER_BANNER_DISMISSED = 'BRAND_FAIRE_DIRECT_PERCENTAGE_DISCOUNT_REMINDER_BANNER_DISMISSED',
    /**
     * Set when brand plays the intro reel introducing the new top shop
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PLAYED_TOP_SHOP_INTRO_REEL = 'BRAND_PLAYED_TOP_SHOP_INTRO_REEL',
    /**
     * Set when brand accepted 20230705 brand TOS
     * @protobufOption (milestoneType) = BRAND
     */
    COMMISSION_PAYOUTS_NAM_UPDATE_TOS_ACCEPTED = 'COMMISSION_PAYOUTS_NAM_UPDATE_TOS_ACCEPTED',
    /**
     * Set when brand dismisses 20230705 brand TOS modal during pre-launch,
     * across devices, after 3 dismisses, brand won't see modal again till launch
     * @protobufOption (milestoneType) = BRAND
     */
    COMMISSION_PAYOUTS_NAM_UPDATE_TOS_DISMISSED = 'COMMISSION_PAYOUTS_NAM_UPDATE_TOS_DISMISSED',
    /**
     * Show once after the first time brand goes to order details after commission change launches
     * @protobufOption (milestoneType) = BRAND
     */
    COMMISSION_PAYOUTS_NAM_UPDATE_ORDER_DETAILS_PAGE_FTU_BANNER_SEEN = 'COMMISSION_PAYOUTS_NAM_UPDATE_ORDER_DETAILS_PAGE_FTU_BANNER_SEEN',
    /**
     * Set when brand has seen the tax on services CAN announcement banner
     * @protobufOption (milestoneType) = BRAND
     */
    TAX_ON_SERVICES_CAN_ANNOUNCEMENT_BANNER_SEEN = 'TAX_ON_SERVICES_CAN_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * Set when brand has the listing quality pop-out with listing advice
     * @protobufOption (milestoneType) = BRAND
     */
    LISTING_QUALITY_EDUCATION_SIDE_SHEET_SEEN = 'LISTING_QUALITY_EDUCATION_SIDE_SHEET_SEEN',
    /**
     * Brand has dismissed banner prompting them about listing quality issues
     * @protobufOption (milestoneType) = BRAND
     */
    LISTING_QUALITY_BANNER_DISMISSED = 'LISTING_QUALITY_BANNER_DISMISSED',
    /**
     * Brand has seen banner prompting them about listing quality issues
     * @protobufOption (milestoneType) = BRAND
     */
    LISTING_QUALITY_BANNER_SEEN = 'LISTING_QUALITY_BANNER_SEEN',
    /**
     * Set when the brand has seen the samples list page for the first time
     * @protobufOption (milestoneType) = BRAND
     */
    SAMPLES_PAGE_VISITED = 'SAMPLES_PAGE_VISITED',
    /**
     * Milestone to determine whether a brand has dismissed the order minimum nudge
     * @protobufOption (milestoneType) = BRAND
     */
    ORDER_MINIMUM_NUDGE_DISMISSED = 'ORDER_MINIMUM_NUDGE_DISMISSED',
    /**
     * Set when the product image auto crop banner has been dismissed
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_IMAGE_AUTO_CROP_BANNER_DISMISSED = 'PRODUCT_IMAGE_AUTO_CROP_BANNER_DISMISSED',
    /**
     * Set when a marketing campaign's first-time only visible recently contacted exclusion filter tooltip has been dismissed
     * @protobufOption (milestoneType) = BRAND
     */
    EXCLUDE_RECENTLY_CONTACTED_TOOLTIP_DISMISSED = 'EXCLUDE_RECENTLY_CONTACTED_TOOLTIP_DISMISSED',
    /**
     * Set when the brand dismisses the filters update go to market tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    CRM_FILTER_UPDATE_GTM_DISMISSED = 'CRM_FILTER_UPDATE_GTM_DISMISSED',
    /**
     * Set when the brand dismisses the banner showing updates to introduce the percentage based Faire Direct Credit
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_CREDIT_UPDATE_07_01_2023_DISMISSED = 'FAIRE_DIRECT_CREDIT_UPDATE_07_01_2023_DISMISSED',
    /**
     * Set when brand has seen the Basic Information header tooltip for product variant-attribute project in Single Product Editor
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_VARIANT_ATTRIBUTE_ROLLOUT_BASIC_INFORMATION_TOOLTIP_SEEN = 'PRODUCT_VARIANT_ATTRIBUTE_ROLLOUT_BASIC_INFORMATION_TOOLTIP_SEEN',
    /**
     * Set when brand has seen the USPS Ground Advantage announcement banner
     * @protobufOption (milestoneType) = BRAND
     */
    USPS_GROUND_ADVANTAGE_ANNOUNCEMENT_BANNER_SEEN = 'USPS_GROUND_ADVANTAGE_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * Set when brand has dismissed the USPS Ground Advantage announcement banner
     * @protobufOption (milestoneType) = BRAND
     */
    USPS_GROUND_ADVANTAGE_ANNOUNCEMENT_BANNER_DISMISSED = 'USPS_GROUND_ADVANTAGE_ANNOUNCEMENT_BANNER_DISMISSED',
    /**
     * Set when the Product Option inventory management tooltip is dismissed
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_OPTION_INVENTORY_MANEMENT_IMPROVEMENT_TOOLTIP_DISMISSED = 'PRODUCT_OPTION_INVENTORY_MANEMENT_IMPROVEMENT_TOOLTIP_DISMISSED',
    /**
     * Set when a brand reverts all their auto cropped product images
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_IMAGE_AUTO_CROP_REVERT_ALL = 'PRODUCT_IMAGE_AUTO_CROP_REVERT_ALL',
    /**
     * Set when the product image review page has been seen
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_IMAGE_AUTO_CROP_REVIEW_PAGE_SEEN = 'PRODUCT_IMAGE_AUTO_CROP_REVIEW_PAGE_SEEN',
    /**
     * Set when a brand has clicked the Get Started button on Ads Manager onboarding page
     * @protobufOption (milestoneType) = BRAND
     */
    ADS_MANAGER_ONBOARDING_GET_STARTED_CLICKED = 'ADS_MANAGER_ONBOARDING_GET_STARTED_CLICKED',
    /**
     * Set when a brand has clicked the Get Started button on Ads Manager onboarding page
     * @protobufOption (milestoneType) = BRAND
     */
    SEGMENT_DROPDOWN_GTM_TOOLTIP_SEEN = 'SEGMENT_DROPDOWN_GTM_TOOLTIP_SEEN',
    /**
     * Set when a brand has clicked the Get Started button on Ads Manager onboarding page
     * @protobufOption (milestoneType) = BRAND
     */
    SEGMENT_SETTINGS_GTM_TOOLTIP_SEEN = 'SEGMENT_SETTINGS_GTM_TOOLTIP_SEEN',
    /**
     * Set when brand has seen the UPS HAZMAT banner
     * @protobufOption (milestoneType) = BRAND
     */
    UPS_HAZMAT_BANNER_SEEN = 'UPS_HAZMAT_BANNER_SEEN',
    /**
     * Set when brand dismisses the collection promo banner
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_BASED_COLLECTION_PROMO_ANNOUNCEMENT_BANNER_DISMISSED = 'PRODUCT_BASED_COLLECTION_PROMO_ANNOUNCEMENT_BANNER_DISMISSED',
    /**
     * Set when brand dismisses the add display promo banner
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_BASED_COLLECTION_ADD_DISPLAY_INCENTIVE_BANNER_DISMISSED = 'PRODUCT_BASED_COLLECTION_ADD_DISPLAY_INCENTIVE_BANNER_DISMISSED',
    /**
     * Set when brand dismisses the UPS HAZMAT banner
     * @protobufOption (milestoneType) = BRAND
     */
    UPS_HAZMAT_BANNER_DISMISSED = 'UPS_HAZMAT_BANNER_DISMISSED',
    /**
     * Set when brand dismisses the exclusivity banner on home page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    EXCLUSIVITY_BANNER_HOMEPAGE_DISMISSED = 'EXCLUSIVITY_BANNER_HOMEPAGE_DISMISSED',
    /**
     * Set when brand has seen the catalog completeness review information page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETENESS_REVIEW_INFO_PAGE_SEEN = 'CATALOG_COMPLETENESS_REVIEW_INFO_PAGE_SEEN',
    /**
     * Set when brand has seen the document upload section
     * @protobufOption (milestoneType) = BRAND
     */
    DOCUMENT_UPLOAD_SECTION_SEEN = 'DOCUMENT_UPLOAD_SECTION_SEEN',
    /**
     * Set when brand has an expired batch of auto crops
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_IMAGE_AUTO_CROP_BATCH_EXPIRED = 'PRODUCT_IMAGE_AUTO_CROP_BATCH_EXPIRED',
    /**
     * Set when brand has seen the tax on services EU announcement banner
     * @protobufOption (milestoneType) = BRAND
     */
    TAX_ON_SERVICES_EU_ANNOUNCEMENT_BANNER_SEEN = 'TAX_ON_SERVICES_EU_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * Set each time the campaign status change notice is dismissed; reset when a new status change is made.
     * @protobufOption (milestoneType) = BRAND
     */
    ADS_MANAGER_CAMPAIGN_STATUS_CHANGE_NOTICE_DISMISSED = 'ADS_MANAGER_CAMPAIGN_STATUS_CHANGE_NOTICE_DISMISSED',
    /**
     * Set when brand has seen the catalog completeness information for top shop beta program
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_COMPLETENESS_INFO_SEEN_TOP_SHOP_BETA = 'CATALOG_COMPLETENESS_INFO_SEEN_TOP_SHOP_BETA',
    /**
     * Set products page banner as dismissed for attribute GTM project.
     * @protobufOption (milestoneType) = BRAND
     */
    Q3_ATTRIBUTE_GTM_PRODUCTS_PAGE_BANNER_DISMISSED = 'Q3_ATTRIBUTE_GTM_PRODUCTS_PAGE_BANNER_DISMISSED',
    /**
     * Set homepage banner as dismissed for attribute GTM project.
     * @protobufOption (milestoneType) = BRAND
     */
    Q3_ATTRIBUTE_GTM_HOMEPAGE_BANNER_DISMISSED = 'Q3_ATTRIBUTE_GTM_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set category tooltip as dismissed for Q3 Attribute GTM project.
     * @protobufOption (milestoneType) = BRAND
     */
    Q3_ATTRIBUTE_GTM_CATEGORY_TOOLTIP_DISMISSED = 'Q3_ATTRIBUTE_GTM_CATEGORY_TOOLTIP_DISMISSED',
    /**
     * Set when the brand dismisses the Faire Direct Rewards program off-boarding banner on the home page
     * by clicking `x`
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_REWARDS_OFFBOARDING_HOMEPAGE_BANNER_DISMISSED = 'FAIRE_DIRECT_REWARDS_OFFBOARDING_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set when the brand dismisses the off-boarding banner on the Faire Direct Rewards page
     * by clicking `x`
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_REWARDS_LANDING_PAGE_OFFBOARDING_BANNER_DISMISSED = 'FAIRE_DIRECT_REWARDS_LANDING_PAGE_OFFBOARDING_BANNER_DISMISSED',
    /**
     * Set when the brand dismisses the banner showing updates to introduce the percentage based Faire Direct Credit for
     * brands that had fixed amount discount, or to update brands about the maximum value change and offer extension
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_CREDIT_UPDATE_10_01_2023_DISMISSED = 'FAIRE_DIRECT_CREDIT_UPDATE_10_01_2023_DISMISSED',
    /**
     * brands that had fixed amount discount, or to update brands about the maximum value change and offer extension
     * @protobufOption (milestoneType) = BRAND
     */
    SUBMIT_PRICING_CATALOG_HOMEPAGE_BANNER_DISMISSED = 'SUBMIT_PRICING_CATALOG_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Brand has dismissed undergoing repeat violation downrank banner
     * @protobufOption (milestoneType) = BRAND
     */
    UNDERGOING_REPEAT_VIOLATION_DOWNRANK_BANNER_DISMISSED = 'UNDERGOING_REPEAT_VIOLATION_DOWNRANK_BANNER_DISMISSED',
    /**
     * Brand has dismissed the FD Policy Update Announcement banner
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_NEW_POLICY_ANNOUNCEMENT_HOMEPAGE_BANNER_DISMISSED = 'FAIRE_DIRECT_NEW_POLICY_ANNOUNCEMENT_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Brand has dismissed the FD Policy Update Launch banner
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_DIRECT_NEW_POLICY_LAUNCH_HOMEPAGE_BANNER_DISMISSED = 'FAIRE_DIRECT_NEW_POLICY_LAUNCH_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Brand has dismissed the Ads Manager banner on homa page
     * @protobufOption (milestoneType) = BRAND
     */
    ADS_MANAGER_HOMEPAGE_BANNER_DISMISSED = 'ADS_MANAGER_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set when brand has submitted a zendesk ticket using the invalid sources request help modal
     * @protobufOption (milestoneType) = BRAND
     */
    CATALOG_CHECK_INVALID_SOURCES_REQUEST_HELP_MODAL_SUBMITTED = 'CATALOG_CHECK_INVALID_SOURCES_REQUEST_HELP_MODAL_SUBMITTED',
    /**
     * Set when a brand has dismissed the campaign performance & transparency GTM banner in campaigns list page
     * @protobufOption (milestoneType) = BRAND
     */
    CAMPAIGN_PERFORMANCE_TRANSPARENCY_GTM_BANNER_DISMISSED = 'CAMPAIGN_PERFORMANCE_TRANSPARENCY_GTM_BANNER_DISMISSED',
    /**
     * Set when a brand has completed setting up their shipping profile for the first time
     * @protobufOption (milestoneType) = BRAND
     */
    SHIPPING_PROFILE_FIRST_RUN_COMPLETED = 'SHIPPING_PROFILE_FIRST_RUN_COMPLETED',
    /**
     * Set when a brand has interacted with the shipping profile default zone
     * @protobufOption (milestoneType) = BRAND
     */
    SHIPPING_PROFILE_DEFAULT_ZONE_MODIFIED = 'SHIPPING_PROFILE_DEFAULT_ZONE_MODIFIED',
    /**
     * Set when brand dismisses the exclusivity GTM banner on home page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    EXCLUSIVITY_GTM_BANNER_HOMEPAGE_DISMISSED = 'EXCLUSIVITY_GTM_BANNER_HOMEPAGE_DISMISSED',
    /**
     * Set when brand dismisses the exclusivity introduction banner on home page
     * @protobufOption (milestoneType) = BRAND
     */
    EXCLUSIVITY_INTRODUCTION_HOMEPAGE_BANNER_DISMISSED = 'EXCLUSIVITY_INTRODUCTION_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Sets when brand have seen the install shopify nudge banner
     * @protobufOption (milestoneType) = BRAND
     */
    INSTALL_FAIRE_ON_SHOPIFY_NUDGE_BANNER_SEEN = 'INSTALL_FAIRE_ON_SHOPIFY_NUDGE_BANNER_SEEN',
    /**
     * Sets when brand have seen the new product tags nudge banner
     * @protobufOption (milestoneType) = BRAND
     */
    NEW_PRODUCT_TAGS_NUDGE_BANNER_SEEN = 'NEW_PRODUCT_TAGS_NUDGE_BANNER_SEEN',
    /**
     * Sets when brand have seen review listings nudge banner
     * @protobufOption (milestoneType) = BRAND
     */
    REVIEW_LISTING_UPDATES_NUDGE_BANNER_SEEN = 'REVIEW_LISTING_UPDATES_NUDGE_BANNER_SEEN',
    /**
     * Sets when brand have seen the pricing parity nudge banner
     * @protobufOption (milestoneType) = BRAND
     */
    REVIEW_PRICING_PARITY_NUDGE_BANNER_SEEN = 'REVIEW_PRICING_PARITY_NUDGE_BANNER_SEEN',
    /**
     * Set when brand has visited the product editor page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_VISITED_PRODUCT_EDITOR_PAGE = 'BRAND_HAS_VISITED_PRODUCT_EDITOR_PAGE',
    /**
     * Milestone to track when brand has clicked on the button to accept
     * the terms and conditions for guaranteed shipping
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_ACCEPTED_GUARANTEED_SHIPPING_TERMS_AND_CONDITIONS = 'HAS_ACCEPTED_GUARANTEED_SHIPPING_TERMS_AND_CONDITIONS',
    /**
     * Milestone to track when brand has clicked on the continue button
     * after seeing a warning about how faire's shipping estimates may be
     * inaccurate in the shipping settings page
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_CLICKED_CONTINUE_OR_CLOSE_ON_SHIPPING_ESTIMATE_MODAL = 'HAS_CLICKED_CONTINUE_OR_CLOSE_ON_SHIPPING_ESTIMATE_MODAL',
    /**
     * Milestone to track when brand has clicked on the skip button
     * after seeing a warning about how faire's shipping estimates may be
     * inaccurate in the shipping settings page
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_CLICKED_SKIP_SAVED_PACKAGE_CHECKLIST_ITEM = 'HAS_CLICKED_SKIP_SAVED_PACKAGE_CHECKLIST_ITEM',
    /**
     * Set when brand has seen the shop assistant introduction tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_SHOP_ASSISTANT_INTRODUCTION_TOOLTIP = 'BRAND_HAS_SEEN_SHOP_ASSISTANT_INTRODUCTION_TOOLTIP',
    /**
     * Set when brand has seen and clicked through the guaranteed shipping landing page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_GUARANTEED_SHIPPING_LANDING_PAGE = 'BRAND_HAS_SEEN_GUARANTEED_SHIPPING_LANDING_PAGE',
    /**
     * Increment when brand has dismissed the Interested Retailers Homepage Banner
     * @protobufOption (milestoneType) = BRAND
     */
    EXCLUSIVITY_INTERESTED_RETAILERS_HOMEPAGE_BANNER_DISMISSAL_COUNT = 'EXCLUSIVITY_INTERESTED_RETAILERS_HOMEPAGE_BANNER_DISMISSAL_COUNT',
    /**
     * Set when brand has disabled the Interested Retailers Homepage Banner
     * @protobufOption (milestoneType) = BRAND
     */
    EXCLUSIVITY_INTERESTED_RETAILERS_HOMEPAGE_BANNER_DISABLED = 'EXCLUSIVITY_INTERESTED_RETAILERS_HOMEPAGE_BANNER_DISABLED',
    /**
     * Set when we send the custom braze event after brand sets up their first guaranteed shipping zone
     * @protobufOption (milestoneType) = BRAND
     */
    SENT_BRAZE_EVENT_FOR_FIRST_GUARANTEED_SHIPPING_ZONE = 'SENT_BRAZE_EVENT_FOR_FIRST_GUARANTEED_SHIPPING_ZONE',
    /**
     * Set when a brand has dismissed the custom domain authentication required homepage banner
     * @protobufOption (milestoneType) = BRAND
     */
    DOMAIN_AUTHENTICATION_REQUIRED_HOMEPAGE_BANNER_DISMISSED = 'DOMAIN_AUTHENTICATION_REQUIRED_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set when brand has seen the shop assistant welcome to updates message"
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_SHOP_ASSISTANT_WELCOME_TO_UPDATES_MESSAGE = 'BRAND_HAS_SEEN_SHOP_ASSISTANT_WELCOME_TO_UPDATES_MESSAGE',
    /**
     * Set when brand has seen the education panel for content recommendations
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_EDUCATION_PANEL_FOR_CONTENT_RECOMMENDATIONS = 'BRAND_HAS_SEEN_EDUCATION_PANEL_FOR_CONTENT_RECOMMENDATIONS',
    /**
     * Set when brand has closed the banner to inform the new design tool to customize a Faire invite email
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_DISMISSED_NEW_WAY_TO_CUSTOMIZE_EMAIL_BANNER = 'HAS_DISMISSED_NEW_WAY_TO_CUSTOMIZE_EMAIL_BANNER',
    /**
     * Set when brand has seen the education panel for post publish content recommendations
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_EDUCATION_PANEL_FOR_POST_PUBLISH_CONTENT_RECOMMENDATIONS = 'BRAND_HAS_SEEN_EDUCATION_PANEL_FOR_POST_PUBLISH_CONTENT_RECOMMENDATIONS',
    /**
     * Set when a brand selected their based in country during sign up
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SET_BASED_IN_DURING_SIGN_UP = 'BRAND_HAS_SET_BASED_IN_DURING_SIGN_UP',
    /**
     * Set when brand has dismissed the first guaranteed shipping rate banner
     * @protobufOption (milestoneType) = BRAND
     */
    FIRST_GUARANTEED_SHIPPING_RATE_BANNER_DISMISSED = 'FIRST_GUARANTEED_SHIPPING_RATE_BANNER_DISMISSED',
    /**
     * Tracks when the brand has dismissed the exclusivity landing page banner for brand unenrolled from exclusivity
     * @protobufOption (milestoneType) = BRAND
     */
    EXCLUSIVITY_UNENROLLED_LANDING_PAGE_BANNER_DISMISSED = 'EXCLUSIVITY_UNENROLLED_LANDING_PAGE_BANNER_DISMISSED',
    /**
     * Tracks when the brand has viewed the exclusivity landing page banner for brand unenrolled from exclusivity
     * @protobufOption (milestoneType) = BRAND
     */
    EXCLUSIVITY_UNENROLLED_LANDING_PAGE_BANNER_VIEWED = 'EXCLUSIVITY_UNENROLLED_LANDING_PAGE_BANNER_VIEWED',
    /**
     * Set when a brand enrolled in NAM subsidy dismisses the banner on the Insider Partnerships Landing Page
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_PARTNERSHIP_AUTO_ENROLLED_BANNER_DISMISSED = 'INSIDER_PARTNERSHIP_AUTO_ENROLLED_BANNER_DISMISSED',
    /**
     * Set when a brand accepts the terms and conditions for the Insider Partnership program
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_PARTNERSHIP_TERMS_AND_CONDITIONS_ACCEPTED = 'INSIDER_PARTNERSHIP_TERMS_AND_CONDITIONS_ACCEPTED',
    /**
     * Set when a brand accepts the terms and conditions for the Insider Partnership program
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_PARTNERSHIP_HOMEPAGE_BANNER_DISMISSED = 'INSIDER_PARTNERSHIP_HOMEPAGE_BANNER_DISMISSED',
    /**
     * Set when brand has seen the introduction launch tooltip for the brand announcement system
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_ANNOUNCEMENT_SYSTEM_INTRODUCTION_TOOLTIP_SEEN = 'BRAND_ANNOUNCEMENT_SYSTEM_INTRODUCTION_TOOLTIP_SEEN',
    /**
     * FD-213418 Set when the brand has dismissed the brand app education banner on the homescreen.
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_APP_EDUCATION_HOMEPAGE_BANNER_DISMISSED = 'BRAND_APP_EDUCATION_HOMEPAGE_BANNER_DISMISSED',
    /**
     * FD-213418 Set when the brand has dismissed the brand app education banner on the updates sidebar.
     * @deprecated
     * @protobufOption (milestoneType) = USER
     */
    BRAND_APP_EDUCATION_SIDEBAR_BANNER_DISMISSED = 'BRAND_APP_EDUCATION_SIDEBAR_BANNER_DISMISSED',
    /**
     * FD-213418 Set when the brand has dismissed the app education banner on the orders page.
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_APP_EDUCATION_ORDERS_BANNER_DISMISSED = 'BRAND_APP_EDUCATION_ORDERS_BANNER_DISMISSED',
    /**
     * FD-213418 Set when the brand has dismissed the app education banner on the messenger page.
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_APP_EDUCATION_MESSENGER_BANNER_DISMISSED = 'BRAND_APP_EDUCATION_MESSENGER_BANNER_DISMISSED',
    /**
     * FD-213418 Set when the brand has dismissed the app education banner on the customers page.
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_APP_EDUCATION_CUSTOMERS_BANNER_DISMISSED = 'BRAND_APP_EDUCATION_CUSTOMERS_BANNER_DISMISSED',
    /**
     * FD-215276 Set when the brand has dismissed the insider side door for free shipping thresholds
     * @protobufOption (milestoneType) = BRAND
     */
    FREE_SHIPPING_THRESHOLD_INSIDER_SIDE_DOOR_DISMISSED = 'FREE_SHIPPING_THRESHOLD_INSIDER_SIDE_DOOR_DISMISSED',
    /**
     * Brand user clicked on a widget on the brand portal Faire Direct page
     * @deprecated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_FAIRE_DIRECT_WIDGET_TASK_CLICKED = 'BRAND_PORTAL_FAIRE_DIRECT_WIDGET_TASK_CLICKED',
    /**
     * Brand user clicked on the profile cta link on the brand portal Faire Direct page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_FAIRE_DIRECT_PROFILE_LINK_TASK_CLICKED = 'BRAND_PORTAL_FAIRE_DIRECT_PROFILE_LINK_TASK_CLICKED',
    /**
     * Brand user clicked on the email signature cta link on the brand portal Faire Direct page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_FAIRE_DIRECT_EMAIL_SIGNATURE_TASK_CLICKED = 'BRAND_PORTAL_FAIRE_DIRECT_EMAIL_SIGNATURE_TASK_CLICKED',
    /**
     * Brand user clicked on the marketing collateral cta link on the brand portal Faire Direct page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_FAIRE_DIRECT_MARKETING_COLLATERAL_TASK_CLICKED = 'BRAND_PORTAL_FAIRE_DIRECT_MARKETING_COLLATERAL_TASK_CLICKED',
    /**
     * Brand user clicked on the announcement cta link on the brand portal Faire Direct page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_FAIRE_DIRECT_ANNOUNCEMENT_TASK_CLICKED = 'BRAND_PORTAL_FAIRE_DIRECT_ANNOUNCEMENT_TASK_CLICKED',
    /**
     * Brand user clicked on the direct message cta link on the brand portal Faire Direct page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_FAIRE_DIRECT_DIRECT_MESSAGE_TASK_CLICKED = 'BRAND_PORTAL_FAIRE_DIRECT_DIRECT_MESSAGE_TASK_CLICKED',
    /**
     * Brand user clicked on the QR code cta link on the brand portal Faire Direct page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_FAIRE_DIRECT_QR_CODE_TASK_CLICKED = 'BRAND_PORTAL_FAIRE_DIRECT_QR_CODE_TASK_CLICKED',
    /**
     * Brand user clicked on the brand app cta link on the brand portal Faire Direct page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_FAIRE_DIRECT_BRAND_APP_TASK_CLICKED = 'BRAND_PORTAL_FAIRE_DIRECT_BRAND_APP_TASK_CLICKED',
    /**
     * Brand user dismissed the banner that is displayed in the single product editor when Shopify price sync is on
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_SINGLE_PRODUCT_EDITOR_SHOPIFY_PRICE_SYNC_ON_BANNER_DISMISSED = 'BRAND_PORTAL_SINGLE_PRODUCT_EDITOR_SHOPIFY_PRICE_SYNC_ON_BANNER_DISMISSED',
    /**
     * FD-213418 Set when the brand has dismissed the app education banner on the invoices page.
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_APP_EDUCATION_INVOICES_BANNER_DISMISSED = 'BRAND_APP_EDUCATION_INVOICES_BANNER_DISMISSED',
    /**
     * Brand user has signed up for our carrier calculated shipping waitlist
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_SIGNED_UP_FOR_CARRIER_CALCULATED_SHIPPING_WAITLIST = 'BRAND_SIGNED_UP_FOR_CARRIER_CALCULATED_SHIPPING_WAITLIST',
    /**
     * Brand user dismissed the carrier calculated shipping waitlist banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_CLOSED_CARRIER_CALCULATED_SHIPPING_WAITLIST_BANNER = 'BRAND_CLOSED_CARRIER_CALCULATED_SHIPPING_WAITLIST_BANNER',
    /**
     * Brand user dismissed the add team member banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DISMISSED_ADD_TEAM_MEMBER_BANNER = 'BRAND_DISMISSED_ADD_TEAM_MEMBER_BANNER',
    /**
     * Brand has visited brand portal after activating their store
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_VISITED_POST_ACTIVATION_BRAND_PORTAL = 'BRAND_HAS_VISITED_POST_ACTIVATION_BRAND_PORTAL',
    /**
     * Brand has seen SWF Pickup tag for features enabled by setting ENABLE_CARRIER_PICKUPS_NAM_EXPERIMENT_240612,
     * in Brand Order Fulfillment - Additional services, for NAM brands
     * @protobufOption (milestoneType) = BRAND
     */
    SWF_PICKUP_NAM_TAG_SEEN = 'SWF_PICKUP_NAM_TAG_SEEN',
    /**
     * Brand user has dismissed the banner for updated (active/inactive) email delivery metrics
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_INACTIVE_RECIPIENT_BANNER = 'BRAND_PORTAL_INACTIVE_RECIPIENT_BANNER',
    /**
     * Brand has visited brand activation portal welcome page after activating their store
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_VISITED_BRAND_ACTIVATION_PORTAL_WELCOME = 'BRAND_HAS_VISITED_BRAND_ACTIVATION_PORTAL_WELCOME',
    /**
     * Set when the brand dismisses the FD Widget banner on top shop page *
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_TOP_SHOP_PAGE_FAIRE_DIRECT_WIDGET_BANNER_DISMISSED = 'BRAND_TOP_SHOP_PAGE_FAIRE_DIRECT_WIDGET_BANNER_DISMISSED',
    /**
     * Set when the brand has seen the first order celebration modal *
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_FIRST_ORDER_MODAL = 'BRAND_HAS_SEEN_FIRST_ORDER_MODAL',
    /**
     * Set when the brand views the Featured in New Arrivals celebration modal *
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_FEATURED_IN_NEW_ARRIVALS_CELEBRATION_MODAL = 'BRAND_HAS_SEEN_FEATURED_IN_NEW_ARRIVALS_CELEBRATION_MODAL',
    /**
     * Brand has seen the products page full catalog education panel
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_ADD_FULL_CATALOG_EDUCATION_PANEL = 'BRAND_HAS_SEEN_ADD_FULL_CATALOG_EDUCATION_PANEL',
    /**
     * Brand has seen the description listing quality education panel
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_WRITE_DETAILED_DESCRIPTION_EDUCATION_PANEL = 'BRAND_HAS_SEEN_WRITE_DETAILED_DESCRIPTION_EDUCATION_PANEL',
    /**
     * Brand has seen the image listing quality education panel
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_ADD_CLEAR_IMAGES_EDUCATION_PANEL = 'BRAND_HAS_SEEN_ADD_CLEAR_IMAGES_EDUCATION_PANEL',
    /**
     * No. of times brand user has seen the banner for updated (active/inactive) email delivery metrics
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PORTAL_INACTIVE_RECIPIENT_BANNER_SEEN_COUNT = 'BRAND_PORTAL_INACTIVE_RECIPIENT_BANNER_SEEN_COUNT',
    /**
     * Brand dismissed the add team member banner in Product's page
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_PRODUCT_ADD_TEAM_MEMBER_BANNER_DISMISSED = 'BRAND_PRODUCT_ADD_TEAM_MEMBER_BANNER_DISMISSED',
    /**
     * Brand dismissed the custom exclusivity area size banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_CUSTOM_EXCLUSIVITY_AREA_SIZE_BANNER_DISMISSED = 'BRAND_CUSTOM_EXCLUSIVITY_AREA_SIZE_BANNER_DISMISSED',
    /**
     * Brand has invited a team member to their account
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_INVITED_TEAM_MEMBER = 'BRAND_INVITED_TEAM_MEMBER',
    /**
     * Brand has seen the Top Shop celebration banner
     * @protobufOption (milestoneType) = BRAND
     */
    TOP_SHOP_CELEBRATION_SEEN_TIMES = 'TOP_SHOP_CELEBRATION_SEEN_TIMES',
    /**
     * Brand has dismissed the Faire For Teams GTM modal
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FAIRE_FOR_TEAMS_GTM_MODAL_DISMISSED = 'BRAND_FAIRE_FOR_TEAMS_GTM_MODAL_DISMISSED',
    /**
     * Brand has seen the Faire For Teams GTM modal
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_FAIRE_FOR_TEAMS_GTM_MODAL_SEEN = 'BRAND_FAIRE_FOR_TEAMS_GTM_MODAL_SEEN',
    /**
     * Brand has dismissed the listing quality image issues banner
     * @protobufOption (milestoneType) = BRAND
     */
    LISTING_QUALITY_IMAGE_ISSUES_BANNER_DISMISSED = 'LISTING_QUALITY_IMAGE_ISSUES_BANNER_DISMISSED',
    /**
     * Brand has seen the description recommendation feedback modal
     * @protobufOption (milestoneType) = BRAND
     */
    HAS_SEEN_DESCRIPTION_RECOMMENDATION_FEEDBACK_MODAL = 'HAS_SEEN_DESCRIPTION_RECOMMENDATION_FEEDBACK_MODAL',
    /**
     * Brand user has seen the Faire For Teams page for the first time
     * @protobufOption (milestoneType) = USER
     */
    HAS_SEEN_FAIRE_FOR_TEAMS_PAGE = 'HAS_SEEN_FAIRE_FOR_TEAMS_PAGE',
    /**
     * Brand user has updated their Faire Direct link
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_EDITED_FAIRE_DIRECT_TOKEN_ALIAS = 'BRAND_HAS_EDITED_FAIRE_DIRECT_TOKEN_ALIAS',
    /**
     * Brand user has viewed the pop-up for completing the F35D lifecycle FD adoption incentive
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_FAIRE_DIRECT_ADOPTION_INCENTIVE_ACTIVATED_MODAL = 'BRAND_HAS_SEEN_FAIRE_DIRECT_ADOPTION_INCENTIVE_ACTIVATED_MODAL',
    /**
     * Brand user has viewed the new bulk upload page banner
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_BULK_UPLOAD_UPDATE_BANNER = 'BRAND_HAS_SEEN_BULK_UPLOAD_UPDATE_BANNER',
    /**
     * Brand user has seen the unlocked ad credits modal
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_UNLOCKED_AD_CREDITS_MODAL = 'BRAND_HAS_SEEN_UNLOCKED_AD_CREDITS_MODAL',
    /**
     * Brand user has seen the Other Files tab in the bulk upload page when a new requisition is created or status
     * is updated
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_NEW_OR_UPDATED_CATALOG_UPDATE_REQUISITION = 'BRAND_HAS_NEW_OR_UPDATED_CATALOG_UPDATE_REQUISITION',
    /**
     * Brand user has dismissed Insider expansion announcement banner in the Insider Partnership page
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_EXPANSION_ANNOUNCEMENT_BANNER_DISMISSED = 'INSIDER_EXPANSION_ANNOUNCEMENT_BANNER_DISMISSED',
    /**
     * Brand user has dismissed the Faire For Teams banner in Marketing page
     * @protobufOption (milestoneType) = BRAND
     */
    FAIRE_FOR_TEAMS_MARKETING_BANNER_DISMISSED = 'FAIRE_FOR_TEAMS_MARKETING_BANNER_DISMISSED',
    /**
     * Number of times the user has dismissed the contextual entrypoint banner on the performance page.
     * @protobufOption (milestoneType) = USER
     */
    CONTEXTUAL_ENTRYPOINT_PRODUCT_PERFORMANCE_PAGE_BANNER_DISMISSED = 'CONTEXTUAL_ENTRYPOINT_PRODUCT_PERFORMANCE_PAGE_BANNER_DISMISSED',
    /**
     * Brand user has seen the Decagon AI chatbot tooltip
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN = 'BRAND_DECAGON_AI_CHATBOT_TOOLTIP_SEEN',
    /**
     * Number of times the user has dismissed the contextual entrypoint banner on the performance page.
     * @protobufOption (milestoneType) = USER
     */
    CONTEXTUAL_ENTRYPOINT_PROMOTIONS_PAGE_BANNER_DISMISSED = 'CONTEXTUAL_ENTRYPOINT_PROMOTIONS_PAGE_BANNER_DISMISSED',
    /**
     * Number of times the user has dismissed the CRM recommendation contextual entrypoint.
     * @protobufOption (milestoneType) = USER
     */
    CONTEXTUAL_ENTRYPOINT_CRM_RECOMMENDATIONS_DISMISSED = 'CONTEXTUAL_ENTRYPOINT_CRM_RECOMMENDATIONS_DISMISSED',
    /**
     * Brand user has dismissed the request a review nudge in messenger
     * @protobufOption (milestoneType) = USER
     */
    BRAND_REQUEST_A_REVIEW_NUDGE_IN_MESSENGER_DISMISSED = 'BRAND_REQUEST_A_REVIEW_NUDGE_IN_MESSENGER_DISMISSED',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    FIRST_INSIDER_MP_ORDERS_INTERSTITIAL_SEEN = 'FIRST_INSIDER_MP_ORDERS_INTERSTITIAL_SEEN',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    FIRST_INSIDER_FD_ORDER_INTERSTITIAL_SEEN = 'FIRST_INSIDER_FD_ORDER_INTERSTITIAL_SEEN',
    /**
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_PARTNERSHIP_DEFAULT_ENROLL_TERMS_ACCEPTED = 'INSIDER_PARTNERSHIP_DEFAULT_ENROLL_TERMS_ACCEPTED',
    /**
     * Tracks the number of views to the how it works banner on the Insider Partnership  dashboard
     * @protobufOption (milestoneType) = BRAND
     */
    INSIDER_PARTNERSHIP_HOW_IT_WORKS_BANNER_SEEN = 'INSIDER_PARTNERSHIP_HOW_IT_WORKS_BANNER_SEEN',
    /**
     * Brand has dismissed the Single Product Editor explainer for LMM-based taxonomy prediction.
     * @protobufOption (milestoneType) = BRAND
     */
    PRODUCT_TAXONOMY_PREDICTION_BANNER_SEEN = 'PRODUCT_TAXONOMY_PREDICTION_BANNER_SEEN',
    /**
     * Brand has seen the title recommendation feedback modal
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_HAS_SEEN_TITLE_RECOMMENDATION_FEEDBACK_MODAL = 'BRAND_HAS_SEEN_TITLE_RECOMMENDATION_FEEDBACK_MODAL',
    /**
     * Tracks whether the brand has seen the announcement banner for the retailer review request feature
     * @protobufOption (milestoneType) = BRAND
     */
    BRAND_TO_RETAILER_REVIEW_REQUEST_ANNOUNCEMENT_BANNER_SEEN = 'BRAND_TO_RETAILER_REVIEW_REQUEST_ANNOUNCEMENT_BANNER_SEEN',
    /**
     * In order to handle unique indexes correctly, we need MySQL to store an actual value for nulls
     * @deprecated
     * @protobufOption (milestoneType) = USER
     */
    NO_BRAND_MILESTONE = 'NO_BRAND_MILESTONE',
  }

  /**
   * Return an instance of IUserMilestone with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IUserMilestone>): IUserMilestone =>
    ({
      ...(partial ?? {}),
    } as IUserMilestone);
}

export interface IUserMilestone {
  /**
   * A milestone that has not been set will be shown as having count=0, createdAt=null
   */
  count: number | undefined;
  updated_at: number | undefined;
  created_at: number | undefined;
  retailer_milestone: keyof typeof IUserMilestone.RetailerMilestone | undefined;
  brand_milestone: keyof typeof IUserMilestone.BrandMilestone | undefined;
  /**
   * This named milestone allows old mobile clients to set new milestones
   * using the SDUI framework. The apps will get the milestone name from the
   * RecordMilestoneAction proto. The server will convert that to the appropriate
   * enum.
   */
  retailer_milestone_name: string | undefined;
  /**
   * This named milestone allows old mobile clients to set new milestones using the BE-Driven Messaging Components
   * framework. The apps will get the milestone name from the UiMessagingContainer proto. The server will convert that
   * to the appropriate enum.
   */
  brand_milestone_name: string | undefined;
}
